import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import "./Admin.css";
import {
  Button,
  Icon,
  Modal,
  TransitionablePortal,
  Form,
  Dropdown,
  Confirm,
  Popup,
  Progress,
  Input,
} from "semantic-ui-react";
import AthleteDetails from "../components/athletes/AthleteDetails";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import * as yup from "yup";
import {
  updateAthlete,
  resetAthlete,
  deleteAthlete,
  updateAthleteEvents,
} from "../store/actions/athleteActions";
import { Loader } from "semantic-ui-react";
import "../components/layout/Spinner.css";
import "doka/doka.css";
import {
  createDefaultImageReader,
  createDefaultImageWriter,
  setPlugins,
  plugin_crop,
  locale_en_gb,
  plugin_crop_locale_en_gb,
  plugin_finetune_locale_en_gb,
  plugin_annotate_locale_en_gb,
  blobToFile,
} from "doka";
import heic2any from "heic2any";
import { DokaImageEditor } from "react-doka";
import ReactPlayer from "react-player";
import { actionTypes } from "redux-firestore";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImgsViewer from "react-images-viewer";
import Dropzone from "react-dropzone";
import AddNewSport, { AddNewSportIcon } from "../components/layout/AddNewSport";
import SportList from "../components/athletes/SportList";
import PositionList from "../components/athletes/PositionList";
import AddNewPosition, {
  AddNewPositionIcon,
} from "../components/layout/AddNewPosition";
import AddNewSeo from "./AddNewSeo";
import { heicRegex } from "../utils/regex";
import AdvocateDetails from "../components/athletes/AdvocateDetails";
import { isFileImage, openURL } from "../utils/utils";
import Dummy from "../images/001.png";
import StatsPhotos from "../components/layout/StatsPhotos/StatsPhotos";
import PublicModal from "../components/layout/Reminders/PublicModal";
import ContactInfo from "../components/athletes/ContactInfo/ContactInfo";
setPlugins(plugin_crop);

const classOptions = [
  { key: 1, text: "2014", value: 2014 },
  { key: 2, text: "2015", value: 2015 },
  { key: 3, text: "2016", value: 2016 },
  { key: 4, text: "2017", value: 2017 },
  { key: 5, text: "2018", value: 2018 },
  { key: 6, text: "2019", value: 2019 },
  { key: 7, text: "2020", value: 2020 },
  { key: 8, text: "2021", value: 2021 },
  { key: 9, text: "2022", value: 2022 },
  { key: 10, text: "2023", value: 2023 },
  { key: 11, text: "2024", value: 2024 },
  { key: 12, text: "2025", value: 2025 },
  { key: 13, text: "2026", value: 2026 },
  { key: 14, text: "2027", value: 2027 },
  { key: 15, text: "2028", value: 2028 },
  { key: 16, text: "2029", value: 2029 },
  { key: 17, text: "2030", value: 2030 },
  { key: 18, text: "College Transfer", value: "college_transfer" },
];

const committedOptions = [
  { key: 1, text: "Committed", value: "Committed" },
  { key: 2, text: "Uncommitted", value: "Uncommitted" },
];

const footballPositionOptions = [
  { key: 1, text: "Defensive Back", value: "Defensive Back" },
  { key: 2, text: "Defensive Line", value: "Defensive Line" },
  { key: 3, text: "Kicker", value: "Kicker" },
  { key: 4, text: "Linebacker", value: "Linebacker" },
  { key: 5, text: "Long Snapper", value: "Long Snapper" },
  { key: 6, text: "Offensive Line", value: "Offensive Line" },
  { key: 7, text: "Quarterback", value: "Quarterback" },
  { key: 8, text: "Receiver", value: "Receiver" },
  { key: 9, text: "Running Back", value: "Running Back" },
  { key: 10, text: "Tight End", value: "Tight End" },
];

const batsOptions = [
  { key: 1, text: "Right", value: "Right" },
  { key: 2, text: "Left", value: "Left" },
  { key: 3, text: "Slapper", value: "Slapper" },
];
const throwsOptions = [
  { key: 1, text: "Right", value: "Right" },
  { key: 2, text: "Left", value: "Left" },
];

let initialFirstName = null;
let initialLastName = null;
let initialHometown = null;
let initialClass = null;
let initialSport = null;
let initialCommitted = null;
let initialPrimaryPosition = null;
let initialSecondaryPosition = null;
let initialBats = null;
let initialThrows = null;
let initialSpecialtyMetrics = null;
let initialParentOneFirstName = null;
let initialParentTwoFirstName = null;
let initialParentOneLastName = null;
let initialParentTwoLastName = null;
let initialClubName = null;
let initialClubTeamName = null;
let initialJersey = null;
let initialHeight = null;
let initialWeight = null;
let initialNcaaId = null;
let initialGpa = null;
let initialAct = null;
let initialSat = null;
let initialClassRank = null;
let initialHighSchoolName = null;
let initialHighSchoolCityState = null;
let initialIntendedMajor = null;
let initialClubCoachName = null;
let initialClubCoachPhone = null;
let initialClubCoachEmail = null;
let initialHighSchoolCoachName = null;
let initialHighSchoolCoachPhone = null;
let initialHighSchoolCoachEmail = null;
let initialHittingCoachName = null;
let initialHittingCoachPhone = null;
let initialHittingCoachEmail = null;
let initialPitchingCoachName = null;
let initialPitchingCoachPhone = null;
let initialPitchingCoachEmail = null;

let initialCatchingCoachName = null;
let initialCatchingCoachPhone = null;
let initialCatchingCoachEmail = null;

let initialSpecialtyCoachName = null;
let initialSpecialtyCoachFocus = null;
let initialSpecialtyCoachPhone = null;
let initialSpecialtyCoachEmail = null;

let initialTwitter = null;
let initialAgl = null;
let initialFacebook = null;
let initialHudl = null;
let initialInstagram = null;
let initialYouTube = null;

let initialAcademicHonorOne = null;
let initialAcademicHonorTwo = null;
let initialAcademicHonorThree = null;
let initialAcademicHonorFour = null;
let initialAcademicHonorFive = null;
let initialAcademicHonorSix = null;
let initialAcademicHonorSeven = null;
let initialAcademicHonorEight = null;
let initialAcademicHonorNine = null;
let initialAcademicHonorTen = null;

let initialAthleticAwardOne = null;
let initialAthleticAwardTwo = null;
let initialAthleticAwardThree = null;
let initialAthleticAwardFour = null;
let initialAthleticAwardFive = null;
let initialAthleticAwardSix = null;
let initialAthleticAwardSeven = null;
let initialAthleticAwardEight = null;
let initialAthleticAwardNine = null;
let initialAthleticAwardTen = null;

let initialAthleticStrengthOne = null;
let initialAthleticStrengthTwo = null;
let initialAthleticStrengthThree = null;
let initialAthleticStrengthFour = null;
let initialAthleticStrengthFive = null;

let initialAthleticExtraOne = null;
let initialAthleticExtraTwo = null;
let initialAthleticExtraThree = null;
let initialAthleticExtraFour = null;
let initialAthleticExtraFive = null;

let initialAthleticHobbyOne = null;
let initialAthleticHobbyTwo = null;
let initialAthleticHobbyThree = null;
let initialAthleticHobbyFour = null;
let initialAthleticHobbyFive = null;

let initialEventOneName = null;
let initialEventOneUrl = null;
let initialEventOneDate = null;
let initialEventTwoName = null;
let initialEventTwoUrl = null;
let initialEventTwoDate = null;
let initialEventThreeName = null;
let initialEventThreeUrl = null;
let initialEventThreeDate = null;
let initialEventFourName = null;
let initialEventFourUrl = null;
let initialEventFourDate = null;
let initialEventFiveName = null;
let initialEventFiveUrl = null;
let initialEventFiveDate = null;
let initialEventSixName = null;
let initialEventSixUrl = null;
let initialEventSixDate = null;
let initialAthleteCalendar = null;

let initialVideoOneTitle = null;
let initialVideoTwoTitle = null;
let initialVideoThreeTitle = null;
let initialVideoFourTitle = null;

let initialSchool = null;

let count = 0;
let progressLabel = null;

const schema = yup.object().shape({
  weight: yup
    .number()
    .positive()
    .integer()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  ncaaId: yup
    .number()
    .positive()
    .integer()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  gpa: yup
    .number()
    .positive()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  act: yup
    .number()
    .positive()
    .integer()
    .min(1)
    .max(36)
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  sat: yup
    .number()
    .positive()
    .integer()
    .min(1)
    .max(1600)
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  phone: yup
    .number()
    .positive()
    .integer()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ),
  url: yup.string().url().nullable(),
});

const adminReduxCoachList = "adminCoachList";
const adminReduxSocialList = "adminSocialList";
const adminReduxAwardsList = "adminAwardsList";
const adminReduxExtrasList = "adminExtrasList";
const adminReduxImagesList = "adminImagesList";
const adminReduxVideoList = "adminVideoList";
const adminReduxEventsList = "adminEventsList";
const adminReduxSchoolsList = "adminSchoolsList";
const adminReduxSportsList = "adminSportsList";
const adminReduxSchoolsIdList = "adminSchoolsIdList";

const initialState = {
  remindersModal: false,
  oldData: {},
  croppedImageTranscriptBlob: null,
  croppedImageTranscriptBlobUrl: null,
  seoPopup: false,
  videoOneTitle: null,
  videoOneTitleChanged: null,
  videoTwoTitle: null,
  videoTwoTitleChanged: null,
  videoThreeTitle: null,
  videoThreeTitleChanged: null,
  videoFourTitle: null,
  videoFourTitleChanged: null,
  newSportName: null,
  showNewSportField: false,
  showNewPositionField: false,
  propsLoadedToState: false,
  customUrl: null,
  athleteTriedToUpdate: false,
  manageEvents: false,
  editProfileOpen: false,
  cropImageOpen: false,
  cropImageOneOpen: false,
  showHighSchoolScheduleOne: false,
  showHighSchoolScheduleTwo: false,
  showHighSchoolScheduleThree: false,
  showHighSchoolScheduleFour: false,
  showHighSchoolScheduleFive: false,
  cropImageTwoOpen: false,
  cropImageThreeOpen: false,
  cropImageFourOpen: false,
  cropImageFiveOpen: false,
  cropImageTranscriptOpen: false,
  cropImageSatOpen: false,
  cropImageActOpen: false,
  imageCropped: false,
  cropSource: null,
  confirmOpen: false,
  changesMade: false,
  formError: false,
  thumbnail: "",
  thumbnailChanged: false,
  firstName: "",
  firstNameChanged: false,
  lastName: "",
  lastNameChanged: false,
  hometown: "",
  hometownChanged: false,
  newThumbnailImage: null,
  newThumbnailImageUrl: null,
  newThumbnailImageUpdated: false,
  class: "",
  classChanged: false,
  sport: "",
  sportChanged: false,
  committed: false,
  committedValue: "Uncommitted",
  committedChanged: false,
  primaryPosition: "",
  primaryPositionFilter: "",
  primaryPositionChanged: false,
  secondaryPosition: "",
  secondaryPositionChanged: false,
  bats: "",
  batsChanged: false,
  throws: "",
  throwsChanged: false,
  specialtyMetrics: "",
  specialtyMetricsChanged: false,
  parentOneFirstName: "",
  parentOneFirstNameChanged: false,
  parentTwoFirstName: "",
  parentTwoFirstNameChanged: false,
  parentOneLastName: "",
  parentOneLastNameChanged: false,
  parentTwoLastName: "",
  parentTwoLastNameChanged: false,
  clubName: "",
  clubNameChanged: false,
  clubTeamName: "",
  clubTeamNameChanged: false,
  jersey: "",
  jerseyChanged: false,
  height: "",
  heightChanged: false,
  weight: "",
  weightChanged: false,
  weightError: false,
  ncaaId: "",
  ncaaIdChanged: false,
  ncaaIdError: false,
  gpa: "",
  gpaChanged: false,
  gpaError: false,
  act: "",
  actChanged: false,
  actError: false,
  sat: "",
  satChanged: false,
  satError: false,
  classRank: "",
  classRankChanged: false,
  highSchoolName: "",
  highSchoolNameChanged: false,
  highSchoolCityState: "",
  highSchoolCityStateChanged: false,
  intendedMajor: "",
  intendedMajorChanged: false,
  clubCoachName: "",
  clubCoachNameChanged: false,
  clubCoachPhone: "",
  clubCoachPhoneChanged: false,
  clubCoachPhoneError: false,
  clubCoachEmail: "",
  clubCoachEmailChanged: false,
  highSchoolCoachName: "",
  highSchoolCoachNameChanged: false,
  highSchoolCoachPhone: "",
  highSchoolCoachPhoneChanged: false,
  highSchoolCoachPhoneError: false,
  highSchoolCoachEmail: "",
  highSchoolCoachEmailChanged: false,
  hittingCoachName: "",
  hittingCoachNameChanged: false,
  hittingCoachPhone: "",
  hittingCoachPhoneChanged: false,
  hittingCoachPhoneError: false,
  hittingCoachEmail: "",
  hittingCoachEmailChanged: false,
  pitchingCoachName: "",
  pitchingCoachNameChanged: false,
  pitchingCoachPhone: "",
  pitchingCoachPhoneChanged: false,
  pitchingCoachPhoneError: false,
  pitchingCoachEmail: "",
  pitchingCoachEmailChanged: false,
  catchingCoachName: "",
  catchingCoachNameChanged: false,
  catchingCoachPhone: "",
  catchingCoachPhoneChanged: false,
  catchingCoachPhoneError: false,
  catchingCoachEmail: "",
  catchingCoachEmailChanged: false,
  specialtyCoachName: "",
  specialtyCoachNameChanged: false,
  specialtyCoachFocus: "",
  specialtyCoachFocusChanged: false,
  specialtyCoachPhone: "",
  specialtyCoachPhoneChanged: false,
  specialtyCoachPhoneError: false,
  specialtyCoachEmail: "",
  specialtyCoachEmailChanged: false,
  twitter: "",
  twitterChanged: false,
  twitterError: false,
  agl: "",
  aglChanged: false,
  facebook: "",
  facebookChanged: false,
  facebookError: false,
  hudl: "",
  hudlChanged: false,
  hudlError: false,
  instagram: "",
  instagramChanged: false,
  instagramError: false,
  youTube: "",
  youTubeChanged: false,
  youTubeError: false,
  academicHonorOne: "",
  academicHonorOneChanged: false,
  academicHonorTwo: "",
  academicHonorTwoChanged: false,
  academicHonorThree: "",
  academicHonorThreeChanged: false,
  academicHonorFour: "",
  academicHonorFourChanged: false,
  academicHonorFive: "",
  academicHonorFiveChanged: false,
  academicHonorSix: "",
  academicHonorSixChanged: false,
  academicHonorSeven: "",
  academicHonorSevenChanged: false,
  academicHonorEight: "",
  academicHonorEightChanged: false,
  academicHonorNine: "",
  academicHonorNineChanged: false,
  academicHonorTen: "",
  academicHonorTenChanged: false,
  athleticAwardOne: "",
  athleticAwardOneChanged: false,
  athleticAwardTwo: "",
  athleticAwardTwoChanged: false,
  athleticAwardThree: "",
  athleticAwardThreeChanged: false,
  athleticAwardFour: "",
  athleticAwardFourChanged: false,
  athleticAwardFive: "",
  athleticAwardFiveChanged: false,
  athleticAwardSix: "",
  athleticAwardSixChanged: false,
  athleticAwardSeven: "",
  athleticAwardSevenChanged: false,
  athleticAwardEight: "",
  athleticAwardEightChanged: false,
  athleticAwardNine: "",
  athleticAwardNineChanged: false,
  athleticAwardTen: "",
  athleticAwardTenChanged: false,
  athleticStrengthOne: "",
  athleticStrengthOneChanged: false,
  athleticStrengthTwo: "",
  athleticStrengthTwoChanged: false,
  athleticStrengthThree: "",
  athleticStrengthThreeChanged: false,
  athleticStrengthFour: "",
  athleticStrengthFourChanged: false,
  athleticStrengthFive: "",
  athleticStrengthFiveChanged: false,
  athleticExtraOne: "",
  athleticExtraOneChanged: false,
  athleticExtraTwo: "",
  athleticExtraTwoChanged: false,
  athleticExtraThree: "",
  athleticExtraThreeChanged: false,
  athleticExtraFour: "",
  athleticExtraFourChanged: false,
  athleticExtraFive: "",
  athleticExtraFiveChanged: false,
  athleticHobbyOne: "",
  athleticHobbyOneChanged: false,
  athleticHobbyTwo: "",
  athleticHobbyTwoChanged: false,
  athleticHobbyThree: "",
  athleticHobbyThreeChanged: false,
  athleticHobbyFour: "",
  athleticHobbyFourChanged: false,
  athleticHobbyFive: "",
  athleticHobbyFiveChanged: false,

  eventOneError: false,
  eventTwoError: false,
  eventThreeError: false,
  eventFourError: false,
  eventFiveError: false,
  eventSixError: false,

  eventOneName: "",
  eventOneNameChanged: false,
  eventTwoName: "",
  eventTwoNameChanged: false,
  eventThreeName: "",
  eventThreeNameChanged: false,
  eventFourName: "",
  eventFourNameChanged: false,
  eventFiveName: "",
  eventFiveNameChanged: false,
  eventSixName: "",
  eventSixNameChanged: false,
  eventSevenName: "",
  eventSevenNameChanged: false,
  eventEightName: "",
  eventEightNameChanged: false,
  eventNineName: "",
  eventNineNameChanged: false,
  eventTenName: "",
  eventTenNameChanged: false,
  eventElevenName: "",
  eventElevenNameChanged: false,
  eventTwelveName: "",
  eventTwelveNameChanged: false,

  eventOneUrl: "",
  eventOneUrlChanged: false,
  eventTwoUrl: "",
  eventTwoUrlChanged: false,
  eventThreeUrl: "",
  eventThreeUrlChanged: false,
  eventFourUrl: "",
  eventFourUrlChanged: false,
  eventFiveUrl: "",
  eventFiveUrlChanged: false,
  eventSixUrl: "",
  eventSixUrlChanged: false,
  eventSevenUrl: "",
  eventSevenUrlChanged: false,
  eventEightUrl: "",
  eventEightUrlChanged: false,
  eventNineUrl: "",
  eventNineUrlChanged: false,
  eventTenUrl: "",
  eventTenUrlChanged: false,
  eventElevenUrl: "",
  eventElevenUrlChanged: false,
  eventTwelveUrl: "",
  eventTwelveUrlChanged: false,

  eventOneDate: null,
  eventOneDateChanged: false,
  eventTwoDate: null,
  eventTwoDateChanged: false,
  eventThreeDate: null,
  eventThreeDateChanged: false,
  eventFourDate: null,
  eventFourDateChanged: false,
  eventFiveDate: null,
  eventFiveDateChanged: false,
  eventSixDate: null,
  eventSixDateChanged: false,
  eventSevenDate: null,
  eventSevenDateChanged: false,
  eventEightDate: null,
  eventEightDateChanged: false,
  eventNineDate: null,
  eventNineDateChanged: false,
  eventTenDate: null,
  eventTenDateChanged: false,
  eventElevenDate: null,
  eventElevenDateChanged: false,
  eventTwelveDate: null,
  eventTwelveDateChanged: false,

  imageOne: "",
  imageOneChanged: false,
  newImageOne: null,
  newImageOneUrl: null,
  newImageOneUpdated: false,
  imageHighSchoolOneShow: null,

  imageTwo: "",
  imageTwoChanged: false,
  newImageTwo: null,
  newImageTwoUrl: null,
  newImageTwoUpdated: false,

  imageThree: "",
  imageThreeChanged: false,
  newImageThree: null,
  newImageThreeUrl: null,
  newImageThreeUpdated: false,

  imageFour: "",
  imageFourChanged: false,
  newImageFour: null,
  newImageFourUrl: null,
  newImageFourUpdated: false,

  imageFive: "",
  imageFiveChanged: false,
  newImageFive: null,
  newImageFiveUrl: null,
  newImageFiveUpdated: false,

  // Highschool Schedule

  imageHighSchoolOne: "",
  imageHighSchoolOneChanged: false,
  newImageHighSchoolOne: null,
  newImageHighSchoolOneUrl: null,

  imageHighSchoolTwo: "",
  imageHighSchoolTwoChanged: false,
  newImageHighSchoolTwo: null,
  newImageHighSchoolTwoUrl: null,

  imageHighSchoolThree: "",
  imageHighSchoolThreeChanged: false,
  newImageHighSchoolThree: null,
  newImageHighSchoolThreeUrl: null,
  newImageHighSchoolThreeUpdated: false,

  imageHighSchoolFour: "",
  imageHighSchoolFourChanged: false,
  newImageHighSchoolFour: null,
  newImageHighSchoolFourUrl: null,
  newImageHighSchoolFourUpdated: false,

  imageHighSchoolFive: "",
  imageHighSchoolFiveChanged: false,
  newImageHighSchoolFive: null,
  newImageHighSchoolFiveUrl: null,
  newImageHighSchoolFiveUpdated: false,

  videoOne: "",
  videoOneChanged: false,
  newVideoOne: null,
  newVideoOneUrl: null,

  videoTwo: "",
  videoTwoChanged: false,
  newVideoTwo: null,
  newVideoTwoUrl: null,

  videoThree: "",
  videoThreeChanged: false,
  newVideoThree: null,
  newVideoThreeUrl: null,

  videoFour: "",
  videoFourChanged: false,
  newVideoFour: null,
  newVideoFourUrl: null,

  cropImageVideoOneOpen: false,
  dropzoneVideoOne: null,
  dropzoneVideoOneUrl: null,
  dropzoneVideoOneLink: "",
  videoOneLink: null,

  cropImageVideoTwoOpen: false,
  dropzoneVideoTwo: null,
  dropzoneVideoTwoUrl: null,
  dropzoneVideoTwoLink: "",
  videoTwoLink: null,

  cropImageVideoThreeOpen: false,
  dropzoneVideoThree: null,
  dropzoneVideoThreeUrl: null,
  dropzoneVideoThreeLink: "",
  videoThreeLink: null,

  cropImageVideoFourOpen: false,
  dropzoneVideoFour: null,
  dropzoneVideoFourUrl: null,
  dropzoneVideoFourLink: "",
  videoFourLink: null,

  cropImageVideoNewOpen: false,
  dropzoneVideoNew: null,
  dropzoneVideoNewUrl: null,
  dropzoneVideoNewLink: "",

  confirmDelete: false,
  deleteRedirect: false,
  deletingAthlete: false,

  transcriptImage: "",
  transcriptImageChanged: false,
  newTranscriptImage: null,
  newTranscriptImageUrl: null,
  newTranscriptImageUpdated: false,

  satScoreImage: "",
  satScoreImageChanged: false,
  newSatScoreImage: null,
  newSatScoreImageUrl: null,
  newSatScoreImageUpdated: false,

  actScoreImage: "",
  actScoreImageChanged: false,
  newActScoreImage: null,
  newActScoreImageUrl: null,
  newActScoreImageUpdated: false,

  athleteCalendar: "",
  athleteCalendarChanged: false,

  committedSchool: "",
  committedSchoolChanged: false,
  committedSchoolId: "",
};
const editorConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 500,
      height: 500,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageOneConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 600,
      height: 400,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1.5,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageTwoConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 600,
      height: 400,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1.5,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageThreeConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 600,
      height: 400,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1.5,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageFourConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 600,
      height: 400,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1.5,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageFiveConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 600,
      height: 400,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 1.5,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageTranscriptConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 1000,
      height: undefined,
      fit: "contain",
      upscale: false,
    },
  }),
  imageCropAspectRatio: undefined,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

const editorImageSatConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 500,
      height: 500,
      upscale: true,
    },
  }),
  imageCropAspectRatio: undefined,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};
const editorImageActConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 500,
      height: 500,
      upscale: true,
    },
  }),
  imageCropAspectRatio: undefined,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;

    count = 0;

    this.onDropVideoOne = (file) => {
      this.setState({
        dropzoneVideoOne: file[0],
        dropzoneVideoOneUrl: URL.createObjectURL(file[0]),
      });
    };
    this.onDropVideoTwo = (file) => {
      this.setState({
        dropzoneVideoTwo: file[0],
        dropzoneVideoTwoUrl: URL.createObjectURL(file[0]),
      });
    };
    this.onDropVideoThree = (file) => {
      this.setState({
        dropzoneVideoThree: file[0],
        dropzoneVideoThreeUrl: URL.createObjectURL(file[0]),
      });
    };
    this.onDropVideoFour = (file) => {
      this.setState({
        dropzoneVideoFour: file[0],
        dropzoneVideoFourUrl: URL.createObjectURL(file[0]),
      });
    };
    this.onDropVideoNew = (file) => {
      this.setState({
        dropzoneVideoNew: file[0],
        dropzoneVideoNewUrl: URL.createObjectURL(file[0]),
      });
    };
  }

  static getDerivedStateFromProps(props, state) {
    let committedText = null;
    let weightValue = "";
    let ncaaIdValue = "";
    let gpaValue = "";
    let actValue = "";
    let satValue = "";

    let catchingCoachNameValue = "";
    let catchingCoachPhoneValue = "";
    let catchingCoachEmailValue = "";

    let specialtyCoachNameValue = "";
    let specialtyCoachFocusValue = "";
    let specialtyCoachPhoneValue = "";
    let specialtyCoachEmailValue = "";

    let athleteCalendarValue = "";

    let athleteSchoolIdValue = "";
    let athleteSchoolValue = "";

    let eventOneNameValue = "";
    let eventOneUrlValue = "";
    let eventTwoNameValue = "";
    let eventTwoUrlValue = "";
    let eventThreeNameValue = "";
    let eventThreeUrlValue = "";
    let eventFourNameValue = "";
    let eventFourUrlValue = "";
    let eventFiveNameValue = "";
    let eventFiveUrlValue = "";
    let eventSixNameValue = "";
    let eventSixUrlValue = "";

    if (
      props.athlete &&
      props.adminCoachList &&
      props.adminSocialList &&
      props.adminAwardsList &&
      props.adminExtrasList &&
      props.adminImagesList &&
      props.adminVideoList &&
      props.adminSchoolsList &&
      props.adminSchoolsIdList
    ) {
      count = count + 1;
      if (count === 1) {
        if (props.athlete.committed) {
          committedText = "Committed";
        } else {
          committedText = "Uncommitted";
        }
        if (props.athlete.weight > 0) {
          weightValue = props.athlete.weight;
        }
        if (props.athlete.ncaaId > 0) {
          ncaaIdValue = props.athlete.ncaaId;
        }
        if (props.athlete.gpa > 0) {
          gpaValue = props.athlete.gpa;
        }
        if (props.athlete.act > 0) {
          actValue = props.athlete.act;
        }
        if (props.athlete.sat > 0) {
          satValue = props.athlete.sat;
        }
        if (props.adminCoachList.catchingCoachName) {
          catchingCoachNameValue = props.adminCoachList.catchingCoachName;
        }
        if (props.adminCoachList.catchingCoachPhone) {
          catchingCoachPhoneValue = props.adminCoachList.catchingCoachPhone;
        }
        if (props.adminCoachList.catchingCoachEmail) {
          catchingCoachEmailValue = props.adminCoachList.catchingCoachEmail;
        }
        if (props.adminCoachList.specialtyCoachName) {
          specialtyCoachNameValue = props.adminCoachList.specialtyCoachName;
        }
        if (props.adminCoachList.specialtyCoachFocus) {
          specialtyCoachFocusValue = props.adminCoachList.specialtyCoachFocus;
        }
        if (props.adminCoachList.specialtyCoachPhone) {
          specialtyCoachPhoneValue = props.adminCoachList.specialtyCoachPhone;
        }
        if (props.adminCoachList.specialtyCoachEmail) {
          specialtyCoachEmailValue = props.adminCoachList.specialtyCoachEmail;
        }
        if (props.adminSocialList.calendar) {
          athleteCalendarValue = props.adminSocialList.calendar;
        }

        if (props.adminEventsList) {
          if (props.adminEventsList.eventOneName) {
            initialEventOneName = props.adminEventsList.eventOneName;
            eventOneNameValue = props.adminEventsList.eventOneName;
          }
          if (props.adminEventsList.eventOneUrl) {
            initialEventOneUrl = props.adminEventsList.eventOneUrl;
            eventOneUrlValue = props.adminEventsList.eventOneUrl;
          }
          if (
            props.adminEventsList.eventOneDate &&
            props.adminEventsList.eventOneDate !== null
          ) {
            initialEventOneDate = props.adminEventsList.eventOneDate.toDate();
          } else {
            initialEventOneDate = null;
          }

          if (props.adminEventsList.eventTwoName) {
            initialEventTwoName = props.adminEventsList.eventTwoName;
            eventTwoNameValue = props.adminEventsList.eventTwoName;
          }
          if (props.adminEventsList.eventTwoUrl) {
            initialEventTwoUrl = props.adminEventsList.eventTwoUrl;
            eventTwoUrlValue = props.adminEventsList.eventTwoUrl;
          }
          if (
            props.adminEventsList.eventTwoDate &&
            props.adminEventsList.eventTwoDate !== null
          ) {
            initialEventTwoDate = props.adminEventsList.eventTwoDate.toDate();
          } else {
            initialEventTwoDate = null;
          }

          if (props.adminEventsList.eventThreeName) {
            initialEventThreeName = props.adminEventsList.eventThreeName;
            eventThreeNameValue = props.adminEventsList.eventThreeName;
          }
          if (props.adminEventsList.eventThreeUrl) {
            initialEventThreeUrl = props.adminEventsList.eventThreeUrl;
            eventThreeUrlValue = props.adminEventsList.eventThreeUrl;
          }
          if (
            props.adminEventsList.eventThreeDate &&
            props.adminEventsList.eventThreeDate !== null
          ) {
            initialEventThreeDate =
              props.adminEventsList.eventThreeDate.toDate();
          } else {
            initialEventThreeDate = null;
          }

          if (props.adminEventsList.eventFourName) {
            initialEventFourName = props.adminEventsList.eventFourName;
            eventFourNameValue = props.adminEventsList.eventFourName;
          }
          if (props.adminEventsList.eventFourUrl) {
            initialEventFourUrl = props.adminEventsList.eventFourUrl;
            eventFourUrlValue = props.adminEventsList.eventFourUrl;
          }
          if (
            props.adminEventsList.eventFourDate &&
            props.adminEventsList.eventFourDate !== null
          ) {
            initialEventFourDate = props.adminEventsList.eventFourDate.toDate();
          } else {
            initialEventFourDate = null;
          }

          if (props.adminEventsList.eventFiveName) {
            initialEventFiveName = props.adminEventsList.eventFiveName;
            eventFiveNameValue = props.adminEventsList.eventFiveName;
          }
          if (props.adminEventsList.eventFiveUrl) {
            initialEventFiveUrl = props.adminEventsList.eventFiveUrl;
            eventFiveUrlValue = props.adminEventsList.eventFiveUrl;
          }
          if (
            props.adminEventsList.eventFiveDate &&
            props.adminEventsList.eventFiveDate !== null
          ) {
            initialEventFiveDate = props.adminEventsList.eventFiveDate.toDate();
          } else {
            initialEventFiveDate = null;
          }

          if (props.adminEventsList.eventSixName) {
            initialEventSixName = props.adminEventsList.eventSixName;
            eventSixNameValue = props.adminEventsList.eventSixName;
          }
          if (props.adminEventsList.eventSixUrl) {
            initialEventSixUrl = props.adminEventsList.eventSixUrl;
            eventSixUrlValue = props.adminEventsList.eventSixUrl;
          }
          if (
            props.adminEventsList.eventSixDate &&
            props.adminEventsList.eventSixDate !== null
          ) {
            initialEventSixDate = props.adminEventsList.eventSixDate.toDate();
          } else {
            initialEventSixDate = null;
          }
        }

        if (
          props.athlete.committedSchoolId &&
          props.athlete.committedSchoolId !== "" &&
          props.athlete.committedSchoolId !== null
        ) {
          const schoolId = props.athlete.committedSchoolId;
          athleteSchoolIdValue = schoolId;
          athleteSchoolValue = props.adminSchoolsIdList[schoolId].name;
          initialSchool = athleteSchoolValue;
        }

        return {
          oldData: {
            ...props.athlete,
            ...props.adminCoachList,
            ...props.adminSocialList,
            ...props.adminAwardsList,
            ...props.adminExtrasList,
            ...props.adminImagesList,
            ...props.adminVideoList,
          },
          customUrl: props.athlete.customUrl,
          firstName: props.athlete.firstName,
          lastName: props.athlete.lastName,
          hometown: props.athlete.hometown,
          thumbnail: props.athlete.thumbnail,
          class: props.athlete.class,
          sport: props.athlete.sport,
          committed: props.athlete.committed,
          committedValue: committedText,
          primaryPosition: props.athlete.primaryPosition,
          primaryPositionFilter: props.athlete.primaryPositionFilter,
          secondaryPosition: props.athlete.secondaryPosition,
          bats: props.athlete.bats,
          throws: props.athlete.throws,
          parentOneFirstName: props.athlete.parentOneFirstName,
          parentTwoFirstName: props.athlete.parentTwoFirstName,
          parentOneLastName: props.athlete.parentOneLastName,
          parentTwoLastName: props.athlete.parentTwoLastName,
          specialtyMetrics: props.athlete.specialtyMetrics,
          clubName: props.athlete.clubName,
          clubTeamName: props.athlete.clubTeamName,
          jersey: props.athlete.jersey,
          height: props.athlete.height,
          weight: weightValue,
          ncaaId: ncaaIdValue,
          gpa: gpaValue,
          act: actValue,
          sat: satValue,
          classRank: props.athlete.classRank,
          highSchoolName: props.athlete.highSchoolName,
          highSchoolCityState: props.athlete.highSchoolCityState,
          intendedMajor: props.athlete.intendedMajor,
          clubCoachName: props.adminCoachList.clubCoachName,
          clubCoachPhone: props.adminCoachList.clubCoachPhone,
          clubCoachEmail: props.adminCoachList.clubCoachEmail,
          highSchoolCoachName: props.adminCoachList.highSchoolCoachName,
          highSchoolCoachPhone: props.adminCoachList.highSchoolCoachPhone,
          highSchoolCoachEmail: props.adminCoachList.highSchoolCoachEmail,
          hittingCoachName: props.adminCoachList.hittingCoachName,
          hittingCoachPhone: props.adminCoachList.hittingCoachPhone,
          hittingCoachEmail: props.adminCoachList.hittingCoachEmail,
          pitchingCoachName: props.adminCoachList.pitchingCoachName,
          pitchingCoachPhone: props.adminCoachList.pitchingCoachPhone,
          pitchingCoachEmail: props.adminCoachList.pitchingCoachEmail,

          catchingCoachName: catchingCoachNameValue,
          catchingCoachPhone: catchingCoachPhoneValue,
          catchingCoachEmail: catchingCoachEmailValue,

          specialtyCoachName: specialtyCoachNameValue,
          specialtyCoachFocus: specialtyCoachFocusValue,
          specialtyCoachPhone: specialtyCoachPhoneValue,
          specialtyCoachEmail: specialtyCoachEmailValue,

          twitter: props.adminSocialList.twitter,
          agl: props.adminSocialList.agl,
          facebook: props.adminSocialList.facebook,
          hudl: props.adminSocialList.hudl,
          instagram: props.adminSocialList.instagram,
          youTube: props.adminSocialList.youTube,
          academicHonorOne: props.adminAwardsList.academicHonorOne,
          academicHonorTwo: props.adminAwardsList.academicHonorTwo,
          academicHonorThree: props.adminAwardsList.academicHonorThree,
          academicHonorFour: props.adminAwardsList.academicHonorFour,
          academicHonorFive: props.adminAwardsList.academicHonorFive,
          academicHonorSix: props.adminAwardsList.academicHonorSix,
          academicHonorSeven: props.adminAwardsList.academicHonorSeven,
          academicHonorEight: props.adminAwardsList.academicHonorEight,
          academicHonorNine: props.adminAwardsList.academicHonorNine,
          academicHonorTen: props.adminAwardsList.academicHonorTen,

          athleticAwardOne: props.adminAwardsList.athleticAwardOne,
          athleticAwardTwo: props.adminAwardsList.athleticAwardTwo,
          athleticAwardThree: props.adminAwardsList.athleticAwardThree,
          athleticAwardFour: props.adminAwardsList.athleticAwardFour,
          athleticAwardFive: props.adminAwardsList.athleticAwardFive,
          athleticAwardSix: props.adminAwardsList.athleticAwardSix,
          athleticAwardSeven: props.adminAwardsList.athleticAwardSeven,
          athleticAwardEight: props.adminAwardsList.athleticAwardEight,
          athleticAwardNine: props.adminAwardsList.athleticAwardNine,
          athleticAwardTen: props.adminAwardsList.athleticAwardTen,

          athleticStrengthOne: props.adminExtrasList.strengthOne,
          athleticStrengthTwo: props.adminExtrasList.strengthTwo,
          athleticStrengthThree: props.adminExtrasList.strengthThree,
          athleticStrengthFour: props.adminExtrasList.strengthFour,
          athleticStrengthFive: props.adminExtrasList.strengthFive,

          athleticExtraOne: props.adminExtrasList.extraOne,
          athleticExtraTwo: props.adminExtrasList.extraTwo,
          athleticExtraThree: props.adminExtrasList.extraThree,
          athleticExtraFour: props.adminExtrasList.extraFour,
          athleticExtraFive: props.adminExtrasList.extraFive,

          athleticHobbyOne: props.adminExtrasList.hobbyOne,
          athleticHobbyTwo: props.adminExtrasList.hobbyTwo,
          athleticHobbyThree: props.adminExtrasList.hobbyThree,
          athleticHobbyFour: props.adminExtrasList.hobbyFour,
          athleticHobbyFive: props.adminExtrasList.hobbyFive,

          imageOne: props.adminImagesList.imageOne,
          imageTwo: props.adminImagesList.imageTwo,
          imageThree: props.adminImagesList.imageThree,
          imageFour: props.adminImagesList.imageFour,
          imageFive: props.adminImagesList.imageFive,

          imageHighSchoolOne: props.adminImagesList.imageHighSchoolOne,
          imageHighSchoolTwo: props.adminImagesList.imageHighSchoolTwo,
          imageHighSchoolThree: props.adminImagesList.imageHighSchoolThree,
          imageHighSchoolFour: props.adminImagesList.imageHighSchoolFour,
          imageHighSchoolFive: props.adminImagesList.imageHighSchoolFive,

          videoOne: props.adminVideoList.videoOne,
          videoOneTitle: props.adminVideoList.videoOneTitle,
          videoTwo: props.adminVideoList.videoTwo,
          videoTwoTitle: props.adminVideoList.videoTwoTitle,
          videoThree: props.adminVideoList.videoThree,
          videoThreeTitle: props.adminVideoList.videoThreeTitle,
          videoFour: props.adminVideoList.videoFour,
          videoFourTitle: props.adminVideoList.videoFourTitle,

          propsLoadedToState: true,

          transcriptImage: props.adminImagesList.transcriptImage,
          satScoreImage: props.adminImagesList.satScoreImage,
          actScoreImage: props.adminImagesList.actScoreImage,

          athleteCalendar: athleteCalendarValue,

          eventOneName: eventOneNameValue,
          eventOneUrl: eventOneUrlValue,
          eventOneDate: initialEventOneDate,
          eventTwoName: eventTwoNameValue,
          eventTwoUrl: eventTwoUrlValue,
          eventTwoDate: initialEventTwoDate,
          eventThreeName: eventThreeNameValue,
          eventThreeUrl: eventThreeUrlValue,
          eventThreeDate: initialEventThreeDate,
          eventFourName: eventFourNameValue,
          eventFourUrl: eventFourUrlValue,
          eventFourDate: initialEventFourDate,
          eventFiveName: eventFiveNameValue,
          eventFiveUrl: eventFiveUrlValue,
          eventFiveDate: initialEventFiveDate,
          eventSixName: eventSixNameValue,
          eventSixUrl: eventSixUrlValue,
          eventSixDate: initialEventSixDate,
          committedSchool: athleteSchoolValue,
          committedSchoolId: athleteSchoolIdValue,
        };
      } else {
        return null;
      }
    }
    return null;
  }
  componentWillUnmount() {
    count = 0;

    this.props.clearData();
    this.props.resetAthlete();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.adminEventsList !== this.props.adminEventsList) {
      if (this.props.adminEventsList) {
        let eventOneNameUpdate = "";
        let eventOneUrlUpdate = "";
        let eventTwoNameUpdate = "";
        let eventTwoUrlUpdate = "";
        let eventThreeNameUpdate = "";
        let eventThreeUrlUpdate = "";
        let eventFourNameUpdate = "";
        let eventFourUrlUpdate = "";
        let eventFiveNameUpdate = "";
        let eventFiveUrlUpdate = "";
        let eventSixNameUpdate = "";
        let eventSixUrlUpdate = "";

        if (this.props.adminEventsList.eventOneName) {
          eventOneNameUpdate = this.props.adminEventsList.eventOneName;
        }
        if (this.props.adminEventsList.eventOneUrl) {
          eventOneUrlUpdate = this.props.adminEventsList.eventOneUrl;
        }

        if (this.props.adminEventsList.eventTwoName) {
          eventTwoNameUpdate = this.props.adminEventsList.eventTwoName;
        }
        if (this.props.adminEventsList.eventTwoUrl) {
          eventTwoUrlUpdate = this.props.adminEventsList.eventTwoUrl;
        }

        if (this.props.adminEventsList.eventThreeName) {
          eventThreeNameUpdate = this.props.adminEventsList.eventThreeName;
        }
        if (this.props.adminEventsList.eventThreeUrl) {
          eventThreeUrlUpdate = this.props.adminEventsList.eventThreeUrl;
        }

        if (this.props.adminEventsList.eventFourName) {
          eventFourNameUpdate = this.props.adminEventsList.eventFourName;
        }
        if (this.props.adminEventsList.eventFourUrl) {
          eventFourUrlUpdate = this.props.adminEventsList.eventFourUrl;
        }

        if (this.props.adminEventsList.eventFiveName) {
          eventFiveNameUpdate = this.props.adminEventsList.eventFiveName;
        }
        if (this.props.adminEventsList.eventFiveUrl) {
          eventFiveUrlUpdate = this.props.adminEventsList.eventFiveUrl;
        }

        if (this.props.adminEventsList.eventSixName) {
          eventSixNameUpdate = this.props.adminEventsList.eventSixName;
        }
        if (this.props.adminEventsList.eventSixUrl) {
          eventSixUrlUpdate = this.props.adminEventsList.eventSixUrl;
        }

        this.setState(
          {
            eventOneName: eventOneNameUpdate,
            eventOneUrl: eventOneUrlUpdate,
            eventTwoName: eventTwoNameUpdate,
            eventTwoUrl: eventTwoUrlUpdate,
            eventThreeName: eventThreeNameUpdate,
            eventThreeUrl: eventThreeUrlUpdate,
            eventFourName: eventFourNameUpdate,
            eventFourUrl: eventFourUrlUpdate,
            eventFiveName: eventFiveNameUpdate,
            eventFiveUrl: eventFiveUrlUpdate,
            eventSixName: eventSixNameUpdate,
            eventSixUrl: eventSixUrlUpdate,
          },
          () => {
            if (
              this.props.adminEventsList.eventOneDate &&
              this.props.adminEventsList.eventOneDate !== null
            ) {
              this.setState({
                eventOneDate: this.props.adminEventsList.eventOneDate.toDate(),
              });
            } else {
              this.setState({
                eventOneDate: null,
              });
            }
            if (
              this.props.adminEventsList.eventTwoDate &&
              this.props.adminEventsList.eventTwoDate !== null
            ) {
              this.setState({
                eventTwoDate: this.props.adminEventsList.eventTwoDate.toDate(),
              });
            } else {
              this.setState({
                eventTwoDate: null,
              });
            }
            if (
              this.props.adminEventsList.eventThreeDate &&
              this.props.adminEventsList.eventThreeDate !== null
            ) {
              this.setState({
                eventThreeDate:
                  this.props.adminEventsList.eventThreeDate.toDate(),
              });
            } else {
              this.setState({
                eventThreeDate: null,
              });
            }
            if (
              this.props.adminEventsList.eventFourDate &&
              this.props.adminEventsList.eventFourDate !== null
            ) {
              this.setState({
                eventFourDate:
                  this.props.adminEventsList.eventFourDate.toDate(),
              });
            } else {
              this.setState({
                eventFourDate: null,
              });
            }
            if (
              this.props.adminEventsList.eventFiveDate &&
              this.props.adminEventsList.eventFiveDate !== null
            ) {
              this.setState({
                eventFiveDate:
                  this.props.adminEventsList.eventFiveDate.toDate(),
              });
            } else {
              this.setState({
                eventFiveDate: null,
              });
            }
            if (
              this.props.adminEventsList.eventSixDate &&
              this.props.adminEventsList.eventSixDate !== null
            ) {
              this.setState({
                eventSixDate: this.props.adminEventsList.eventSixDate.toDate(),
              });
            } else {
              this.setState({
                eventSixDate: null,
              });
            }
          }
        );
      }
    }
  }

  handleDropdownChange = (e, data) => {
    if (data.name === "schoolDropdown") {
      const { value } = data;
      const { key } = data.options.find((o) => o.value === value);

      this.setState({
        committedSchool: value,
        committedSchoolId: key,
      });

      if (value !== initialSchool) {
        this.setState(
          {
            committedSchoolChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            committedSchoolChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }

    if (data.name === "classDropdown") {
      this.setState({
        class: data.value,
      });
      if (data.value !== initialClass) {
        this.setState(
          {
            classChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            classChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "sportDropdown") {
      this.setState({
        sport: data.value,
      });
      if (data.value !== initialSport) {
        this.setState(
          {
            sportChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            sportChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "committedDropdown") {
      if (data.value === "Committed") {
        this.setState(
          {
            committed: true,
            committedValue: "Committed",
          },
          () => {
            if (this.state.committed !== initialCommitted) {
              this.setState(
                {
                  committedChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  committedChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          }
        );
      } else {
        this.setState(
          {
            committed: false,
            committedValue: "Uncommitted",
          },
          () => {
            if (this.state.committed !== initialCommitted) {
              this.setState(
                {
                  committedChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  committedChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          }
        );
      }
    }
    if (data.name === "primaryPositionDropdown") {
      this.setState({
        primaryPosition: data.value,
      });
      if (data.value !== initialPrimaryPosition) {
        this.setState(
          {
            primaryPositionChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            primaryPositionChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "secondaryPositionDropdown") {
      this.setState({
        secondaryPosition: data.value,
      });
      if (data.value !== initialSecondaryPosition) {
        this.setState(
          {
            secondaryPositionChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            secondaryPositionChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "batsDropdown") {
      this.setState({
        bats: data.value,
      });
      if (data.value !== initialBats) {
        this.setState(
          {
            batsChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            batsChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
    if (data.name === "throwsDropdown") {
      this.setState({
        throws: data.value,
      });
      if (data.value !== initialThrows) {
        this.setState(
          {
            throwsChanged: true,
          },
          () => {
            this.trackChanges();
          }
        );
      } else {
        this.setState(
          {
            throwsChanged: false,
          },
          () => {
            this.trackChanges();
          }
        );
      }
    }
  };

  trackErrors = () => {
    if (
      this.state.weightError ||
      this.state.ncaaIdError ||
      this.state.gpaError ||
      this.state.actError ||
      this.state.satError ||
      this.state.clubCoachPhoneError ||
      this.state.highSchoolCoachPhoneError ||
      this.state.hittingCoachPhoneError ||
      this.state.pitchingCoachPhoneError ||
      this.state.twitterError ||
      this.state.aglError ||
      this.state.facebookError ||
      this.state.hudlError ||
      this.state.instagramError ||
      this.state.youTubeError ||
      this.state.catchingCoachPhoneError ||
      this.state.specialtyCoachPhoneError ||
      this.state.eventOneError ||
      this.state.eventTwoError ||
      this.state.eventThreeError ||
      this.state.eventFourError ||
      this.state.eventFiveError ||
      this.state.eventSixError
    ) {
      this.setState({
        formError: true,
      });
    } else {
      this.setState({
        formError: false,
      });
    }
  };
  // To Show and Hide Add  New Sport And Position Modal
  handleShowNewSportFieldOpen = () => {
    this.setState({
      showNewSportField: !this.state.showNewSportField,
    });
  };
  handleShowNewPositionFieldOpen = () => {
    this.setState({
      showNewPositionField: !this.state.showNewPositionField,
    });
  };
  getNewSportInputValue = (e) => {
    this.setState({ newSportName: e.target.value });
  };
  newSportSubmit = () => {
    this.setState({
      showNewSportField: false,
    });
  };

  checkEventsError = () => {
    if (this.state.eventOneUrl !== null && this.state.eventOneUrl !== "") {
      if (
        this.state.eventOneName !== "" &&
        this.state.eventOneName !== null &&
        this.state.eventOneDate !== null &&
        this.state.eventOneDate !== ""
      ) {
        this.setState(
          {
            eventOneError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventOneError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (this.state.eventOneName !== null && this.state.eventOneName !== "") {
        if (
          this.state.eventOneDate !== null &&
          this.state.eventOneDate !== ""
        ) {
          this.setState(
            {
              eventOneError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventOneError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (this.state.eventOneDate !== null && this.state.eventOneDate !== "") {
        if (
          this.state.eventOneName !== null &&
          this.state.eventOneName !== ""
        ) {
          this.setState(
            {
              eventOneError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventOneError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventOneDate === null || this.state.eventOneDate === "") &&
        (this.state.eventOneName === null || this.state.eventOneName === "")
      ) {
        this.setState(
          {
            eventOneError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }

    if (this.state.eventTwoUrl !== null && this.state.eventTwoUrl !== "") {
      if (
        this.state.eventTwoName !== "" &&
        this.state.eventTwoName !== null &&
        this.state.eventTwoDate !== null &&
        this.state.eventTwoDate !== ""
      ) {
        this.setState(
          {
            eventTwoError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventTwoError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (this.state.eventTwoName !== null && this.state.eventTwoName !== "") {
        if (
          this.state.eventTwoDate !== null &&
          this.state.eventTwoDate !== ""
        ) {
          this.setState(
            {
              eventTwoError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventTwoError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (this.state.eventTwoDate !== null && this.state.eventTwoDate !== "") {
        if (
          this.state.eventTwoName !== null &&
          this.state.eventTwoName !== ""
        ) {
          this.setState(
            {
              eventTwoError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventTwoError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventTwoDate === null || this.state.eventTwoDate === "") &&
        (this.state.eventTwoName === null || this.state.eventTwoName === "")
      ) {
        this.setState(
          {
            eventTwoError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }

    if (this.state.eventThreeUrl !== null && this.state.eventThreeUrl !== "") {
      if (
        this.state.eventThreeName !== "" &&
        this.state.eventThreeName !== null &&
        this.state.eventThreeDate !== null &&
        this.state.eventThreeDate !== ""
      ) {
        this.setState(
          {
            eventThreeError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventThreeError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (
        this.state.eventThreeName !== null &&
        this.state.eventThreeName !== ""
      ) {
        if (
          this.state.eventThreeDate !== null &&
          this.state.eventThreeDate !== ""
        ) {
          this.setState(
            {
              eventThreeError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventThreeError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        this.state.eventThreeDate !== null &&
        this.state.eventThreeDate !== ""
      ) {
        if (
          this.state.eventThreeName !== null &&
          this.state.eventThreeName !== ""
        ) {
          this.setState(
            {
              eventThreeError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventThreeError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventThreeDate === null ||
          this.state.eventThreeDate === "") &&
        (this.state.eventThreeName === null || this.state.eventThreeName === "")
      ) {
        this.setState(
          {
            eventThreeError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }

    if (this.state.eventFourUrl !== null && this.state.eventFourUrl !== "") {
      if (
        this.state.eventFourName !== "" &&
        this.state.eventFourName !== null &&
        this.state.eventFourDate !== null &&
        this.state.eventFourDate !== ""
      ) {
        this.setState(
          {
            eventFourError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventFourError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (
        this.state.eventFourName !== null &&
        this.state.eventFourName !== ""
      ) {
        if (
          this.state.eventFourDate !== null &&
          this.state.eventFourDate !== ""
        ) {
          this.setState(
            {
              eventFourError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventFourError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        this.state.eventFourDate !== null &&
        this.state.eventFourDate !== ""
      ) {
        if (
          this.state.eventFourName !== null &&
          this.state.eventFourName !== ""
        ) {
          this.setState(
            {
              eventFourError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventFourError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventFourDate === null ||
          this.state.eventFourDate === "") &&
        (this.state.eventFourName === null || this.state.eventFourName === "")
      ) {
        this.setState(
          {
            eventFourError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }

    if (this.state.eventFiveUrl !== null && this.state.eventFiveUrl !== "") {
      if (
        this.state.eventFiveName !== "" &&
        this.state.eventFiveName !== null &&
        this.state.eventFiveDate !== null &&
        this.state.eventFiveDate !== ""
      ) {
        this.setState(
          {
            eventFiveError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventFiveError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (
        this.state.eventFiveName !== null &&
        this.state.eventFiveName !== ""
      ) {
        if (
          this.state.eventFiveDate !== null &&
          this.state.eventFiveDate !== ""
        ) {
          this.setState(
            {
              eventFiveError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventFiveError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        this.state.eventFiveDate !== null &&
        this.state.eventFiveDate !== ""
      ) {
        if (
          this.state.eventFiveName !== null &&
          this.state.eventFiveName !== ""
        ) {
          this.setState(
            {
              eventFiveError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventFiveError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventFiveDate === null ||
          this.state.eventFiveDate === "") &&
        (this.state.eventFiveName === null || this.state.eventFiveName === "")
      ) {
        this.setState(
          {
            eventFiveError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }

    if (this.state.eventSixUrl !== null && this.state.eventSixUrl !== "") {
      if (
        this.state.eventSixName !== "" &&
        this.state.eventSixName !== null &&
        this.state.eventSixDate !== null &&
        this.state.eventSixDate !== ""
      ) {
        this.setState(
          {
            eventSixError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      } else {
        this.setState(
          {
            eventSixError: true,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    } else {
      if (this.state.eventSixName !== null && this.state.eventSixName !== "") {
        if (
          this.state.eventSixDate !== null &&
          this.state.eventSixDate !== ""
        ) {
          this.setState(
            {
              eventSixError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventSixError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (this.state.eventSixDate !== null && this.state.eventSixDate !== "") {
        if (
          this.state.eventSixName !== null &&
          this.state.eventSixName !== ""
        ) {
          this.setState(
            {
              eventSixError: false,
            },
            () => {
              this.trackErrors();
            }
          );
        } else {
          this.setState(
            {
              eventSixError: true,
            },
            () => {
              this.trackErrors();
            }
          );
        }
      }
      if (
        (this.state.eventSixDate === null || this.state.eventSixDate === "") &&
        (this.state.eventSixName === null || this.state.eventSixName === "")
      ) {
        this.setState(
          {
            eventSixError: false,
          },
          () => {
            this.trackErrors();
          }
        );
      }
    }
  };

  trackChanges = () => {
    if (
      this.state.imageCropped ||
      this.state.firstNameChanged ||
      this.state.lastNameChanged ||
      this.state.hometownChanged ||
      this.state.classChanged ||
      this.state.sportChanged ||
      this.state.committedChanged ||
      this.state.primaryPositionChanged ||
      this.state.secondaryPositionChanged ||
      this.state.batsChanged ||
      this.state.throwsChanged ||
      this.state.parentOneFirstNameChanged ||
      this.state.parentTwoFirstNameChanged ||
      this.state.parentOneLastNameChanged ||
      this.state.parentTwoLastNameChanged ||
      this.state.specialtyMetricsChanged ||
      this.state.clubNameChanged ||
      this.state.clubTeamNameChanged ||
      this.state.jerseyChanged ||
      this.state.heightChanged ||
      this.state.weightChanged ||
      this.state.ncaaIdChanged ||
      this.state.gpaChanged ||
      this.state.actChanged ||
      this.state.satChanged ||
      this.state.classRankChanged ||
      this.state.highSchoolNameChanged ||
      this.state.highSchoolCityStateChanged ||
      this.state.intendedMajorChanged ||
      this.state.clubCoachNameChanged ||
      this.state.clubCoachPhoneChanged ||
      this.state.clubCoachEmailChanged ||
      this.state.highSchoolCoachNameChanged ||
      this.state.highSchoolCoachPhoneChanged ||
      this.state.highSchoolCoachEmailChanged ||
      this.state.hittingCoachNameChanged ||
      this.state.hittingCoachPhoneChanged ||
      this.state.hittingCoachEmailChanged ||
      this.state.pitchingCoachNameChanged ||
      this.state.pitchingCoachPhoneChanged ||
      this.state.pitchingCoachEmailChanged ||
      this.state.twitterChanged ||
      this.state.aglChanged ||
      this.state.facebookChanged ||
      this.state.hudlChanged ||
      this.state.instagramChanged ||
      this.state.youTubeChanged ||
      this.state.academicHonorOneChanged ||
      this.state.academicHonorTwoChanged ||
      this.state.academicHonorThreeChanged ||
      this.state.academicHonorFourChanged ||
      this.state.academicHonorFiveChanged ||
      this.state.academicHonorSixChanged ||
      this.state.academicHonorSevenChanged ||
      this.state.academicHonorEightChanged ||
      this.state.academicHonorNineChanged ||
      this.state.academicHonorTenChanged ||
      this.state.athleticAwardOneChanged ||
      this.state.athleticAwardTwoChanged ||
      this.state.athleticAwardThreeChanged ||
      this.state.athleticAwardFourChanged ||
      this.state.athleticAwardFiveChanged ||
      this.state.athleticAwardSixChanged ||
      this.state.athleticAwardSevenChanged ||
      this.state.athleticAwardEightChanged ||
      this.state.athleticAwardNineChanged ||
      this.state.athleticAwardTenChanged ||
      this.state.athleticStrengthOneChanged ||
      this.state.athleticStrengthTwoChanged ||
      this.state.athleticStrengthThreeChanged ||
      this.state.athleticStrengthFourChanged ||
      this.state.athleticStrengthFiveChanged ||
      this.state.athleticExtraOneChanged ||
      this.state.athleticExtraTwoChanged ||
      this.state.athleticExtraThreeChanged ||
      this.state.athleticExtraFourChanged ||
      this.state.athleticExtraFiveChanged ||
      this.state.athleticHobbyOneChanged ||
      this.state.athleticHobbyTwoChanged ||
      this.state.athleticHobbyThreeChanged ||
      this.state.athleticHobbyFourChanged ||
      this.state.athleticHobbyFiveChanged ||
      this.state.catchingCoachNameChanged ||
      this.state.catchingCoachPhoneChanged ||
      this.state.catchingCoachEmailChanged ||
      this.state.specialtyCoachNameChanged ||
      this.state.specialtyCoachFocusChanged ||
      this.state.specialtyCoachPhoneChanged ||
      this.state.specialtyCoachEmailChanged ||
      this.state.transcriptImageChanged ||
      this.state.satScoreImageChanged ||
      this.state.actScoreImageChanged ||
      this.state.athleteCalendarChanged ||
      this.state.eventOneNameChanged ||
      this.state.eventOneUrlChanged ||
      this.state.eventOneDateChanged ||
      this.state.eventTwoNameChanged ||
      this.state.eventTwoUrlChanged ||
      this.state.eventTwoDateChanged ||
      this.state.eventThreeNameChanged ||
      this.state.eventThreeUrlChanged ||
      this.state.eventThreeDateChanged ||
      this.state.eventFourNameChanged ||
      this.state.eventFourUrlChanged ||
      this.state.eventFourDateChanged ||
      this.state.eventFiveNameChanged ||
      this.state.eventFiveUrlChanged ||
      this.state.eventFiveDateChanged ||
      this.state.eventSixNameChanged ||
      this.state.eventSixUrlChanged ||
      this.state.videoOneTitleChanged ||
      this.state.videoTwoTitleChanged ||
      this.state.videoThreeTitleChanged ||
      this.state.videoFourTitleChanged ||
      this.state.committedSchoolChanged
    ) {
      this.setState({
        changesMade: true,
      });
    } else {
      this.setState({
        changesMade: false,
      });
    }
  };

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {
        const self = this;

        switch (e.target.id) {
          case "athleteCalendar":
            if (e.target.value !== initialAthleteCalendar) {
              this.setState(
                {
                  athleteCalendarChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleteCalendarChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;

          case "eventOneName":
            if (e.target.value !== initialEventOneName) {
              this.setState(
                {
                  eventOneNameChanged: true,
                },
                () => {
                  this.checkEventsError();

                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventOneNameChanged: false,
                },
                () => {
                  this.checkEventsError();

                  this.trackChanges();
                }
              );
            }
            break;
          case "eventOneUrl":
            if (e.target.value !== initialEventOneUrl) {
              this.setState(
                {
                  eventOneUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventOneUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventTwoName":
            if (e.target.value !== initialEventTwoName) {
              this.setState(
                {
                  eventTwoNameChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventTwoNameChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventTwoUrl":
            if (e.target.value !== initialEventTwoUrl) {
              this.setState(
                {
                  eventTwoUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventTwoUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventThreeName":
            if (e.target.value !== initialEventThreeName) {
              this.setState(
                {
                  eventThreeNameChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventThreeNameChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventThreeUrl":
            if (e.target.value !== initialEventThreeUrl) {
              this.setState(
                {
                  eventThreeUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventThreeUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventFourName":
            if (e.target.value !== initialEventFourName) {
              this.setState(
                {
                  eventFourNameChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventFourNameChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventFourUrl":
            if (e.target.value !== initialEventFourUrl) {
              this.setState(
                {
                  eventFourUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventFourUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventFiveName":
            if (e.target.value !== initialEventFiveName) {
              this.setState(
                {
                  eventFiveNameChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventFiveNameChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventFiveUrl":
            if (e.target.value !== initialEventFiveUrl) {
              this.setState(
                {
                  eventFiveUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventFiveUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventSixName":
            if (e.target.value !== initialEventSixName) {
              this.setState(
                {
                  eventSixNameChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventSixNameChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "eventSixUrl":
            if (e.target.value !== initialEventSixUrl) {
              this.setState(
                {
                  eventSixUrlChanged: true,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  eventSixUrlChanged: false,
                },
                () => {
                  this.checkEventsError();
                  this.trackChanges();
                }
              );
            }
            break;
          case "firstName":
            if (e.target.value !== initialFirstName) {
              this.setState(
                {
                  firstNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  firstNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "lastName":
            if (e.target.value !== initialLastName) {
              this.setState(
                {
                  lastNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  lastNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "hometown":
            if (e.target.value !== initialHometown) {
              this.setState(
                {
                  hometownChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  hometownChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "parentOneFirstName":
            if (e.target.value !== initialParentOneFirstName) {
              this.setState(
                {
                  parentOneFirstNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  parentOneFirstNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "parentTwoFirstName":
            if (e.target.value !== initialParentTwoFirstName) {
              this.setState(
                {
                  parentTwoFirstNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  parentTwoFirstNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "parentOneLastName":
            if (e.target.value !== initialParentOneLastName) {
              this.setState(
                {
                  parentOneLastNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  parentOneLastNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "parentTwoLastName":
            if (e.target.value !== initialParentTwoLastName) {
              this.setState(
                {
                  parentTwoLastNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  parentTwoLastNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "specialtyMetrics":
            if (e.target.value !== initialSpecialtyMetrics) {
              this.setState(
                {
                  specialtyMetricsChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  specialtyMetricsChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "clubName":
            if (e.target.value !== initialClubName) {
              this.setState(
                {
                  clubNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  clubNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "clubTeamName":
            if (e.target.value !== initialClubTeamName) {
              this.setState(
                {
                  clubTeamNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  clubTeamNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "jersey":
            if (e.target.value !== initialJersey) {
              this.setState(
                {
                  jerseyChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  jerseyChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "height":
            if (e.target.value !== initialHeight) {
              this.setState(
                {
                  heightChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  heightChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "weight":
            if (e.target.value !== initialWeight && e.target.value !== "") {
              this.setState(
                {
                  weightChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  weightChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ weight: this.state.weight })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      weightError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      weightError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "ncaaId":
            if (e.target.value !== initialNcaaId && e.target.value !== "") {
              this.setState(
                {
                  ncaaIdChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  ncaaIdChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ ncaaId: this.state.ncaaId })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      ncaaIdError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      ncaaIdError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "gpa":
            if (e.target.value !== initialGpa && e.target.value !== "") {
              this.setState(
                {
                  gpaChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  gpaChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ gpa: this.state.gpa }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    gpaError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    gpaError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "act":
            if (e.target.value !== initialAct && e.target.value !== "") {
              this.setState(
                {
                  actChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  actChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ act: this.state.act }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    actError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    actError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "sat":
            if (e.target.value !== initialSat && e.target.value !== "") {
              this.setState(
                {
                  satChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  satChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ sat: this.state.sat }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    satError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    satError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "classRank":
            if (e.target.value !== initialClassRank) {
              this.setState(
                {
                  classRankChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  classRankChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "highSchoolName":
            if (e.target.value !== initialHighSchoolName) {
              this.setState(
                {
                  highSchoolNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  highSchoolNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "highSchoolCityState":
            if (e.target.value !== initialHighSchoolCityState) {
              this.setState(
                {
                  highSchoolCityStateChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  highSchoolCityStateChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "intendedMajor":
            if (e.target.value !== initialIntendedMajor) {
              this.setState(
                {
                  intendedMajorChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  intendedMajorChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "clubCoachName":
            if (e.target.value !== initialClubCoachName) {
              this.setState(
                {
                  clubCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  clubCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "clubCoachPhone":
            if (e.target.value !== initialClubCoachPhone) {
              this.setState(
                {
                  clubCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  clubCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.clubCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      clubCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      clubCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "clubCoachEmail":
            if (e.target.value !== initialClubCoachEmail) {
              this.setState(
                {
                  clubCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  clubCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "highSchoolCoachName":
            if (e.target.value !== initialHighSchoolCoachName) {
              this.setState(
                {
                  highSchoolCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  highSchoolCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "highSchoolCoachPhone":
            if (e.target.value !== initialHighSchoolCoachPhone) {
              this.setState(
                {
                  highSchoolCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  highSchoolCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.highSchoolCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      highSchoolCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      highSchoolCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "highSchoolCoachEmail":
            if (e.target.value !== initialHighSchoolCoachEmail) {
              this.setState(
                {
                  highSchoolCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  highSchoolCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "hittingCoachName":
            if (e.target.value !== initialHittingCoachName) {
              this.setState(
                {
                  hittingCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  hittingCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "hittingCoachPhone":
            if (e.target.value !== initialHittingCoachPhone) {
              this.setState(
                {
                  hittingCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  hittingCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.hittingCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      hittingCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      hittingCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "hittingCoachEmail":
            if (e.target.value !== initialHittingCoachEmail) {
              this.setState(
                {
                  hittingCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  hittingCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "pitchingCoachName":
            if (e.target.value !== initialPitchingCoachName) {
              this.setState(
                {
                  pitchingCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  pitchingCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "pitchingCoachPhone":
            if (e.target.value !== initialPitchingCoachPhone) {
              this.setState(
                {
                  pitchingCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  pitchingCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.pitchingCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      pitchingCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      pitchingCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "pitchingCoachEmail":
            if (e.target.value !== initialPitchingCoachEmail) {
              this.setState(
                {
                  pitchingCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  pitchingCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;

          case "catchingCoachName":
            if (e.target.value !== initialCatchingCoachName) {
              this.setState(
                {
                  catchingCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  catchingCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "catchingCoachPhone":
            if (e.target.value !== initialCatchingCoachPhone) {
              this.setState(
                {
                  catchingCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  catchingCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.catchingCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      catchingCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      catchingCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "catchingCoachEmail":
            if (e.target.value !== initialCatchingCoachEmail) {
              this.setState(
                {
                  catchingCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  catchingCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "specialtyCoachName":
            if (e.target.value !== initialSpecialtyCoachName) {
              this.setState(
                {
                  specialtyCoachNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  specialtyCoachNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "specialtyCoachFocus":
            if (e.target.value !== initialSpecialtyCoachFocus) {
              this.setState(
                {
                  specialtyCoachFocusChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  specialtyCoachFocusChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "specialtyCoachPhone":
            if (e.target.value !== initialSpecialtyCoachPhone) {
              this.setState(
                {
                  specialtyCoachPhoneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  specialtyCoachPhoneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ phone: this.state.specialtyCoachPhone })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      specialtyCoachPhoneError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      specialtyCoachPhoneError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "specialtyCoachEmail":
            if (e.target.value !== initialSpecialtyCoachEmail) {
              this.setState(
                {
                  specialtyCoachEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  specialtyCoachEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "twitter":
            if (e.target.value !== initialTwitter) {
              this.setState(
                {
                  twitterChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  twitterChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ url: this.state.twitter }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    twitterError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    twitterError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "instagram":
            if (e.target.value !== initialInstagram) {
              this.setState(
                {
                  instagramChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  instagramChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema
              .isValid({ url: this.state.instagram })
              .then(function (valid) {
                if (valid) {
                  self.setState(
                    {
                      instagramError: false,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                } else {
                  self.setState(
                    {
                      instagramError: true,
                    },
                    () => {
                      self.trackErrors();
                    }
                  );
                }
              });
            break;
          case "facebook":
            if (e.target.value !== initialFacebook) {
              this.setState(
                {
                  facebookChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  facebookChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ url: this.state.facebook }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    facebookError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    facebookError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "youTube":
            if (e.target.value !== initialYouTube) {
              this.setState(
                {
                  youTubeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  youTubeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ url: this.state.youTube }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    youTubeError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    youTubeError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "agl":
            if (e.target.value !== initialAgl) {
              this.setState(
                {
                  aglChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  aglChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "hudl":
            if (e.target.value !== initialHudl) {
              this.setState(
                {
                  hudlChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  hudlChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            schema.isValid({ url: this.state.hudl }).then(function (valid) {
              if (valid) {
                self.setState(
                  {
                    hudlError: false,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              } else {
                self.setState(
                  {
                    hudlError: true,
                  },
                  () => {
                    self.trackErrors();
                  }
                );
              }
            });
            break;
          case "academicHonorOne":
            if (e.target.value !== initialAcademicHonorOne) {
              this.setState(
                {
                  academicHonorOneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorOneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorTwo":
            if (e.target.value !== initialAcademicHonorTwo) {
              this.setState(
                {
                  academicHonorTwoChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorTwoChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorThree":
            if (e.target.value !== initialAcademicHonorThree) {
              this.setState(
                {
                  academicHonorThreeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorThreeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorFour":
            if (e.target.value !== initialAcademicHonorFour) {
              this.setState(
                {
                  academicHonorFourChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorFourChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorFive":
            if (e.target.value !== initialAcademicHonorFive) {
              this.setState(
                {
                  academicHonorFiveChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorFiveChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorSix":
            if (e.target.value !== initialAcademicHonorSix) {
              this.setState(
                {
                  academicHonorSixChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorSixChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorSeven":
            if (e.target.value !== initialAcademicHonorSeven) {
              this.setState(
                {
                  academicHonorSevenChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorSevenChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorEight":
            if (e.target.value !== initialAcademicHonorEight) {
              this.setState(
                {
                  academicHonorEightChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorEightChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorNine":
            if (e.target.value !== initialAcademicHonorNine) {
              this.setState(
                {
                  academicHonorNineChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorNineChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "academicHonorTen":
            if (e.target.value !== initialAcademicHonorTen) {
              this.setState(
                {
                  academicHonorTenChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  academicHonorTenChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardOne":
            if (e.target.value !== initialAthleticAwardOne) {
              this.setState(
                {
                  athleticAwardOneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardOneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardTwo":
            if (e.target.value !== initialAthleticAwardTwo) {
              this.setState(
                {
                  athleticAwardTwoChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardTwoChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardThree":
            if (e.target.value !== initialAthleticAwardThree) {
              this.setState(
                {
                  athleticAwardThreeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardThreeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardFour":
            if (e.target.value !== initialAthleticAwardFour) {
              this.setState(
                {
                  athleticAwardFourChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardFourChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardFive":
            if (e.target.value !== initialAthleticAwardFive) {
              this.setState(
                {
                  athleticAwardFiveChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardFiveChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardSix":
            if (e.target.value !== initialAthleticAwardSix) {
              this.setState(
                {
                  athleticAwardSixChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardSixChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardSeven":
            if (e.target.value !== initialAthleticAwardSeven) {
              this.setState(
                {
                  athleticAwardSevenChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardSevenChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardEight":
            if (e.target.value !== initialAthleticAwardEight) {
              this.setState(
                {
                  athleticAwardEightChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardEightChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardNine":
            if (e.target.value !== initialAthleticAwardNine) {
              this.setState(
                {
                  athleticAwardNineChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardNineChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticAwardTen":
            if (e.target.value !== initialAthleticAwardTen) {
              this.setState(
                {
                  athleticAwardTenChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticAwardTenChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticStrengthOne":
            if (e.target.value !== initialAthleticStrengthOne) {
              this.setState(
                {
                  athleticStrengthOneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticStrengthOneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticStrengthTwo":
            if (e.target.value !== initialAthleticStrengthTwo) {
              this.setState(
                {
                  athleticStrengthTwoChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticStrengthTwoChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticStrengthThree":
            if (e.target.value !== initialAthleticStrengthThree) {
              this.setState(
                {
                  athleticStrengthThreeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticStrengthThreeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticStrengthFour":
            if (e.target.value !== initialAthleticStrengthFour) {
              this.setState(
                {
                  athleticStrengthFourChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticStrengthFourChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticStrengthFive":
            if (e.target.value !== initialAthleticStrengthFive) {
              this.setState(
                {
                  athleticStrengthFiveChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticStrengthFiveChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticExtraOne":
            if (e.target.value !== initialAthleticExtraOne) {
              this.setState(
                {
                  athleticExtraOneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticExtraOneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticExtraTwo":
            if (e.target.value !== initialAthleticExtraTwo) {
              this.setState(
                {
                  athleticExtraTwoChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticExtraTwoChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticExtraThree":
            if (e.target.value !== initialAthleticExtraThree) {
              this.setState(
                {
                  athleticExtraThreeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticExtraThreeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticExtraFour":
            if (e.target.value !== initialAthleticExtraFour) {
              this.setState(
                {
                  athleticExtraFourChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticExtraFourChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticExtraFive":
            if (e.target.value !== initialAthleticExtraFive) {
              this.setState(
                {
                  athleticExtraFiveChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticExtraFiveChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticHobbyOne":
            if (e.target.value !== initialAthleticHobbyOne) {
              this.setState(
                {
                  athleticHobbyOneChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticHobbyOneChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticHobbyTwo":
            if (e.target.value !== initialAthleticHobbyTwo) {
              this.setState(
                {
                  athleticHobbyTwoChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticHobbyTwoChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticHobbyThree":
            if (e.target.value !== initialAthleticHobbyThree) {
              this.setState(
                {
                  athleticHobbyThreeChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticHobbyThreeChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticHobbyFour":
            if (e.target.value !== initialAthleticHobbyFour) {
              this.setState(
                {
                  athleticHobbyFourChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticHobbyFourChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "athleticHobbyFive":
            if (e.target.value !== initialAthleticHobbyFive) {
              this.setState(
                {
                  athleticHobbyFiveChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  athleticHobbyFiveChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          default:
            return;
        }
      }
    );
  };
  videoTitleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {
        switch (e.target.id) {
          case "videoOneTitle":
            if (e.target.value !== initialVideoOneTitle) {
              this.setState(
                {
                  videoOneTitleChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  videoOneTitleChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "videoTwoTitle":
            if (e.target.value !== initialVideoTwoTitle) {
              this.setState(
                {
                  videoTwoTitleChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  videoTwoTitleChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "videoThreeTitle":
            if (e.target.value !== initialVideoThreeTitle) {
              this.setState(
                {
                  videoThreeTitleChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  videoThreeTitleChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "videoFourTitle":
            if (e.target.value !== initialVideoFourTitle) {
              this.setState(
                {
                  videoFourTitleChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  videoFourTitleChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          default:
            return;
        }
      }
    );
  };
  confirmOpen = () => this.setState({ confirmOpen: true });

  confirmClose = () => {
    this.setState(initialState, () => {
      this.handleClose();
    });
  };

  confirmDelete = () => {
    this.handleDelete();
  };

  confirmCloseCancel = () =>
    this.setState({
      confirmOpen: false,
    });

  confirmDeleteCancel = () =>
    this.setState({
      confirmDelete: false,
    });

  handleDeleteExit = () => {
    this.setState({
      deleteRedirect: true,
    });
  };

  handleExit = () => {
    count = 0;

    this.setState(initialState, () => {
      this.props.resetAthlete();
    });
  };

  handleErrorMessageClose = () => {
    this.setState({
      showErrorMessage: false,
    });
  };

  handleClose = () => {
    if (
      this.state.cropImageOpen ||
      this.state.cropImageOneOpen ||
      this.state.cropImageTwoOpen ||
      this.state.cropImageThreeOpen ||
      this.state.cropImageFourOpen ||
      this.state.cropImageFiveOpen ||
      this.state.cropImageVideoOneOpen ||
      this.state.cropImageVideoTwoOpen ||
      this.state.cropImageVideoThreeOpen ||
      this.state.cropImageVideoFourOpen ||
      this.state.cropImageVideoNewOpen ||
      this.state.cropImageTranscriptOpen ||
      this.state.cropImageSatOpen ||
      this.state.cropImageActOpen
    ) {
      return;
    } else {
      if (this.state.changesMade) {
        this.confirmOpen();
      } else {
        count = 0;
        this.setState({
          editProfileOpen: false,
          imageCropped: false,
        });
      }
    }
  };

  handleEventsClose = () => {
    if (this.state.changesMade) {
      this.confirmOpen();
    } else {
      this.setState({
        manageEvents: false,
      });
    }
  };

  handleDelete = () => {
    this.setState(
      {
        deletingAthlete: true,
      },
      () => {
        this.props.deleteAthlete(this.props.match.params.id);
      }
    );
  };

  handleEditVideoClose = () => {
    this.setState({
      cropImageVideoOneOpen: false,
      cropImageVideoTwoOpen: false,
      cropImageVideoThreeOpen: false,
      cropImageVideoFourOpen: false,
      cropImageVideoNewOpen: false,

      dropzoneVideoOne: null,
      dropzoneVideoOneUrl: null,
      dropzoneVideoOneLink: "",

      dropzoneVideoTwo: null,
      dropzoneVideoTwoUrl: null,
      dropzoneVideoTwoLink: "",

      dropzoneVideoThree: null,
      dropzoneVideoThreeUrl: null,
      dropzoneVideoThreeLink: "",

      dropzoneVideoFour: null,
      dropzoneVideoFourUrl: null,
      dropzoneVideoFourLink: "",

      dropzoneVideoNew: null,
      dropzoneVideoNewUrl: null,
      dropzoneVideoNewLink: "",
    });
  };
  handleShowHighSchoolScheduleOneClose = () => {
    if (this.state.showHighSchoolScheduleOne) {
      this.setState({
        showHighSchoolScheduleOne: false,
      });
    } else return;
  };
  showHighScheduleOneImage = () => {
    this.setState({
      showHighSchoolScheduleOne: true,
    });
  };
  handleShowHighSchoolScheduleTwoClose = () => {
    if (this.state.showHighSchoolScheduleTwo) {
      this.setState({
        showHighSchoolScheduleTwo: false,
      });
    } else return;
  };
  showHighScheduleTwoImage = () => {
    this.setState({
      showHighSchoolScheduleTwo: true,
    });
  };
  handleShowHighSchoolScheduleThreeClose = () => {
    if (this.state.showHighSchoolScheduleThree) {
      this.setState({
        showHighSchoolScheduleThree: false,
      });
    } else return;
  };
  showHighScheduleThreeImage = () => {
    this.setState({
      showHighSchoolScheduleThree: true,
    });
  };
  handleShowHighSchoolScheduleFourClose = () => {
    if (this.state.showHighSchoolScheduleFour) {
      this.setState({
        showHighSchoolScheduleFour: false,
      });
    } else return;
  };
  showHighScheduleFourImage = () => {
    this.setState({
      showHighSchoolScheduleFour: true,
    });
  };
  handleShowHighSchoolScheduleFiveClose = () => {
    if (this.state.showHighSchoolScheduleFive) {
      this.setState({
        showHighSchoolScheduleFive: false,
      });
    } else return;
  };
  showHighScheduleFiveImage = () => {
    this.setState({
      showHighSchoolScheduleFive: true,
    });
  };
  handleEditImageClose = () => {
    if (
      this.state.cropImageOpen ||
      this.state.cropImageOneOpen ||
      this.state.cropImageTwoOpen ||
      this.state.cropImageThreeOpen ||
      this.state.cropImageFourOpen ||
      this.state.cropImageFiveOpen ||
      this.state.cropImageTranscriptOpen ||
      this.state.cropImageSatOpen ||
      this.state.cropImageActOpen
    ) {
      return;
    } else {
      if (this.state.imageCropped) {
        switch (this.state.cropSource) {
          case "thumbnail":
            this.setState({
              thumbnail: this.state.croppedImageBlob,
              thumbnailChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageOne":
            this.setState({
              imageOne: this.state.croppedImageOneBlob,
              imageOneChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageTwo":
            this.setState({
              imageTwo: this.state.croppedImageTwoBlob,
              imageTwoChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageThree":
            this.setState({
              imageThree: this.state.croppedImageThreeBlob,
              imageThreeChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageFour":
            this.setState({
              imageFour: this.state.croppedImageFourBlob,
              imageFourChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageFive":
            this.setState({
              imageFive: this.state.croppedImageFiveBlob,
              imageFiveChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageTranscript":
            this.setState({
              transcriptImage: this.state.croppedImageTranscriptBlob,
              transcriptImageChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageSat":
            this.setState({
              satScoreImage: this.state.croppedImageSatBlob,
              satScoreImageChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;
          case "imageAct":
            this.setState({
              actScoreImage: this.state.croppedImageActBlob,
              actScoreImageChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          case "imageHighSchoolOne":
            this.setState({
              imageHighSchoolOne: this.state.newImageHighSchoolOne,
              imageHighSchoolOneChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          case "imageHighSchoolTwo":
            this.setState({
              imageHighSchoolTwo: this.state.newImageHighSchoolTwo,
              imageHighSchoolTwoChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          case "imageHighSchoolThree":
            this.setState({
              imageHighSchoolThree: this.state.newImageHighSchoolThree,
              imageHighSchoolThreeChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          case "imageHighSchoolFour":
            this.setState({
              imageHighSchoolFour: this.state.newImageHighSchoolFour,
              imageHighSchoolFourChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          case "imageHighSchoolFive":
            this.setState({
              imageHighSchoolFive: this.state.newImageHighSchoolFive,
              imageHighSchoolFiveChanged: true,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
            break;

          default:
            this.setState({
              imageCropped: false,
              cropImageOpen: false,
              cropImageOneOpen: false,
              cropImageTwoOpen: false,
              cropImageThreeOpen: false,
              cropImageFourOpen: false,
              cropImageFiveOpen: false,
              cropImageTranscriptOpen: false,
              cropImageSatOpen: false,
              cropImageActOpen: false,
            });
        }
      } else {
        this.setState({
          imageCropped: false,
          cropImageOpen: false,
          cropImageOneOpen: false,
          cropImageTwoOpen: false,
          cropImageThreeOpen: false,
          cropImageFourOpen: false,
          cropImageFiveOpen: false,
          cropImageTranscriptOpen: false,
          cropImageSatOpen: false,
          cropImageActOpen: false,
        });
      }
    }
  };

  handleImageApplyCrop = (source) => {
    this.setState(
      {
        imageCropped: true,
        cropSource: source,
        cropImageOpen: false,
        cropImageOneOpen: false,
        cropImageTwoOpen: false,
        cropImageThreeOpen: false,
        cropImageFourOpen: false,
        cropImageFiveOpen: false,
        cropImageTranscriptOpen: false,
        cropImageSatOpen: false,
        cropImageActOpen: false,
      },
      () => {
        this.trackChanges();
      }
    );
  };

  onDateOneChange = (date) => {
    this.setState(
      {
        eventOneDate: date,
      },
      () => {
        if (date !== initialEventOneDate) {
          this.setState(
            {
              eventOneDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventOneDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  onDateTwoChange = (date) => {
    this.setState(
      {
        eventTwoDate: date,
      },
      () => {
        if (date !== initialEventTwoDate) {
          this.setState(
            {
              eventTwoDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventTwoDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  onDateThreeChange = (date) => {
    this.setState(
      {
        eventThreeDate: date,
      },
      () => {
        if (date !== initialEventThreeDate) {
          this.setState(
            {
              eventThreeDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventThreeDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  onDateFourChange = (date) => {
    this.setState(
      {
        eventFourDate: date,
      },
      () => {
        if (date !== initialEventFourDate) {
          this.setState(
            {
              eventFourDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventFourDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  onDateFiveChange = (date) => {
    this.setState(
      {
        eventFiveDate: date,
      },
      () => {
        if (date !== initialEventFiveDate) {
          this.setState(
            {
              eventFiveDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventFiveDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  onDateSixChange = (date) => {
    this.setState(
      {
        eventSixDate: date,
      },
      () => {
        if (date !== initialEventSixDate) {
          this.setState(
            {
              eventSixDateChanged: true,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        } else {
          this.setState(
            {
              eventSixDateChanged: false,
            },
            () => {
              this.checkEventsError();
              this.trackChanges();
            }
          );
        }
      }
    );
  };

  handleClick = (e, data) => {
    switch (data.name) {
      case "profileButton":
        this.setState({
          editProfileOpen: true,
        });
        this.props.resetAthlete();
        break;
      case "eventButton":
        this.setState({
          manageEvents: true,
        });
        break;
      case "deleteButton":
        this.setState({
          confirmDelete: true,
        });
        break;
      default:
        this.setState({
          editProfileOpen: false,
        });
    }
  };

  handleImageEvent = (type) => {
    if (type === "close" || type === "loadabort") {
      this.setState(
        {
          cropImageOpen: false,
          cropImageOneOpen: false,
          cropImageTwoOpen: false,
          cropImageThreeOpen: false,
          cropImageFourOpen: false,
          cropImageFiveOpen: false,
          cropImageTranscriptOpen: false,
          cropImageSatOpen: false,
          cropImageActOpen: false,
        },
        () => {
          this.handleEditImageClose();
        }
      );
    }
  };

  processImage = (dest) => {
    this.setState(
      {
        croppedImageBlob: dest,
        croppedImageBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("thumbnail");
      }
    );
  };

  processImageOne = (dest) => {
    this.setState(
      {
        croppedImageOneBlob: dest,
        croppedImageOneBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageOne");
      }
    );
  };

  processImageHighSchoolOne = (dest) => {
    this.setState(
      {
        croppedImageHighSchoolOneBlob: dest,
        croppedImageHighSchoolOneBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolOne");
      }
    );
  };

  processImageTwo = (dest) => {
    this.setState(
      {
        croppedImageTwoBlob: dest,
        croppedImageTwoBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageTwo");
      }
    );
  };

  processImageHighSchoolTwo = (dest) => {
    this.setState(
      {
        croppedImageHighSchoolTwoBlob: dest,
        croppedImageHighSchoolTwoBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolTwo");
      }
    );
  };

  processImageThree = (dest) => {
    this.setState(
      {
        croppedImageThreeBlob: dest,
        croppedImageThreeBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageThree");
      }
    );
  };
  processImageHighSchoolThree = (dest) => {
    this.setState(
      {
        croppedImageHighSchoolThreeBlob: dest,
        croppedImageHighSchoolThreeBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolThree");
      }
    );
  };
  processImageFour = (dest) => {
    this.setState(
      {
        croppedImageFourBlob: dest,
        croppedImageFourBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageFour");
      }
    );
  };
  processImageHighSchoolFour = (dest) => {
    this.setState(
      {
        croppedImageHighSchoolFourBlob: dest,
        croppedImageHighSchoolFourBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolFour");
      }
    );
  };
  processImageFive = (dest) => {
    this.setState(
      {
        croppedImageFiveBlob: dest,
        croppedImageFiveBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageFive");
      }
    );
  };
  processImageHighSchoolFive = (dest) => {
    this.setState(
      {
        croppedImageHighSchoolFiveBlob: dest,
        croppedImageHighSchoolFiveBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolFive");
      }
    );
  };
  processImageTranscript = (dest) => {
    this.setState(
      {
        croppedImageTranscriptBlob: dest,
        croppedImageTranscriptBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageTranscript");
      }
    );
  };

  processImageSat = (dest) => {
    this.setState(
      {
        croppedImageSatBlob: dest,
        croppedImageSatBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageSat");
      }
    );
  };

  processImageAct = (dest) => {
    this.setState(
      {
        croppedImageActBlob: dest,
        croppedImageActBlobUrl: URL.createObjectURL(dest),
      },
      () => {
        this.handleImageApplyCrop("imageAct");
      }
    );
  };

  upload = (source) => {
    switch (source) {
      case "thumbnail":
        document.getElementById("thumbnail").click();
        break;
      case "imageOne":
        document.getElementById("imageOne").click();
        break;
      case "imageHighSchoolOne":
        document.getElementById("imageHighSchoolOne").click();
        break;
      case "imageTwo":
        document.getElementById("imageTwo").click();
        break;
      case "imageHighSchoolTwo":
        document.getElementById("imageHighSchoolTwo").click();
        break;
      case "imageThree":
        document.getElementById("imageThree").click();
        break;
      case "imageHighSchoolThree":
        document.getElementById("imageHighSchoolThree").click();
        break;
      case "imageFour":
        document.getElementById("imageFour").click();
        break;
      case "imageHighSchoolFour":
        document.getElementById("imageHighSchoolFour").click();
        break;
      case "imageFive":
        document.getElementById("imageFive").click();
        break;
      case "imageHighSchoolFive":
        document.getElementById("imageHighSchoolFive").click();
        break;
      case "imageTranscript":
        document.getElementById("imageTranscript").click();
        break;
      case "imageSat":
        document.getElementById("imageSat").click();
        break;
      case "imageAct":
        document.getElementById("imageAct").click();
        break;
      case "school":
        if (this.state.imageHighSchoolOne !== "None") {
          // add to image two three four or five

          if (this.state.imageHighSchoolTwo !== "None") {
            // add to image three four or five

            if (this.state.imageHighSchoolThree !== "None") {
              // add to image four or five

              if (this.state.imageHighSchoolFour !== "None") {
                // add to image five
                document.getElementById("imageHighSchoolFive").click();
                break;
              } else {
                // add to image four
                document.getElementById("imageHighSchoolFour").click();
                break;
              }
            } else {
              // add to image three
              document.getElementById("imageHighSchoolThree").click();
              break;
            }
          } else {
            // add to image two
            document.getElementById("imageHighSchoolTwo").click();
            break;
          }
        } else {
          // add to image one
          document.getElementById("imageHighSchoolOne").click();
          break;
        }
      default:
        // default is imageNew

        if (this.state.imageOne !== "None") {
          // add to image two three four or five

          if (this.state.imageTwo !== "None") {
            // add to image three four or five

            if (this.state.imageThree !== "None") {
              // add to image four or five

              if (this.state.imageFour !== "None") {
                // add to image five
                document.getElementById("imageFive").click();
                break;
              } else {
                // add to image four
                document.getElementById("imageFour").click();
                break;
              }
            } else {
              // add to image three
              document.getElementById("imageThree").click();
              break;
            }
          } else {
            // add to image two
            document.getElementById("imageTwo").click();
            break;
          }
        } else {
          // add to image one
          document.getElementById("imageOne").click();
          break;
        }
    }
  };
  fileSelectedImageHighSchoolOneHandler = (event) => {
    this.setState(
      {
        newImageHighSchoolOne: event.target.files[0],
        newImageHighSchoolOneUrl: URL.createObjectURL(event.target.files[0]),
        imageCropped: true,
        cropSource: "imageHighSchoolOne",
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolOne");
        this.handleEditImageClose("imageHighSchoolOne");
      }
    );
  };
  fileSelectedImageHighSchoolTwoHandler = (event) => {
    this.setState(
      {
        newImageHighSchoolTwo: event.target.files[0],
        newImageHighSchoolTwoUrl: URL.createObjectURL(event.target.files[0]),
        imageCropped: true,
        cropSource: "imageHighSchoolTwo",
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolTwo");
        this.handleEditImageClose("imageHighSchoolTwo");
      }
    );
  };
  fileSelectedImageHighSchoolThreeHandler = (event) => {
    this.setState(
      {
        newImageHighSchoolThree: event.target.files[0],
        newImageHighSchoolThreeUrl: URL.createObjectURL(event.target.files[0]),
        imageCropped: true,
        cropSource: "imageHighSchoolThree",
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolThree");
        this.handleEditImageClose("imageHighSchoolThree");
      }
    );
  };
  fileSelectedImageHighSchoolFourHandler = (event) => {
    this.setState(
      {
        newImageHighSchoolFour: event.target.files[0],
        newImageHighSchoolFourUrl: URL.createObjectURL(event.target.files[0]),
        imageCropped: true,
        cropSource: "imageHighSchoolFour",
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolFour");
        this.handleEditImageClose("imageHighSchoolFour");
      }
    );
  };
  fileSelectedImageHighSchoolFiveHandler = (event) => {
    this.setState(
      {
        newImageHighSchoolFive: event.target.files[0],
        newImageHighSchoolFiveUrl: URL.createObjectURL(event.target.files[0]),
        imageCropped: true,
        cropSource: "imageHighSchoolFive",
      },
      () => {
        this.handleImageApplyCrop("imageHighSchoolFive");
        this.handleEditImageClose("imageHighSchoolFive");
      }
    );
  };

  fileSelectedHandler = (event) => {
    this.setState({
      newThumbnailImage: event.target.files[0],
      newThumbnailImageUrl: URL.createObjectURL(event.target.files[0]),
      cropImageOpen: true,
    });
  };
  fileSelectedImageOneHandler = (event) => {
    this.setState({
      newImageOne: event.target.files[0],
      newImageOneUrl: URL.createObjectURL(event.target.files[0]),
      cropImageOneOpen: true,
    });
  };
  fileSelectedImageTwoHandler = (event) => {
    this.setState({
      newImageTwo: event.target.files[0],
      newImageTwoUrl: URL.createObjectURL(event.target.files[0]),
      cropImageTwoOpen: true,
    });
  };
  fileSelectedImageThreeHandler = (event) => {
    this.setState({
      newImageThree: event.target.files[0],
      newImageThreeUrl: URL.createObjectURL(event.target.files[0]),
      cropImageThreeOpen: true,
    });
  };
  fileSelectedImageFourHandler = (event) => {
    this.setState({
      newImageFour: event.target.files[0],
      newImageFourUrl: URL.createObjectURL(event.target.files[0]),
      cropImageFourOpen: true,
    });
  };
  fileSelectedImageFiveHandler = (event) => {
    this.setState({
      newImageFive: event.target.files[0],
      newImageFiveUrl: URL.createObjectURL(event.target.files[0]),
      cropImageFiveOpen: true,
    });
  };
  fileSelectedImageTranscriptHandler = (event) => {
    if (event.target.files[0].type === "application/pdf") {
      this.setState({
        transcriptImage: event.target.files[0],
        croppedImageTranscriptBlobUrl: URL.createObjectURL(
          event.target.files[0]
        ),
        transcriptImageChanged: true,
        changesMade: true,
      });

      this.handleImageApplyCrop("imageTranscript");
    }
    if (isFileImage(event.target.files[0])) {
      this.setState({
        newTranscriptImage: event.target.files[0],
        newTranscriptImageUrl: URL.createObjectURL(event.target.files[0]),
        cropImageTranscriptOpen: true,
      });
    }
  };
  fileSelectedImageSatHandler = (event) => {
    if (event.target.files[0].type === "application/pdf") {
      this.setState({
        satScoreImage: event.target.files[0],
        croppedImageSatBlobUrl: URL.createObjectURL(event.target.files[0]),
        satScoreImageChanged: true,
        changesMade: true,
      });

      this.handleImageApplyCrop("imageSat");
    }
    if (isFileImage(event.target.files[0])) {
      this.setState({
        newSatScoreImage: event.target.files[0],
        newSatScoreImageUrl: URL.createObjectURL(event.target.files[0]),
        cropImageSatOpen: true,
      });
    }
  };
  fileSelectedImageActHandler = (event) => {
    if (event.target.files[0].type === "application/pdf") {
      this.setState({
        actScoreImage: event.target.files[0],
        croppedImageActBlobUrl: URL.createObjectURL(event.target.files[0]),
        actScoreImageChanged: true,
        changesMade: true,
      });

      this.handleImageApplyCrop("imageSat");
    }
    if (isFileImage(event.target.files[0])) {
      this.setState({
        newActScoreImage: event.target.files[0],
        newActScoreImageUrl: URL.createObjectURL(event.target.files[0]),
        cropImageActOpen: true,
      });
    }
  };

  checkWeightError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.weight !== "number") {
      removeSpaces = this.state.weight.replace(/\s+/g, "");
      castToNumber = schema.cast({
        weight: removeSpaces,
      });
      if (typeof castToNumber.weight !== "number") {
        this.setState(
          {
            weight: 0,
          },
          () => {
            this.checkNcaaIdError(e);
          }
        );
      } else {
        this.setState(
          {
            weight: castToNumber.weight,
          },
          () => {
            this.checkNcaaIdError(e);
          }
        );
      }
    } else {
      this.checkNcaaIdError(e);
    }
  };

  checkNcaaIdError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.ncaaId !== "number") {
      removeSpaces = this.state.ncaaId.replace(/\s+/g, "");
      castToNumber = schema.cast({
        ncaaId: removeSpaces,
      });
      if (typeof castToNumber.ncaaId !== "number") {
        this.setState(
          {
            ncaaId: 0,
          },
          () => {
            this.checkGpaError(e);
          }
        );
      } else {
        this.setState(
          {
            ncaaId: castToNumber.ncaaId,
          },
          () => {
            this.checkGpaError(e);
          }
        );
      }
    } else {
      this.checkGpaError(e);
    }
  };

  checkGpaError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.gpa !== "number") {
      removeSpaces = this.state.gpa.replace(/\s+/g, "");
      castToNumber = schema.cast({
        gpa: removeSpaces,
      });
      if (typeof castToNumber.gpa !== "number") {
        this.setState(
          {
            gpa: 0,
          },
          () => {
            this.checkActError(e);
          }
        );
      } else {
        this.setState(
          {
            gpa: castToNumber.gpa,
          },
          () => {
            this.checkActError(e);
          }
        );
      }
    } else {
      this.checkActError(e);
    }
  };

  checkActError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.act !== "number") {
      removeSpaces = this.state.act.replace(/\s+/g, "");
      castToNumber = schema.cast({
        act: removeSpaces,
      });
      if (typeof castToNumber.act !== "number") {
        this.setState(
          {
            act: 0,
          },
          () => {
            this.checkSatError(e);
          }
        );
      } else {
        this.setState(
          {
            act: castToNumber.act,
          },
          () => {
            this.checkSatError(e);
          }
        );
      }
    } else {
      this.checkSatError(e);
    }
  };

  checkSatError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.sat !== "number") {
      removeSpaces = this.state.sat.replace(/\s+/g, "");
      castToNumber = schema.cast({
        sat: removeSpaces,
      });
      if (typeof castToNumber.sat !== "number") {
        this.setState(
          {
            sat: 0,
          },
          () => {
            this.checkClubCoachPhoneError(e);
          }
        );
      } else {
        this.setState(
          {
            sat: castToNumber.sat,
          },
          () => {
            this.checkClubCoachPhoneError(e);
          }
        );
      }
    } else {
      this.checkClubCoachPhoneError(e);
    }
  };

  checkClubCoachPhoneError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.clubCoachPhone !== "number") {
      removeSpaces = this.state.clubCoachPhone.replace(/\s+/g, "");
      castToNumber = schema.cast({
        phone: removeSpaces,
      });
      if (typeof castToNumber.phone !== "number") {
        this.setState(
          {
            clubCoachPhone: "",
          },
          () => {
            this.checkHighSchoolCoachPhoneError(e);
          }
        );
      } else {
        this.setState(
          {
            clubCoachPhone: castToNumber.phone,
          },
          () => {
            this.checkHighSchoolCoachPhoneError(e);
          }
        );
      }
    } else {
      this.checkHighSchoolCoachPhoneError(e);
    }
  };

  checkHighSchoolCoachPhoneError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.highSchoolCoachPhone !== "number") {
      removeSpaces = this.state.highSchoolCoachPhone.replace(/\s+/g, "");
      castToNumber = schema.cast({
        phone: removeSpaces,
      });
      if (typeof castToNumber.phone !== "number") {
        this.setState(
          {
            highSchoolCoachPhone: "",
          },
          () => {
            this.checkHittingCoachPhoneError(e);
          }
        );
      } else {
        this.setState(
          {
            highSchoolCoachPhone: castToNumber.phone,
          },
          () => {
            this.checkHittingCoachPhoneError(e);
          }
        );
      }
    } else {
      this.checkHittingCoachPhoneError(e);
    }
  };

  checkHittingCoachPhoneError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.hittingCoachPhone !== "number") {
      removeSpaces = this.state.hittingCoachPhone.replace(/\s+/g, "");
      castToNumber = schema.cast({
        phone: removeSpaces,
      });
      if (typeof castToNumber.phone !== "number") {
        this.setState(
          {
            hittingCoachPhone: "",
          },
          () => {
            this.checkPitchingCoachPhoneError(e);
          }
        );
      } else {
        this.setState(
          {
            hittingCoachPhone: castToNumber.phone,
          },
          () => {
            this.checkPitchingCoachPhoneError(e);
          }
        );
      }
    } else {
      this.checkPitchingCoachPhoneError(e);
    }
  };

  checkPitchingCoachPhoneError = (e) => {
    let removeSpaces = null;
    let castToNumber = null;

    if (typeof this.state.pitchingCoachPhone !== "number") {
      removeSpaces = this.state.pitchingCoachPhone.replace(/\s+/g, "");
      castToNumber = schema.cast({
        phone: removeSpaces,
      });
      if (typeof castToNumber.phone !== "number") {
        this.setState(
          {
            pitchingCoachPhone: "",
          },
          () => {
            this.handleSubmit(e);
          }
        );
      } else {
        this.setState(
          {
            pitchingCoachPhone: castToNumber.phone,
          },
          () => {
            this.handleSubmit(e);
          }
        );
      }
    } else {
      this.handleSubmit(e);
    }
  };

  checkErrors = (e) => {
    e.preventDefault();
    this.setState(
      {
        athleteTriedToUpdate: true,
      },
      () => {
        this.checkWeightError(e);
      }
    );
  };

  handleDropzoneApply = (e) => {
    switch (e.target.id) {
      case "videoOne":
        if (this.state.dropzoneVideoOne) {
          // file exists
          this.setState(
            {
              newVideoOne: this.state.dropzoneVideoOne,
              newVideoOneUrl: this.state.dropzoneVideoOneUrl,
              imageCropped: true,
              videoOne: this.state.dropzoneVideoOne,
              videoOneChanged: true,
              cropImageVideoOneOpen: false,
              videoOneLink: null,
            },
            () => {
              this.trackChanges();
            }
          );
        } else {
          // file does not exist check link
          if (this.state.dropzoneVideoOneLink !== "") {
            // link exists
            this.setState(
              {
                newVideoOneUrl: this.state.dropzoneVideoOneLink,
                imageCropped: true,
                videoOneLink: this.state.dropzoneVideoOneLink,
                videoOneChanged: true,
                cropImageVideoOneOpen: false,
              },
              () => {
                this.trackChanges();
              }
            );
          } else {
            // file and link do not exist
            this.setState({
              cropImageVideoOneOpen: false,
            });
          }
        }
        break;
      case "videoTwo":
        if (this.state.dropzoneVideoTwo) {
          // file exists
          this.setState(
            {
              newVideoTwo: this.state.dropzoneVideoTwo,
              newVideoTwoUrl: this.state.dropzoneVideoTwoUrl,
              imageCropped: true,
              videoTwo: this.state.dropzoneVideoTwo,
              videoTwoChanged: true,
              cropImageVideoTwoOpen: false,
              videoTwoLink: null,
            },
            () => {
              this.trackChanges();
            }
          );
        } else {
          // file does not exist check link
          if (this.state.dropzoneVideoTwoLink !== "") {
            // link exists
            this.setState(
              {
                newVideoTwoUrl: this.state.dropzoneVideoTwoLink,
                imageCropped: true,
                videoTwoLink: this.state.dropzoneVideoTwoLink,
                videoTwoChanged: true,
                cropImageVideoTwoOpen: false,
              },
              () => {
                this.trackChanges();
              }
            );
          } else {
            // file and link do not exist
            this.setState({
              cropImageVideoTwoOpen: false,
            });
          }
        }
        break;
      case "videoThree":
        if (this.state.dropzoneVideoThree) {
          // file exists
          this.setState(
            {
              newVideoThree: this.state.dropzoneVideoThree,
              newVideoThreeUrl: this.state.dropzoneVideoThreeUrl,
              imageCropped: true,
              videoThree: this.state.dropzoneVideoThree,
              videoThreeChanged: true,
              cropImageVideoThreeOpen: false,
              videoThreeLink: null,
            },
            () => {
              this.trackChanges();
            }
          );
        } else {
          // file does not exist check link
          if (this.state.dropzoneVideoThreeLink !== "") {
            // link exists
            this.setState(
              {
                newVideoThreeUrl: this.state.dropzoneVideoThreeLink,
                imageCropped: true,
                videoThreeLink: this.state.dropzoneVideoThreeLink,
                videoThreeChanged: true,
                cropImageVideoThreeOpen: false,
              },
              () => {
                this.trackChanges();
              }
            );
          } else {
            // file and link do not exist
            this.setState({
              cropImageVideoThreeOpen: false,
            });
          }
        }
        break;
      case "videoFour":
        if (this.state.dropzoneVideoFour) {
          // file exists
          this.setState(
            {
              newVideoFour: this.state.dropzoneVideoFour,
              newVideoFourUrl: this.state.dropzoneVideoFourUrl,
              imageCropped: true,
              videoFour: this.state.dropzoneVideoFour,
              videoFourChanged: true,
              cropImageVideoFourOpen: false,
              videoFourLink: null,
            },
            () => {
              this.trackChanges();
            }
          );
        } else {
          // file does not exist check link
          if (this.state.dropzoneVideoFourLink !== "") {
            // link exists
            this.setState(
              {
                newVideoFourUrl: this.state.dropzoneVideoFourLink,
                imageCropped: true,
                videoFourLink: this.state.dropzoneVideoFourLink,
                videoFourChanged: true,
                cropImageVideoFourOpen: false,
              },
              () => {
                this.trackChanges();
              }
            );
          } else {
            // file and link do not exist
            this.setState({
              cropImageVideoFourOpen: false,
            });
          }
        }
        break;
      case "videoNew":
        if (this.state.dropzoneVideoNew) {
          // file exists
          if (this.state.videoOne !== "None" || this.state.videoOneLink) {
            // add to video two three or four

            if (this.state.videoTwo !== "None" || this.state.videoTwoLink) {
              // add to video three or four

              if (
                this.state.videoThree !== "None" ||
                this.state.videoThreeLink
              ) {
                // add to video four
                this.setState(
                  {
                    newVideoFour: this.state.dropzoneVideoNew,
                    newVideoFourUrl: this.state.dropzoneVideoNewUrl,
                    imageCropped: true,
                    videoFour: this.state.dropzoneVideoNew,
                    videoFourChanged: true,
                    cropImageVideoNewOpen: false,
                    videoFourLink: null,
                    dropzoneVideoNew: null,
                    dropzoneVideoNewUrl: null,
                    dropzoneVideoNewLink: "",
                  },
                  () => {
                    this.trackChanges();
                  }
                );
              } else {
                // add to video three
                this.setState(
                  {
                    newVideoThree: this.state.dropzoneVideoNew,
                    newVideoThreeUrl: this.state.dropzoneVideoNewUrl,
                    imageCropped: true,
                    videoThree: this.state.dropzoneVideoNew,
                    videoThreeChanged: true,
                    cropImageVideoNewOpen: false,
                    videoThreeLink: null,
                    dropzoneVideoNew: null,
                    dropzoneVideoNewUrl: null,
                    dropzoneVideoNewLink: "",
                  },
                  () => {
                    this.trackChanges();
                  }
                );
              }
            } else {
              // add to video two
              this.setState(
                {
                  newVideoTwo: this.state.dropzoneVideoNew,
                  newVideoTwoUrl: this.state.dropzoneVideoNewUrl,
                  imageCropped: true,
                  videoTwo: this.state.dropzoneVideoNew,
                  videoTwoChanged: true,
                  cropImageVideoNewOpen: false,
                  videoTwoLink: null,
                  dropzoneVideoNew: null,
                  dropzoneVideoNewUrl: null,
                  dropzoneVideoNewLink: "",
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          } else {
            // add to video one
            this.setState(
              {
                newVideoOne: this.state.dropzoneVideoNew,
                newVideoOneUrl: this.state.dropzoneVideoNewUrl,
                imageCropped: true,
                videoOne: this.state.dropzoneVideoNew,
                videoOneChanged: true,
                cropImageVideoNewOpen: false,
                videoOneLink: null,
                dropzoneVideoNew: null,
                dropzoneVideoNewUrl: null,
                dropzoneVideoNewLink: "",
              },
              () => {
                this.trackChanges();
              }
            );
          }
        } else {
          // file does not exist check link
          if (this.state.dropzoneVideoNewLink !== "") {
            // link exists
            if (this.state.videoOne !== "None" || this.state.videoOneLink) {
              // add to video two three or four

              if (this.state.videoTwo !== "None" || this.state.videoTwoLink) {
                // add to video three or four

                if (
                  this.state.videoThree !== "None" ||
                  this.state.videoThreeLink
                ) {
                  // add to video four

                  this.setState(
                    {
                      newVideoFourUrl: this.state.dropzoneVideoNewLink,
                      imageCropped: true,
                      videoFourLink: this.state.dropzoneVideoNewLink,
                      videoFourChanged: true,
                      cropImageVideoNewOpen: false,
                      dropzoneVideoNew: null,
                      dropzoneVideoNewUrl: null,
                      dropzoneVideoNewLink: "",
                    },
                    () => {
                      this.trackChanges();
                    }
                  );
                } else {
                  // add to video three
                  this.setState(
                    {
                      newVideoThreeUrl: this.state.dropzoneVideoNewLink,
                      imageCropped: true,
                      videoThreeLink: this.state.dropzoneVideoNewLink,
                      videoThreeChanged: true,
                      cropImageVideoNewOpen: false,
                      dropzoneVideoNew: null,
                      dropzoneVideoNewUrl: null,
                      dropzoneVideoNewLink: "",
                    },
                    () => {
                      this.trackChanges();
                    }
                  );
                }
              } else {
                // add to video two
                this.setState(
                  {
                    newVideoTwoUrl: this.state.dropzoneVideoNewLink,
                    imageCropped: true,
                    videoTwoLink: this.state.dropzoneVideoNewLink,
                    videoTwoChanged: true,
                    cropImageVideoNewOpen: false,
                    dropzoneVideoNew: null,
                    dropzoneVideoNewUrl: null,
                    dropzoneVideoNewLink: "",
                  },
                  () => {
                    this.trackChanges();
                  }
                );
              }
            } else {
              // add to video one
              this.setState(
                {
                  newVideoOneUrl: this.state.dropzoneVideoNewLink,
                  imageCropped: true,
                  videoOneLink: this.state.dropzoneVideoNewLink,
                  videoOneChanged: true,
                  cropImageVideoNewOpen: false,
                  dropzoneVideoNew: null,
                  dropzoneVideoNewUrl: null,
                  dropzoneVideoNewLink: "",
                },
                () => {
                  this.trackChanges();
                }
              );
            }
          } else {
            // file and link do not exist
            this.setState({
              cropImageVideoNewOpen: false,
            });
          }
        }
        break;
      default:
        this.setState({
          cropImageVideoOneOpen: false,
          cropImageVideoTwoOpen: false,
          cropImageVideoThreeOpen: false,
          cropImageVideoFourOpen: false,
          cropImageVideoNewOpen: false,
        });
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.manageEvents) {
      this.props.updateAthleteEvents(this.state, this.props.match.params.id);
    } else {
      this.props.updateAthlete(this.state, this.props.match.params.id);
    }
  };

  render() {
    const { auth, superAdmin } = this.props;
    const routerUserId = this.props.match.params.id;
    const animation = "scale";
    const duration = 500;

    // if ids do not match and NOT super admin
    if (routerUserId !== auth.uid && !superAdmin) {
      return <Redirect to="/login" />;
    } else {
      if (this.state.deleteRedirect) {
        return <Redirect to="/super-admin" />;
      }

      let manageEvents = null;

      let formEventOneName = null;
      let formEventOneUrl = null;
      let formEventTwoName = null;
      let formEventTwoUrl = null;
      let formEventThreeName = null;
      let formEventThreeUrl = null;
      let formEventFourName = null;
      let formEventFourUrl = null;
      let formEventFiveName = null;
      let formEventFiveUrl = null;
      let formEventSixName = null;
      let formEventSixUrl = null;

      let athleteDetails = null;
      let formThumbnail = null;
      let formFirstName = null;
      let formLastName = null;
      let formHometown = null;
      let formClass = null;
      let formSport = null;
      let formCommitted = null;

      let formCommittedSchool = null;

      let formPrimaryPosition = null;
      let formSecondaryPosition = null;
      let formBats = null;
      let formThrows = null;
      let formParentOneFirst = null;
      let formParentTwoFirst = null;
      let formParentOneLast = null;
      let formParentTwoLast = null;
      let formClubName = null;
      let formClubTeamName = null;
      let formJersey = null;
      let formHeight = null;
      let formWeight = null;
      let formNcaaId = null;
      let formSpecialtyMetrics = null;
      let primaryPositionLabel = null;
      let secondaryPositionLabel = null;
      let batsLabel = null;
      let throwsLabel = null;
      let formGpa = null;
      let formAct = null;
      let formSat = null;
      let formClassRank = null;
      let formHighSchoolName = null;
      let formHighSchoolCityState = null;
      let formIntendedMajor = null;
      let formClubCoachName = null;
      let formClubCoachPhone = null;
      let formClubCoachEmail = null;
      let formHighSchoolCoachName = null;
      let formHighSchoolCoachPhone = null;
      let formHighSchoolCoachEmail = null;
      let formHittingCoachName = null;
      let formHittingCoachPhone = null;
      let formHittingCoachEmail = null;
      let formPitchingCoachName = null;
      let formPitchingCoachPhone = null;
      let formPitchingCoachEmail = null;

      let formCatchingCoachName = null;
      let formCatchingCoachPhone = null;
      let formCatchingCoachEmail = null;

      let formSpecialtyCoachName = null;
      let formSpecialtyCoachFocus = null;
      let formSpecialtyCoachPhone = null;
      let formSpecialtyCoachEmail = null;

      let formTwitter = null;
      let formFacebook = null;
      let formInstagram = null;
      let formYouTube = null;
      let formAgl = null;
      let formHudl = null;
      let athleteProfileUpdated = null;
      let saveButton = null;

      let eventsSaveButton = null;
      let eventsAthleteUpdated = null;

      let formAcademicHonorOne = null;
      let formAcademicHonorTwo = null;
      let formAcademicHonorThree = null;
      let formAcademicHonorFour = null;
      let formAcademicHonorFive = null;
      let formAcademicHonorSix = null;
      let formAcademicHonorSeven = null;
      let formAcademicHonorEight = null;
      let formAcademicHonorNine = null;
      let formAcademicHonorTen = null;

      let formAthleticAwardOne = null;
      let formAthleticAwardTwo = null;
      let formAthleticAwardThree = null;
      let formAthleticAwardFour = null;
      let formAthleticAwardFive = null;
      let formAthleticAwardSix = null;
      let formAthleticAwardSeven = null;
      let formAthleticAwardEight = null;
      let formAthleticAwardNine = null;
      let formAthleticAwardTen = null;

      let formAthleticStrengthOne = null;
      let formAthleticStrengthTwo = null;
      let formAthleticStrengthThree = null;
      let formAthleticStrengthFour = null;
      let formAthleticStrengthFive = null;

      let formAthleticExtraOne = null;
      let formAthleticExtraTwo = null;
      let formAthleticExtraThree = null;
      let formAthleticExtraFour = null;
      let formAthleticExtraFive = null;

      let formAthleticHobbyOne = null;
      let formAthleticHobbyTwo = null;
      let formAthleticHobbyThree = null;
      let formAthleticHobbyFour = null;
      let formAthleticHobbyFive = null;

      let formImageOne = null;
      let formImageTwo = null;
      let formImageThree = null;
      let formImageFour = null;
      let formImageFive = null;

      let formImageTranscript = null;
      let formImageSat = null;
      let formImageAct = null;

      let formAthleteCalendar = null;

      let formVideoOne = null;
      let formVideoTwo = null;
      let formVideoThree = null;
      let formVideoFour = null;

      let addImageButton = null;
      let addVideoButton = null;

      let addTranscriptImageButton = null;
      let addSatImageButton = null;
      let addActImageButton = null;

      let deleteAthleteButton = null;
      let eventsPage = null;
      let reminders = null;
      let wikiPage = null;
      let seoPopup = null;
      let seoButton = null;
      let athleteProfileDeleted = null;
      let addImageHighSchoolButton = null;
      let formImageHighSchoolOne = null;
      let formImageHighSchoolTwo = null;
      let formImageHighSchoolThree = null;
      let formImageHighSchoolFour = null;
      let formImageHighSchoolFive = null;
      let formDropzoneVideo = null;
      let formDropzoneVideoLinkLabel = <h3>Add Video Link</h3>;

      let formDropzoneVideoOneLink = (
        <Input
          fluid
          label="https://"
          placeholder="youtube.com"
          id="dropzoneVideoOneLink"
          value={this.state.dropzoneVideoOneLink}
          onChange={this.handleChange}
        />
      );

      let formDropzoneApplyVideoOneButton = (
        <Button
          disabled
          floated="right"
          color="blue"
          id="videoOne"
          onClick={this.handleDropzoneApply}
        >
          Apply
        </Button>
      );
      let formDropzoneOne = (
        <Dropzone onDrop={this.onDropVideoOne}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div className="AdminDropzoneContainer" {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag a video file here, or click to select file</p>
              </div>
            </section>
          )}
        </Dropzone>
      );

      let formDropzoneVideoTwoLink = (
        <Input
          fluid
          label="https://"
          placeholder="youtube.com"
          id="dropzoneVideoTwoLink"
          value={this.state.dropzoneVideoTwoLink}
          onChange={this.handleChange}
        />
      );

      let formDropzoneApplyVideoTwoButton = (
        <Button
          disabled
          floated="right"
          color="blue"
          id="videoTwo"
          onClick={this.handleDropzoneApply}
        >
          Apply
        </Button>
      );

      let formDropzoneTwo = (
        <Dropzone onDrop={this.onDropVideoTwo}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div className="AdminDropzoneContainer" {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag a video file here, or click to select file</p>
              </div>
            </section>
          )}
        </Dropzone>
      );

      let formDropzoneVideoThreeLink = (
        <Input
          fluid
          label="https://"
          placeholder="youtube.com"
          id="dropzoneVideoThreeLink"
          value={this.state.dropzoneVideoThreeLink}
          onChange={this.handleChange}
        />
      );

      let formDropzoneApplyVideoThreeButton = (
        <Button
          disabled
          floated="right"
          color="blue"
          id="videoThree"
          onClick={this.handleDropzoneApply}
        >
          Apply
        </Button>
      );

      let formDropzoneThree = (
        <Dropzone onDrop={this.onDropVideoThree}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div className="AdminDropzoneContainer" {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag a video file here, or click to select file</p>
              </div>
            </section>
          )}
        </Dropzone>
      );

      let formDropzoneVideoFourLink = (
        <Input
          fluid
          label="https://"
          placeholder="youtube.com"
          id="dropzoneVideoFourLink"
          value={this.state.dropzoneVideoFourLink}
          onChange={this.handleChange}
        />
      );

      let formDropzoneApplyVideoFourButton = (
        <Button
          disabled
          floated="right"
          color="blue"
          id="videoFour"
          onClick={this.handleDropzoneApply}
        >
          Apply
        </Button>
      );

      let formDropzoneFour = (
        <Dropzone onDrop={this.onDropVideoFour}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div className="AdminDropzoneContainer" {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag a video file here, or click to select file</p>
              </div>
            </section>
          )}
        </Dropzone>
      );

      let formDropzoneVideoNewLink = (
        <Input
          fluid
          label="https://"
          placeholder="youtube.com"
          id="dropzoneVideoNewLink"
          value={this.state.dropzoneVideoNewLink}
          onChange={this.handleChange}
        />
      );

      let formDropzoneApplyVideoNewButton = (
        <Button
          disabled
          floated="right"
          color="blue"
          id="videoNew"
          onClick={this.handleDropzoneApply}
        >
          Apply
        </Button>
      );

      let formDropzoneNew = (
        <Dropzone onDrop={this.onDropVideoNew}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div className="AdminDropzoneContainer" {...getRootProps()}>
                <input {...getInputProps()} />
                <p>Drag a video file here, or click to select file</p>
              </div>
            </section>
          )}
        </Dropzone>
      );

      if (
        this.props.athlete &&
        this.props.adminCoachList &&
        this.props.adminSocialList &&
        this.props.adminAwardsList &&
        this.props.adminImagesList &&
        this.props.adminVideoList &&
        this.state.propsLoadedToState &&
        this.props.adminSchoolsList
      ) {
        if (superAdmin) {
          if (this.props.athlete.profilePublic) {
            deleteAthleteButton = (
              <Button
                icon
                labelPosition="left"
                color="red"
                name="deleteButton"
                onClick={this.handleClick}
              >
                <Icon name="user delete" />
                Archive athlete
              </Button>
            );
          } else {
            deleteAthleteButton = (
              <Button
                disabled
                icon
                labelPosition="left"
                color="red"
                name="deleteButton"
                onClick={this.handleClick}
              >
                <Icon name="user delete" />
                Archive athlete
              </Button>
            );
          }
        } else {
          deleteAthleteButton = null;
        }
        if (!superAdmin) {
          if (this.props.athlete.profilePublic) {
            eventsPage = (
              <Link to={`/admin/${this.props.auth.uid}/events`}>
                <Button icon labelPosition="left" color="orange">
                  <Icon name="list" />
                  Events
                </Button>
              </Link>
            );
          } else {
            eventsPage = (
              <Button
                disabled
                icon="list"
                labelPosition="left"
                color="aqua"
                content="Events"
              />
            );
          }
        } else {
          eventsPage = null;
        }
        if (!superAdmin) {
          if (this.props.athlete.profilePublic) {
            // Pankaj Bhai Here .
            reminders = (
              <Button
                labelPosition="left"
                color="black"
                name="advocatesButton"
                icon="bell"
                content="Reminders"
                onClick={() =>
                  this.setState({
                    remindersModal: !this.state.remindersModal,
                  })
                }
              />
            );
          } else {
            reminders = (
              <Button
                disabled
                icon="bell"
                labelPosition="left"
                color="black"
                content="Reminders"
              />
            );
          }
        } else {
          reminders = null;
        }
        if (!superAdmin) {
          if (this.props.athlete.profilePublic) {
            wikiPage = (
              <Link to={`/admin/${this.props.auth.uid}/wikis`}>
                <Button
                  icon="wikipedia w"
                  labelPosition="left"
                  color="grey"
                  name="editedButton"
                  content="Wiki & Info"
                />
              </Link>
            );
          } else {
            wikiPage = (
              <Button
                disabled
                icon="wikipedia w"
                labelPosition="left"
                color="red"
                name="editedButton"
                content="Wiki & Info"
              />
            );
          }
        } else {
          wikiPage = null;
        }
        if (superAdmin) {
          if (this.props.athlete.profilePublic) {
            seoButton = (
              <Button
                icon
                labelPosition="left"
                color="teal"
                name="seoButton"
                onClick={() => {
                  this.setState({
                    seoPopup: !this.state.seoPopup,
                  });
                }}
              >
                <Icon name="tag" />
                SEO Tags
              </Button>
            );
          } else {
            seoButton = (
              <Button
                disabled
                icon
                labelPosition="left"
                color="teal"
                name="seoButton"
              >
                <Icon name="tag" />
                SEO Tags
              </Button>
            );
          }
        } else {
          seoButton = null;
        }

        if (this.props.athlete.thumbnail !== "None") {
          formThumbnail = (
            <img src={this.props.athlete.thumbnail} alt="Athlete Thumbnail" />
          );
        } else {
          formThumbnail = (
            <img src={require("../images/user.svg").default} alt="User Icon" />
          );
        }

        if (this.props.adminImagesList.imageOne !== "None") {
          formImageOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageOne}
                  alt="Athlete One"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageOne")}
                />
              </div>
            </div>
          );
        } else {
          formImageOne = null;
        }
        if (this.props.adminImagesList.imageTwo !== "None") {
          formImageTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageTwo}
                  alt="Athlete Two"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageTwo")}
                />
              </div>
            </div>
          );
        } else {
          formImageTwo = null;
        }

        if (this.props.adminImagesList.imageThree !== "None") {
          formImageThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageThree}
                  alt="Athlete Three"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageThree")}
                />
              </div>
            </div>
          );
        } else {
          formImageThree = null;
        }

        if (this.props.adminImagesList.imageFour !== "None") {
          formImageFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageFour}
                  alt="Athlete Four"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageFour")}
                />
              </div>
            </div>
          );
        } else {
          formImageFour = null;
        }

        if (this.props.adminImagesList.imageFive !== "None") {
          formImageFive = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageFive}
                  alt="Athlete Five"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageFive")}
                />
              </div>
            </div>
          );
        } else {
          formImageFive = null;
        }

        if (this.props.adminImagesList.imageHighSchoolOne !== "None") {
          formImageHighSchoolOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageHighSchoolOne}
                  alt="School Schedule One"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="eye"
                  onClick={this.showHighScheduleOneImage}
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolOne")}
                />
              </div>
            </div>
          );
        } else {
          formImageHighSchoolOne = null;
        }
        if (this.props.adminImagesList.imageHighSchoolTwo !== "None") {
          formImageHighSchoolTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageHighSchoolTwo}
                  alt="School Schedule Two"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="eye"
                  onClick={this.showHighScheduleTwoImage}
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolTwo")}
                />
              </div>
            </div>
          );
        } else {
          formImageHighSchoolTwo = null;
        }
        if (this.props.adminImagesList.imageHighSchoolThree !== "None") {
          formImageHighSchoolThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageHighSchoolThree}
                  alt="School Schedule Three"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="eye"
                  onClick={this.showHighScheduleThreeImage}
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolThree")}
                />
              </div>
            </div>
          );
        } else {
          formImageHighSchoolThree = null;
        }
        if (this.props.adminImagesList.imageHighSchoolFour !== "None") {
          formImageHighSchoolFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageHighSchoolFour}
                  alt="School Schedule Four"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="eye"
                  onClick={this.showHighScheduleFourImage}
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolFour")}
                />
              </div>
            </div>
          );
        } else {
          formImageHighSchoolFour = null;
        }
        if (this.props.adminImagesList.imageHighSchoolFive !== "None") {
          formImageHighSchoolFive = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  src={this.props.adminImagesList.imageHighSchoolFive}
                  alt="School Schedule Five"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="eye"
                  onClick={this.showHighScheduleFiveImage}
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolFive")}
                />
              </div>
            </div>
          );
        } else {
          formImageHighSchoolFive = null;
        }

        if (
          this.props.adminImagesList.transcriptImage &&
          this.props.adminImagesList.transcriptImage !== "" &&
          this.props.adminImagesList.transcriptImage !== "None"
        ) {
          formImageTranscript = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  src={this.props.adminImagesList.transcriptImage}
                  alt="Athlete Transcript"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content="Transcript"
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="eye"
                      onClick={() =>
                        openURL(this.props.adminImagesList.transcriptImage)
                      }
                    />
                  }
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageTranscript")}
                />
              </div>
            </div>
          );
        } else {
          formImageTranscript = null;
        }
        if (
          this.props.adminImagesList.satScoreImage &&
          this.props.adminImagesList.satScoreImage !== "" &&
          this.props.adminImagesList.satScoreImage !== "None"
        ) {
          formImageSat = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  src={this.props.adminImagesList.satScoreImage}
                  alt="Athlete SAT"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content="SAT"
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="eye"
                      onClick={() =>
                        openURL(this.props.adminImagesList.satScoreImage)
                      }
                    />
                  }
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageSat")}
                />
              </div>
            </div>
          );
        } else {
          formImageSat = null;
        }

        if (
          this.props.adminImagesList.actScoreImage &&
          this.props.adminImagesList.actScoreImage !== "" &&
          this.props.adminImagesList.actScoreImage !== "None"
        ) {
          formImageAct = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  src={this.props.adminImagesList.actScoreImage}
                  alt="Athlete ACT"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content="ACT"
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="eye"
                      onClick={() =>
                        openURL(this.props.adminImagesList.actScoreImage)
                      }
                    />
                  }
                />
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageAct")}
                />
              </div>
            </div>
          );
        } else {
          formImageAct = null;
        }

        if (this.props.adminVideoList.videoOne !== "None") {
          formVideoOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.props.adminVideoList.videoOne}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoOneOpen: true,
                    })
                  }
                />
              </div>
              <Input
                className="videoTitle"
                fluid
                placeholder="Video One Title"
                id="videoOneTitle"
                value={this.state.videoOneTitle}
                onChange={this.videoTitleChange}
              />
            </div>
          );
        } else {
          formVideoOne = null;
        }

        if (this.props.adminVideoList.videoTwo !== "None") {
          formVideoTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.props.adminVideoList.videoTwo}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoTwoOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video Two Title"
                id="videoTwoTitle"
                value={this.state.videoTwoTitle}
                onChange={this.videoTitleChange}
              />
            </div>
          );
        } else {
          formVideoTwo = null;
        }

        if (this.props.adminVideoList.videoThree !== "None") {
          formVideoThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.props.adminVideoList.videoThree}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoThreeOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video Three Title"
                id="videoThreeTitle"
                value={this.state.videoThreeTitle}
                onChange={this.videoTitleChange}
              />
            </div>
          );
        } else {
          formVideoThree = null;
        }

        if (this.props.adminVideoList.videoFour !== "None") {
          formVideoFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.props.adminVideoList.videoFour}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoFourOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                label="https://"
                placeholder="Video Four Title"
                id="videoFourTitle"
                value={this.state.videoFourTitle}
                onChange={this.videoTitleChange}
              />
            </div>
          );
        } else {
          formVideoFour = null;
        }

        formFirstName = (
          <input
            placeholder="None"
            id="firstName"
            value={this.state.firstName}
            onChange={this.handleChange}
          />
        );
        initialFirstName = this.props.athlete.firstName;

        formLastName = (
          <input
            placeholder="None"
            id="lastName"
            value={this.state.lastName}
            onChange={this.handleChange}
          />
        );
        initialLastName = this.props.athlete.lastName;

        formHometown = (
          <input
            placeholder="Keller, TX"
            id="hometown"
            value={this.state.hometown}
            onChange={this.handleChange}
          />
        );
        initialHometown = this.props.athlete.hometown;

        if (this.props.athlete.class !== 0) {
          formClass = (
            <Dropdown
              options={classOptions}
              selection
              fluid
              placeholder="None"
              value={this.state.class}
              name="classDropdown"
              onChange={this.handleDropdownChange}
            />
          );
        } else {
          formClass = (
            <Dropdown
              options={classOptions}
              selection
              fluid
              placeholder="None"
              name="classDropdown"
              onChange={this.handleDropdownChange}
            />
          );
        }
        initialClass = this.props.athlete.class;
        formSport = (
          <SportList
            value={this.state.sport}
            onChange={this.handleDropdownChange}
            name="sportDropdown"
          />
        );
        initialSport = this.props.athlete.sport;
        formCommitted = (
          <Dropdown
            options={committedOptions}
            selection
            fluid
            placeholder="Committed"
            value={this.state.committedValue}
            name="committedDropdown"
            onChange={this.handleDropdownChange}
          />
        );
        initialCommitted = this.props.athlete.committed;

        const schools = this.props.adminSchoolsList;

        if (this.state.committedValue === "Committed") {
          formCommittedSchool = (
            <Form.Field>
              <label>Committed School</label>
              <Dropdown
                search
                options={schools.map((school) => {
                  return {
                    key: school.id,
                    text: school.name,
                    value: school.name,
                  };
                })}
                selection
                fluid
                placeholder="None"
                value={this.state.committedSchool}
                name="schoolDropdown"
                onChange={this.handleDropdownChange}
              />
            </Form.Field>
          );
        } else {
          formCommittedSchool = null;
        }
        if (this.state.sport === "Football") {
          formPrimaryPosition = (
            <Dropdown
              options={footballPositionOptions}
              selection
              fluid
              placeholder="None"
              value={this.state.primaryPosition}
              name="primaryPositionDropdown"
              onChange={this.handleDropdownChange}
            />
          );
          primaryPositionLabel = (
            <label>
              <div className="AdminNcaaIdContainer">
                Primary Position
                {/* This Handles to show and hide the Add new Position Modal */}
                <AddNewPositionIcon
                  onClick={this.handleShowNewPositionFieldOpen}
                />
              </div>
            </label>
          );
          initialPrimaryPosition = this.props.athlete.primaryPosition;

          formSecondaryPosition = (
            <Dropdown
              options={footballPositionOptions}
              selection
              fluid
              placeholder="None"
              value={this.state.secondaryPosition}
              name="secondaryPositionDropdown"
              onChange={this.handleDropdownChange}
            />
          );
          secondaryPositionLabel = <label>Secondary Position</label>;
          initialSecondaryPosition = this.props.athlete.secondaryPosition;
        } else {
          formPrimaryPosition = (
            <PositionList
              value={this.state.primaryPosition}
              name="primaryPositionDropdown"
              onChange={this.handleDropdownChange}
              sport={this.state.sport}
              disabled={!this.state.sport}
            />
          );
          primaryPositionLabel = (
            <label>
              <div className="AdminNcaaIdContainer">
                Primary Position
                <AddNewPositionIcon
                  onClick={this.handleShowNewPositionFieldOpen} // it is on line number 1988
                />
              </div>
            </label>
          );
          initialPrimaryPosition = this.props.athlete.primaryPosition;

          formSecondaryPosition = (
            <PositionList
              value={this.state.secondaryPosition}
              name="secondaryPositionDropdown"
              onChange={this.handleDropdownChange}
              sport={this.state.sport}
              disabled={!this.state.sport}
              placeholder="None"
            />
          );
          secondaryPositionLabel = <label>Secondary Position</label>;
          initialSecondaryPosition = this.props.athlete.secondaryPosition;
        }

        formBats = (
          <Dropdown
            options={batsOptions}
            selection
            fluid
            placeholder="Right"
            value={this.state.bats}
            name="batsDropdown"
            onChange={this.handleDropdownChange}
          />
        );
        batsLabel = <label>Bats</label>;
        initialBats = this.props.athlete.bats;

        formThrows = (
          <Dropdown
            options={throwsOptions}
            selection
            fluid
            placeholder="Right"
            value={this.state.throws}
            name="throwsDropdown"
            onChange={this.handleDropdownChange}
          />
        );
        throwsLabel = <label>Throws</label>;
        initialThrows = this.props.athlete.throws;

        formParentOneFirst = (
          <input
            placeholder="None"
            id="parentOneFirstName"
            value={this.state.parentOneFirstName}
            onChange={this.handleChange}
          />
        );
        initialParentOneFirstName = this.props.athlete.parentOneFirstName;

        formParentTwoFirst = (
          <input
            placeholder="None"
            id="parentTwoFirstName"
            value={this.state.parentTwoFirstName}
            onChange={this.handleChange}
          />
        );
        initialParentTwoFirstName = this.props.athlete.parentTwoFirstName;

        formParentOneLast = (
          <input
            placeholder="None"
            id="parentOneLastName"
            value={this.state.parentOneLastName}
            onChange={this.handleChange}
          />
        );
        initialParentOneLastName = this.props.athlete.parentOneLastName;

        formParentTwoLast = (
          <input
            placeholder="None"
            id="parentTwoLastName"
            value={this.state.parentTwoLastName}
            onChange={this.handleChange}
          />
        );
        initialParentTwoLastName = this.props.athlete.parentTwoLastName;

        formClubName = (
          <input
            placeholder="None"
            id="clubName"
            value={this.state.clubName}
            onChange={this.handleChange}
          />
        );
        initialClubName = this.props.athlete.clubName;

        formClubTeamName = (
          <input
            placeholder="None"
            id="clubTeamName"
            value={this.state.clubTeamName}
            onChange={this.handleChange}
          />
        );
        initialClubTeamName = this.props.athlete.clubTeamName;

        formJersey = (
          <input
            placeholder="9"
            id="jersey"
            value={this.state.jersey}
            onChange={this.handleChange}
          />
        );
        initialJersey = this.props.athlete.jersey;

        formHeight = (
          <input
            placeholder="5'0&quot;"
            id="height"
            value={this.state.height}
            onChange={this.handleChange}
          />
        );
        initialHeight = this.props.athlete.height;

        if (this.state.weightError) {
          formWeight = (
            <Form.Input
              placeholder="None"
              id="weight"
              value={this.state.weight}
              onChange={this.handleChange}
              error={{ content: "Weight must be a number", pointing: "below" }}
            />
          );
        } else {
          formWeight = (
            <input
              placeholder="None"
              id="weight"
              value={this.state.weight}
              onChange={this.handleChange}
            />
          );
        }
        initialWeight = this.props.athlete.weight;

        if (this.state.ncaaIdError) {
          formNcaaId = (
            <Form.Input
              placeholder="1234567890"
              id="ncaaId"
              value={this.state.ncaaId}
              onChange={this.handleChange}
              error={{
                content: "NCAA / NAIA# must be a number",
                pointing: "below",
              }}
            />
          );
        } else {
          formNcaaId = (
            <input
              placeholder="1234567890"
              id="ncaaId"
              value={this.state.ncaaId}
              onChange={this.handleChange}
            />
          );
        }
        initialNcaaId = this.props.athlete.ncaaId;

        if (this.state.gpaError) {
          formGpa = (
            <Form.Input
              placeholder="None"
              id="gpa"
              value={this.state.gpa}
              onChange={this.handleChange}
              error={{ content: "GPA must be a number", pointing: "below" }}
            />
          );
        } else {
          formGpa = (
            <input
              placeholder="None"
              id="gpa"
              value={this.state.gpa}
              onChange={this.handleChange}
            />
          );
        }
        initialGpa = this.props.athlete.gpa;

        if (this.state.actError) {
          formAct = (
            <Form.Input
              placeholder="None"
              id="act"
              value={this.state.act}
              onChange={this.handleChange}
              error={{
                content: "ACT must be a number between 1 and 36",
                pointing: "below",
              }}
            />
          );
        } else {
          formAct = (
            <input
              placeholder="None"
              id="act"
              value={this.state.act}
              onChange={this.handleChange}
            />
          );
        }
        initialAct = this.props.athlete.act;

        if (this.state.satError) {
          formSat = (
            <Form.Input
              placeholder="None"
              id="sat"
              value={this.state.sat}
              onChange={this.handleChange}
              error={{
                content: "SAT must be a number between 1 and 1600",
                pointing: "below",
              }}
            />
          );
        } else {
          formSat = (
            <input
              placeholder="None"
              id="sat"
              value={this.state.sat}
              onChange={this.handleChange}
            />
          );
        }
        initialSat = this.props.athlete.sat;

        formClassRank = (
          <input
            placeholder="None"
            id="classRank"
            value={this.state.classRank}
            onChange={this.handleChange}
          />
        );
        initialClassRank = this.props.athlete.classRank;

        formHighSchoolName = (
          <input
            placeholder="None"
            id="highSchoolName"
            value={this.state.highSchoolName}
            onChange={this.handleChange}
          />
        );
        initialHighSchoolName = this.props.athlete.highSchoolName;

        formHighSchoolCityState = (
          <input
            placeholder="Keller, TX"
            id="highSchoolCityState"
            value={this.state.highSchoolCityState}
            onChange={this.handleChange}
          />
        );
        initialHighSchoolCityState = this.props.athlete.highSchoolCityState;

        formIntendedMajor = (
          <input
            placeholder="None"
            id="intendedMajor"
            value={this.state.intendedMajor}
            onChange={this.handleChange}
          />
        );
        initialIntendedMajor = this.props.athlete.intendedMajor;

        formClubCoachName = (
          <input
            placeholder="None"
            id="clubCoachName"
            value={this.state.clubCoachName}
            onChange={this.handleChange}
          />
        );
        initialClubCoachName = this.props.adminCoachList.clubCoachName;

        if (this.state.clubCoachPhoneError) {
          formClubCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="clubCoachPhone"
              value={this.state.clubCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formClubCoachPhone = (
            <input
              placeholder="9496339944"
              id="clubCoachPhone"
              value={this.state.clubCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialClubCoachPhone = this.props.adminCoachList.clubCoachPhone;

        formClubCoachEmail = (
          <input
            placeholder="None"
            id="clubCoachEmail"
            value={this.state.clubCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialClubCoachEmail = this.props.adminCoachList.clubCoachEmail;

        formHighSchoolCoachName = (
          <input
            placeholder="None"
            id="highSchoolCoachName"
            value={this.state.highSchoolCoachName}
            onChange={this.handleChange}
          />
        );
        initialHighSchoolCoachName =
          this.props.adminCoachList.highSchoolCoachName;

        if (this.state.highSchoolCoachPhoneError) {
          formHighSchoolCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="highSchoolCoachPhone"
              value={this.state.highSchoolCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formHighSchoolCoachPhone = (
            <input
              placeholder="9496339944"
              id="highSchoolCoachPhone"
              value={this.state.highSchoolCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialHighSchoolCoachPhone =
          this.props.adminCoachList.highSchoolCoachPhone;

        formHighSchoolCoachEmail = (
          <input
            placeholder="None"
            id="highSchoolCoachEmail"
            value={this.state.highSchoolCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialHighSchoolCoachEmail =
          this.props.adminCoachList.highSchoolCoachEmail;

        formHittingCoachName = (
          <input
            placeholder="None"
            id="hittingCoachName"
            value={this.state.hittingCoachName}
            onChange={this.handleChange}
          />
        );
        initialHittingCoachName = this.props.adminCoachList.hittingCoachName;

        if (this.state.hittingCoachPhoneError) {
          formHittingCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="hittingCoachPhone"
              value={this.state.hittingCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formHittingCoachPhone = (
            <input
              placeholder="9496339944"
              id="hittingCoachPhone"
              value={this.state.hittingCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialHittingCoachPhone = this.props.adminCoachList.hittingCoachPhone;

        formHittingCoachEmail = (
          <input
            placeholder="None"
            id="hittingCoachEmail"
            value={this.state.hittingCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialHittingCoachEmail = this.props.adminCoachList.hittingCoachEmail;

        formPitchingCoachName = (
          <input
            placeholder="None"
            id="pitchingCoachName"
            value={this.state.pitchingCoachName}
            onChange={this.handleChange}
          />
        );
        initialPitchingCoachName = this.props.adminCoachList.pitchingCoachName;

        if (this.state.pitchingCoachPhoneError) {
          formPitchingCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="pitchingCoachPhone"
              value={this.state.pitchingCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formPitchingCoachPhone = (
            <input
              placeholder="9496339944"
              id="pitchingCoachPhone"
              value={this.state.pitchingCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialPitchingCoachPhone =
          this.props.adminCoachList.pitchingCoachPhone;

        formPitchingCoachEmail = (
          <input
            placeholder="None"
            id="pitchingCoachEmail"
            value={this.state.pitchingCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialPitchingCoachEmail =
          this.props.adminCoachList.pitchingCoachEmail;

        formCatchingCoachName = (
          <input
            placeholder="None"
            id="catchingCoachName"
            value={this.state.catchingCoachName}
            onChange={this.handleChange}
          />
        );
        initialCatchingCoachName = this.props.adminCoachList.catchingCoachName
          ? this.props.adminCoachList.catchingCoachName
          : "";

        if (this.state.catchingCoachPhoneError) {
          formCatchingCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="catchingCoachPhone"
              value={this.state.catchingCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formCatchingCoachPhone = (
            <input
              placeholder="9496339944"
              id="catchingCoachPhone"
              value={this.state.catchingCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialCatchingCoachPhone = this.props.adminCoachList.catchingCoachPhone
          ? this.props.adminCoachList.catchingCoachPhone
          : "";

        formCatchingCoachEmail = (
          <input
            placeholder="None"
            id="catchingCoachEmail"
            value={this.state.catchingCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialCatchingCoachEmail = this.props.adminCoachList.catchingCoachEmail
          ? this.props.adminCoachList.catchingCoachEmail
          : "";

        formSpecialtyCoachName = (
          <input
            placeholder="None"
            id="specialtyCoachName"
            value={this.state.specialtyCoachName}
            onChange={this.handleChange}
          />
        );
        initialSpecialtyCoachName = this.props.adminCoachList.specialtyCoachName
          ? this.props.adminCoachList.specialtyCoachName
          : "";

        formSpecialtyCoachFocus = (
          <input
            placeholder="i.e. Strength and Conditioning"
            id="specialtyCoachFocus"
            value={this.state.specialtyCoachFocus}
            onChange={this.handleChange}
          />
        );
        initialSpecialtyCoachFocus = this.props.adminCoachList
          .specialtyCoachFocus
          ? this.props.adminCoachList.specialtyCoachFocus
          : "";

        if (this.state.specialtyCoachPhoneError) {
          formSpecialtyCoachPhone = (
            <Form.Input
              placeholder="9496339944"
              id="specialtyCoachPhone"
              value={this.state.specialtyCoachPhone}
              onChange={this.handleChange}
              error={{
                content: "Numbers only please.. no parentheses, dashes, etc.",
                pointing: "below",
              }}
            />
          );
        } else {
          formSpecialtyCoachPhone = (
            <input
              placeholder="9496339944"
              id="specialtyCoachPhone"
              value={this.state.specialtyCoachPhone}
              onChange={this.handleChange}
            />
          );
        }
        initialSpecialtyCoachPhone = this.props.adminCoachList
          .specialtyCoachPhone
          ? this.props.adminCoachList.specialtyCoachPhone
          : "";

        formSpecialtyCoachEmail = (
          <input
            placeholder="None"
            id="specialtyCoachEmail"
            value={this.state.specialtyCoachEmail}
            onChange={this.handleChange}
          />
        );
        initialSpecialtyCoachEmail = this.props.adminCoachList
          .specialtyCoachEmail
          ? this.props.adminCoachList.specialtyCoachEmail
          : "";

        formAthleteCalendar = (
          <input
            placeholder="collegiatesportsadvocate@gmail.com"
            id="athleteCalendar"
            value={this.state.athleteCalendar}
            onChange={this.handleChange}
          />
        );
        initialAthleteCalendar = this.props.adminSocialList.calendar
          ? this.props.adminSocialList.calendar
          : "";

        if (this.state.twitterError) {
          formTwitter = (
            <Form.Input
              placeholder="https://twitter.com"
              id="twitter"
              value={this.state.twitter}
              onChange={this.handleChange}
              error={{
                content:
                  "Paste full link i.e. https://twitter.com/CSA_Athletes",
                pointing: "below",
              }}
            />
          );
        } else {
          formTwitter = (
            <input
              placeholder="https://twitter.com"
              id="twitter"
              value={this.state.twitter}
              onChange={this.handleChange}
            />
          );
        }
        initialTwitter = this.props.adminSocialList.twitter;

        if (this.state.instagramError) {
          formInstagram = (
            <Form.Input
              placeholder="https://www.instagram.com"
              id="instagram"
              value={this.state.instagram}
              onChange={this.handleChange}
              error={{
                content:
                  "Paste full link i.e. https://www.instagram.com/collegiate_sports_advocate",
                pointing: "below",
              }}
            />
          );
        } else {
          formInstagram = (
            <input
              placeholder="https://www.instagram.com"
              id="instagram"
              value={this.state.instagram}
              onChange={this.handleChange}
            />
          );
        }
        initialInstagram = this.props.adminSocialList.twitter;

        if (this.state.facebookError) {
          formFacebook = (
            <Form.Input
              placeholder="https://www.facebook.com"
              id="facebook"
              value={this.state.facebook}
              onChange={this.handleChange}
              error={{
                content:
                  "Paste full link i.e. https://www.facebook.com/collegiatesportsadvocate/",
                pointing: "below",
              }}
            />
          );
        } else {
          formFacebook = (
            <input
              placeholder="https://www.facebook.com"
              id="facebook"
              value={this.state.facebook}
              onChange={this.handleChange}
            />
          );
        }
        initialFacebook = this.props.adminSocialList.facebook;

        if (this.state.youTubeError) {
          formYouTube = (
            <Form.Input
              placeholder="https://www.youtube.com"
              id="youTube"
              value={this.state.youTube}
              onChange={this.handleChange}
              error={{
                content:
                  "Paste full link i.e. https://www.youtube.com/channel/UCq3cZ6roxRhn9Ilk_7WlUhw",
                pointing: "below",
              }}
            />
          );
        } else {
          formYouTube = (
            <input
              placeholder="https://www.youtube.com"
              id="youTube"
              value={this.state.youTube}
              onChange={this.handleChange}
            />
          );
        }
        initialYouTube = this.props.adminSocialList.youTube;

        formAgl = (
          <input
            placeholder="AGL001234"
            id="agl"
            value={this.state.agl}
            onChange={this.handleChange}
          />
        );
        initialAgl = this.props.adminSocialList.agl;

        if (this.state.hudlError) {
          formHudl = (
            <Form.Input
              placeholder="https://www.hudl.com"
              id="hudl"
              value={this.state.hudl}
              onChange={this.handleChange}
              error={{
                content: "Paste full link i.e. https://www.hudl.com/",
                pointing: "below",
              }}
            />
          );
        } else {
          formHudl = (
            <input
              placeholder="https://www.hudl.com"
              id="hudl"
              value={this.state.hudl}
              onChange={this.handleChange}
            />
          );
        }
        initialHudl = this.props.adminSocialList.hudl;

        formSpecialtyMetrics = (
          <input
            placeholder="None"
            id="specialtyMetrics"
            value={this.state.specialtyMetrics}
            onChange={this.handleChange}
          />
        );
        initialSpecialtyMetrics = this.props.athlete.specialtyMetrics;

        formAcademicHonorOne = (
          <input
            placeholder="None"
            id="academicHonorOne"
            value={this.state.academicHonorOne}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorOne = this.props.adminAwardsList.academicHonorOne;

        formAcademicHonorTwo = (
          <input
            placeholder="None"
            id="academicHonorTwo"
            value={this.state.academicHonorTwo}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorTwo = this.props.adminAwardsList.academicHonorTwo;

        formAcademicHonorThree = (
          <input
            placeholder="None"
            id="academicHonorThree"
            value={this.state.academicHonorThree}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorThree =
          this.props.adminAwardsList.academicHonorThree;

        formAcademicHonorFour = (
          <input
            placeholder="None"
            id="academicHonorFour"
            value={this.state.academicHonorFour}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorFour = this.props.adminAwardsList.academicHonorFour;

        formAcademicHonorFive = (
          <input
            placeholder="None"
            id="academicHonorFive"
            value={this.state.academicHonorFive}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorFive = this.props.adminAwardsList.academicHonorFive;

        formAcademicHonorSix = (
          <input
            placeholder="None"
            id="academicHonorSix"
            value={this.state.academicHonorSix}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorSix = this.props.adminAwardsList.academicHonorSix;

        formAcademicHonorSeven = (
          <input
            placeholder="None"
            id="academicHonorSeven"
            value={this.state.academicHonorSeven}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorSeven =
          this.props.adminAwardsList.academicHonorSeven;

        formAcademicHonorEight = (
          <input
            placeholder="None"
            id="academicHonorEight"
            value={this.state.academicHonorEight}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorEight =
          this.props.adminAwardsList.academicHonorEight;

        formAcademicHonorNine = (
          <input
            placeholder="None"
            id="academicHonorNine"
            value={this.state.academicHonorNine}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorNine = this.props.adminAwardsList.academicHonorNine;

        formAcademicHonorTen = (
          <input
            placeholder="None"
            id="academicHonorTen"
            value={this.state.academicHonorTen}
            onChange={this.handleChange}
          />
        );
        initialAcademicHonorTen = this.props.adminAwardsList.academicHonorTen;

        formAthleticAwardOne = (
          <input
            placeholder="None"
            id="athleticAwardOne"
            value={this.state.athleticAwardOne}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardOne = this.props.adminAwardsList.athleticAwardOne;

        formAthleticAwardTwo = (
          <input
            placeholder="None"
            id="athleticAwardTwo"
            value={this.state.athleticAwardTwo}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardTwo = this.props.adminAwardsList.athleticAwardTwo;

        formAthleticAwardThree = (
          <input
            placeholder="None"
            id="athleticAwardThree"
            value={this.state.athleticAwardThree}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardThree =
          this.props.adminAwardsList.athleticAwardThree;

        formAthleticAwardFour = (
          <input
            placeholder="None"
            id="athleticAwardFour"
            value={this.state.athleticAwardFour}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardFour = this.props.adminAwardsList.athleticAwardFour;

        formAthleticAwardFive = (
          <input
            placeholder="None"
            id="athleticAwardFive"
            value={this.state.athleticAwardFive}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardFive = this.props.adminAwardsList.athleticAwardFive;

        formAthleticAwardSix = (
          <input
            placeholder="None"
            id="athleticAwardSix"
            value={this.state.athleticAwardSix}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardSix = this.props.adminAwardsList.athleticAwardSix;

        formAthleticAwardSeven = (
          <input
            placeholder="None"
            id="athleticAwardSeven"
            value={this.state.athleticAwardSeven}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardSeven =
          this.props.adminAwardsList.athleticAwardSeven;

        formAthleticAwardEight = (
          <input
            placeholder="None"
            id="athleticAwardEight"
            value={this.state.athleticAwardEight}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardEight =
          this.props.adminAwardsList.athleticAwardEight;

        formAthleticAwardNine = (
          <input
            placeholder="None"
            id="athleticAwardNine"
            value={this.state.athleticAwardNine}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardNine = this.props.adminAwardsList.athleticAwardNine;

        formAthleticAwardTen = (
          <input
            placeholder="None"
            id="athleticAwardTen"
            value={this.state.athleticAwardTen}
            onChange={this.handleChange}
          />
        );
        initialAthleticAwardTen = this.props.adminAwardsList.athleticAwardTen;

        formAthleticStrengthOne = (
          <input
            placeholder="None"
            id="athleticStrengthOne"
            value={this.state.athleticStrengthOne}
            onChange={this.handleChange}
          />
        );
        initialAthleticStrengthOne = this.props.adminExtrasList.strengthOne;

        formAthleticStrengthTwo = (
          <input
            placeholder="None"
            id="athleticStrengthTwo"
            value={this.state.athleticStrengthTwo}
            onChange={this.handleChange}
          />
        );
        initialAthleticStrengthTwo = this.props.adminExtrasList.strengthTwo;

        formAthleticStrengthThree = (
          <input
            placeholder="None"
            id="athleticStrengthThree"
            value={this.state.athleticStrengthThree}
            onChange={this.handleChange}
          />
        );
        initialAthleticStrengthThree = this.props.adminExtrasList.strengthThree;

        formAthleticStrengthFour = (
          <input
            placeholder="None"
            id="athleticStrengthFour"
            value={this.state.athleticStrengthFour}
            onChange={this.handleChange}
          />
        );
        initialAthleticStrengthFour = this.props.adminExtrasList.strengthFour;

        formAthleticStrengthFive = (
          <input
            placeholder="None"
            id="athleticStrengthFive"
            value={this.state.athleticStrengthFive}
            onChange={this.handleChange}
          />
        );
        initialAthleticStrengthFive = this.props.adminExtrasList.strengthFive;

        formAthleticExtraOne = (
          <input
            placeholder="None"
            id="athleticExtraOne"
            value={this.state.athleticExtraOne}
            onChange={this.handleChange}
          />
        );
        initialAthleticExtraOne = this.props.adminExtrasList.extraOne;

        formAthleticExtraTwo = (
          <input
            placeholder="None"
            id="athleticExtraTwo"
            value={this.state.athleticExtraTwo}
            onChange={this.handleChange}
          />
        );
        initialAthleticExtraTwo = this.props.adminExtrasList.extraTwo;

        formAthleticExtraThree = (
          <input
            placeholder="None"
            id="athleticExtraThree"
            value={this.state.athleticExtraThree}
            onChange={this.handleChange}
          />
        );
        initialAthleticExtraThree = this.props.adminExtrasList.extraThree;

        formAthleticExtraFour = (
          <input
            placeholder="None"
            id="athleticExtraFour"
            value={this.state.athleticExtraFour}
            onChange={this.handleChange}
          />
        );
        initialAthleticExtraFour = this.props.adminExtrasList.extraFour;

        formAthleticExtraFive = (
          <input
            placeholder="None"
            id="athleticExtraFive"
            value={this.state.athleticExtraFive}
            onChange={this.handleChange}
          />
        );
        initialAthleticExtraFive = this.props.adminExtrasList.extraFive;

        formAthleticHobbyOne = (
          <input
            placeholder="None"
            id="athleticHobbyOne"
            value={this.state.athleticHobbyOne}
            onChange={this.handleChange}
          />
        );
        initialAthleticHobbyOne = this.props.adminExtrasList.hobbyOne;

        formAthleticHobbyTwo = (
          <input
            placeholder="None"
            id="athleticHobbyTwo"
            value={this.state.athleticHobbyTwo}
            onChange={this.handleChange}
          />
        );
        initialAthleticHobbyTwo = this.props.adminExtrasList.hobbyTwo;

        formAthleticHobbyThree = (
          <input
            placeholder="None"
            id="athleticHobbyThree"
            value={this.state.athleticHobbyThree}
            onChange={this.handleChange}
          />
        );
        initialAthleticHobbyThree = this.props.adminExtrasList.hobbyThree;

        formAthleticHobbyFour = (
          <input
            placeholder="None"
            id="athleticHobbyFour"
            value={this.state.athleticHobbyFour}
            onChange={this.handleChange}
          />
        );
        initialAthleticHobbyFour = this.props.adminExtrasList.hobbyFour;

        formAthleticHobbyFive = (
          <input
            placeholder="None"
            id="athleticHobbyFive"
            value={this.state.athleticHobbyFive}
            onChange={this.handleChange}
          />
        );
        initialAthleticHobbyFive = this.props.adminExtrasList.hobbyFive;

        formEventOneName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventOneName"
            value={this.state.eventOneName}
            onChange={this.handleChange}
          />
        );
        formEventOneUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventOneUrl"
            value={this.state.eventOneUrl}
            onChange={this.handleChange}
          />
        );

        formEventTwoName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventTwoName"
            value={this.state.eventTwoName}
            onChange={this.handleChange}
          />
        );
        formEventTwoUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventTwoUrl"
            value={this.state.eventTwoUrl}
            onChange={this.handleChange}
          />
        );

        formEventThreeName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventThreeName"
            value={this.state.eventThreeName}
            onChange={this.handleChange}
          />
        );
        formEventThreeUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventThreeUrl"
            value={this.state.eventThreeUrl}
            onChange={this.handleChange}
          />
        );

        formEventFourName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventFourName"
            value={this.state.eventFourName}
            onChange={this.handleChange}
          />
        );
        formEventFourUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventFourUrl"
            value={this.state.eventFourUrl}
            onChange={this.handleChange}
          />
        );

        formEventFiveName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventFiveName"
            value={this.state.eventFiveName}
            onChange={this.handleChange}
          />
        );
        formEventFiveUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventFiveUrl"
            value={this.state.eventFiveUrl}
            onChange={this.handleChange}
          />
        );

        formEventSixName = (
          <input
            placeholder="Colorado Sparkler"
            id="eventSixName"
            value={this.state.eventSixName}
            onChange={this.handleChange}
          />
        );
        formEventSixUrl = (
          <input
            placeholder="https://www.cosparkfire.com"
            id="eventSixUrl"
            value={this.state.eventSixUrl}
            onChange={this.handleChange}
          />
        );

        if (this.state.videoFour !== "None") {
          addVideoButton = (
            <Button
              floated="right"
              disabled
              name="addPhotosButton"
              content="Add Video"
              labelPosition="right"
              icon="video play"
              onClick={() =>
                this.setState({
                  cropImageVideoNewOpen: true,
                })
              }
            />
          );
        } else {
          addVideoButton = (
            <Button
              floated="right"
              name="addPhotosButton"
              content="Add Video"
              labelPosition="right"
              icon="video play"
              onClick={() =>
                this.setState({
                  cropImageVideoNewOpen: true,
                })
              }
            />
          );
        }

        if (
          this.state.sport === "Soccer" ||
          this.props.athlete.sport === "Soccer"
        ) {
          formPrimaryPosition = null;
          formSecondaryPosition = null;
          formBats = null;
          formThrows = null;
          primaryPositionLabel = null;
          secondaryPositionLabel = null;
          batsLabel = null;
          throwsLabel = null;
        }
      } else if (this.props.role === "advocate") {
        // return <AthleteDetails adminId={this.state.key} />;
        return <AdvocateDetails id={this.props.advocateKey} />;
      } else if (this.props.role === "newUser") {
        // return <AthleteDetails adminId={this.state.key} />;
        return <Redirect to={`/new-registration/${this.props.newUserKey}`} />;
      } else {
        return (
          <div className="SpinnerBackground">
            <div className="SpinnerContainer">
              <Loader size="large" active inline="centered" />
            </div>
          </div>
        );
      }

      if (this.state.imageFive && this.state.imageFive !== "None") {
        addImageButton = (
          <Button
            floated="right"
            disabled
            name="addPhotosButton"
            content="Add Photos"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageNew")}
          />
        );
      } else {
        addImageButton = (
          <Button
            floated="right"
            name="addPhotosButton"
            content="Add Photos"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageNew")}
          />
        );
      }
      if (this.state.transcriptImage && this.state.transcriptImage !== "None") {
        addTranscriptImageButton = (
          <Button
            disabled
            name="addTranscriptButton"
            content="Add Transcript"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageTranscript")}
          />
        );
      } else {
        addTranscriptImageButton = (
          <Button
            name="addTranscriptButton"
            content="Add Transcript"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageTranscript")}
          />
        );
      }

      if (this.state.satScoreImage && this.state.satScoreImage !== "None") {
        addSatImageButton = (
          <Button
            disabled
            name="addSatButton"
            content="Add SAT"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageSat")}
          />
        );
      } else {
        addSatImageButton = (
          <Button
            name="addSatButton"
            content="Add SAT"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageSat")}
          />
        );
      }

      if (
        this.state.imageHighSchoolFive &&
        this.state.satScoreImage !== "None"
      ) {
        // if it is undefined it is true then it'll will go to disabled else it'll return true
        addImageHighSchoolButton = (
          <Button
            floated="right"
            disabled
            name="addPhotosHighSchoolButton"
            content="Add Photos"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("school")}
          />
        );
      } else {
        addImageHighSchoolButton = (
          <Button
            floated="right"
            name="addPhotosHighSchoolButton"
            content="Add Photos"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("school")}
          />
        );
      }

      if (this.state.actScoreImage && this.state.actScoreImage !== "None") {
        addActImageButton = (
          <Button
            disabled
            name="addActButton"
            content="Add ACT"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageAct")}
          />
        );
      } else {
        addActImageButton = (
          <Button
            name="addActButton"
            content="Add ACT"
            labelPosition="right"
            icon="image"
            onClick={() => this.upload("imageAct")}
          />
        );
      }

      if (this.state.dropzoneVideoOneUrl) {
        formDropzoneVideo = (
          <div className="AdminAthleteDropzoneVideoContainer">
            <div className="AdminAthleteDropzoneVideoCard">
              <ReactPlayer
                controls={true}
                className="react-player"
                url={this.state.dropzoneVideoOneUrl}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        );
        formDropzoneOne = null;
        formDropzoneVideoLinkLabel = null;
        formDropzoneVideoOneLink = null;
      }

      if (this.state.dropzoneVideoTwoUrl) {
        formDropzoneVideo = (
          <div className="AdminAthleteDropzoneVideoContainer">
            <div className="AdminAthleteDropzoneVideoCard">
              <ReactPlayer
                controls={true}
                className="react-player"
                url={this.state.dropzoneVideoTwoUrl}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        );
        formDropzoneTwo = null;
        formDropzoneVideoLinkLabel = null;
        formDropzoneVideoTwoLink = null;
      }

      if (this.state.dropzoneVideoThreeUrl) {
        formDropzoneVideo = (
          <div className="AdminAthleteDropzoneVideoContainer">
            <div className="AdminAthleteDropzoneVideoCard">
              <ReactPlayer
                controls={true}
                className="react-player"
                url={this.state.dropzoneVideoThreeUrl}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        );
        formDropzoneThree = null;
        formDropzoneVideoLinkLabel = null;
        formDropzoneVideoThreeLink = null;
      }

      if (this.state.dropzoneVideoFourUrl) {
        formDropzoneVideo = (
          <div className="AdminAthleteDropzoneVideoContainer">
            <div className="AdminAthleteDropzoneVideoCard">
              <ReactPlayer
                controls={true}
                className="react-player"
                url={this.state.dropzoneVideoFourUrl}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        );
        formDropzoneFour = null;
        formDropzoneVideoLinkLabel = null;
        formDropzoneVideoFourLink = null;
      }

      if (this.state.dropzoneVideoNewUrl) {
        formDropzoneVideo = (
          <div className="AdminAthleteDropzoneVideoContainer">
            <div className="AdminAthleteDropzoneVideoCard">
              <ReactPlayer
                controls={true}
                className="react-player"
                url={this.state.dropzoneVideoNewUrl}
                width="100%"
                height="100%"
              />
            </div>
          </div>
        );
        formDropzoneNew = null;
        formDropzoneVideoLinkLabel = null;
        formDropzoneVideoNewLink = null;
      }

      if (
        this.state.dropzoneVideoOneUrl ||
        this.state.dropzoneVideoOneLink !== ""
      ) {
        formDropzoneApplyVideoOneButton = (
          <Button
            floated="right"
            color="blue"
            id="videoOne"
            onClick={this.handleDropzoneApply}
          >
            Apply
          </Button>
        );
      }

      if (
        this.state.dropzoneVideoTwoUrl ||
        this.state.dropzoneVideoTwoLink !== ""
      ) {
        formDropzoneApplyVideoTwoButton = (
          <Button
            floated="right"
            color="blue"
            id="videoTwo"
            onClick={this.handleDropzoneApply}
          >
            Apply
          </Button>
        );
      }

      if (
        this.state.dropzoneVideoThreeUrl ||
        this.state.dropzoneVideoThreeLink !== ""
      ) {
        formDropzoneApplyVideoThreeButton = (
          <Button
            floated="right"
            color="blue"
            id="videoThree"
            onClick={this.handleDropzoneApply}
          >
            Apply
          </Button>
        );
      }

      if (
        this.state.dropzoneVideoFourUrl ||
        this.state.dropzoneVideoFourLink !== ""
      ) {
        formDropzoneApplyVideoFourButton = (
          <Button
            floated="right"
            color="blue"
            id="videoFour"
            onClick={this.handleDropzoneApply}
          >
            Apply
          </Button>
        );
      }

      if (
        this.state.dropzoneVideoNewUrl ||
        this.state.dropzoneVideoNewLink !== ""
      ) {
        formDropzoneApplyVideoNewButton = (
          <Button
            floated="right"
            color="blue"
            id="videoNew"
            onClick={this.handleDropzoneApply}
          >
            Apply
          </Button>
        );
      }

      if (this.state.imageCropped) {
        if (this.state.croppedImageBlobUrl) {
          formThumbnail = (
            <img
              alt="Crop"
              style={{ maxWidth: "100%" }}
              src={this.state.croppedImageBlobUrl}
            />
          );
        }
        if (this.state.croppedImageOneBlobUrl) {
          formImageOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageOneBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageOne")}
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageTwoBlobUrl) {
          formImageTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageTwoBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageTwo")}
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageThreeBlobUrl) {
          formImageThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageThreeBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageThree")}
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageFourBlobUrl) {
          formImageFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageFourBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageFour")}
                />
              </div>
            </div>
          );
        }

        if (this.state.croppedImageFiveBlobUrl) {
          formImageFive = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageFiveBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageFive")}
                />
              </div>
            </div>
          );
        }

        if (this.state.newImageHighSchoolOne) {
          formImageHighSchoolOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.newImageHighSchoolOneUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolOne")}
                />
              </div>
            </div>
          );
        }
        if (this.state.newImageHighSchoolTwoUrl) {
          formImageHighSchoolTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.newImageHighSchoolTwoUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolTwo")}
                />
              </div>
            </div>
          );
        }
        if (this.state.newImageHighSchoolThreeUrl) {
          formImageHighSchoolThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.newImageHighSchoolThreeUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolThree")}
                />
              </div>
            </div>
          );
        }
        if (this.state.newImageHighSchoolFourUrl) {
          formImageHighSchoolFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.newImageHighSchoolFourUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolFour")}
                />
              </div>
            </div>
          );
        }
        if (this.state.newImageHighSchoolFiveUrl) {
          formImageHighSchoolFive = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.newImageHighSchoolFiveUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() => this.upload("imageHighSchoolFive")}
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageTranscriptBlobUrl) {
          formImageTranscript = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageTranscriptBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content="Transcript"
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="pencil"
                      onClick={() => this.upload("imageTranscript")}
                    />
                  }
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageSatBlobUrl) {
          formImageSat = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageSatBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content={"SAT"}
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="pencil"
                      onClick={() => this.upload("imageSat")}
                    />
                  }
                />
              </div>
            </div>
          );
        }
        if (this.state.croppedImageActBlobUrl) {
          formImageAct = (
            <div className="AdminFormImageContainer">
              <div className="AdminFormVerificationImageContainerImage">
                <img
                  alt="Crop"
                  style={{ maxWidth: "100%" }}
                  src={this.state.croppedImageActBlobUrl}
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Popup
                  content="ACT"
                  trigger={
                    <Button
                      floated="right"
                      size="tiny"
                      circular
                      icon="pencil"
                      onClick={() => this.upload("imageAct")}
                    />
                  }
                />
              </div>
            </div>
          );
        }

        if (this.state.newVideoOneUrl) {
          formVideoOne = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.state.newVideoOneUrl}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoOneOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video One Title"
                id="videoOneTitle"
                onChange={this.videoTitleChange}
              />
            </div>
          );
        }
        if (this.state.newVideoTwoUrl) {
          formVideoTwo = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.state.newVideoTwoUrl}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoTwoOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video Two Title"
                id="videoTwoTitle"
                onChange={this.videoTitleChange}
              />
            </div>
          );
        }
        if (this.state.newVideoThreeUrl) {
          formVideoThree = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.state.newVideoThreeUrl}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoThreeOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video Three Title"
                id="videoThreeTitle"
                onChange={this.videoTitleChange}
              />
            </div>
          );
        }
        if (this.state.newVideoFourUrl) {
          formVideoFour = (
            <div className="AdminFormImageContainer">
              <div className="AdminAthleteVideoCard">
                <ReactPlayer
                  controls={true}
                  className="react-player"
                  url={this.state.newVideoFourUrl}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="AdminFormImageContainerButton">
                <Button
                  floated="right"
                  size="tiny"
                  circular
                  icon="pencil"
                  onClick={() =>
                    this.setState({
                      cropImageVideoFourOpen: true,
                    })
                  }
                />
              </div>
              <Input
                fluid
                className="videoTitle"
                placeholder="Video Four Title"
                id="videoFourTitle"
                onChange={this.videoTitleChange}
              />
            </div>
          );
        }
      }

      if (this.props.athleteUpdating) {
        let progressNumber = Math.round(this.props.athleteUpdateProgress);
        progressLabel = (
          <div className="AdminProgressLabelContainer">
            <p>Updating {this.props.athleteUpdateProgressType}</p>
            <Progress
              percent={progressNumber}
              color="green"
              size="small"
              progress
            />
          </div>
        );
      } else {
        progressLabel = null;
      }

      if (
        this.state.changesMade &&
        !this.state.formError &&
        !this.state.athleteTriedToUpdate
      ) {
        saveButton = (
          <Button
            floated="right"
            positive
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={this.checkErrors}
          />
        );
      } else {
        if (this.state.formError) {
          saveButton = (
            <Button
              disabled
              floated="right"
              color="red"
              name="saveButton"
              content="Please Check Error(s)"
              labelPosition="right"
              icon="exclamation"
              onClick={this.checkErrors}
            />
          );
        } else {
          if (this.state.athleteTriedToUpdate) {
            saveButton = (
              <Button
                disabled
                loading
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          } else {
            saveButton = (
              <Button
                disabled
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          }
        }
      }

      if (
        this.state.changesMade &&
        !this.state.formError &&
        !this.state.athleteTriedToUpdate
      ) {
        eventsSaveButton = (
          <Button
            floated="right"
            positive
            name="saveButton"
            content="Save"
            labelPosition="right"
            icon="checkmark"
            onClick={this.checkErrors}
          />
        );
      } else {
        if (this.state.formError) {
          eventsSaveButton = (
            <Button
              disabled
              floated="right"
              color="red"
              name="saveButton"
              content="Event Requires Name and Date"
              labelPosition="right"
              icon="exclamation"
              onClick={this.checkErrors}
            />
          );
        } else {
          if (this.state.athleteTriedToUpdate) {
            eventsSaveButton = (
              <Button
                disabled
                loading
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          } else {
            eventsSaveButton = (
              <Button
                disabled
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={this.checkErrors}
              />
            );
          }
        }
      }

      const { athleteUpdated, athleteDeleted, athleteEventsUpdated } =
        this.props;
      if (this.state.seoPopup) {
        seoPopup = (
          // <TransitionablePortal
          //   transition={{ animation, duration }}
          //   open={seoPopup}
          //   onClose={() => {
          //     this.setState({ seoPopup: false });
          //   }}
          // >
          <Modal
            size="tiny"
            onClose={() => {
              this.setState({ seoPopup: false });
            }}
            open={true}
          >
            <Modal.Content>
              <AddNewSeo
                close={() => {
                  this.setState({ seoPopup: false });
                }}
                athleteUid={this.props.athlete.customUrl}
                athleteName={`${this.props.athlete.firstName} ${this.props.athlete.lastName}`}
              />
            </Modal.Content>
          </Modal>
          // {/* </TransitionablePortal> */}
        );
      }

      if (this.state.deletingAthlete) {
        if (athleteDeleted) {
          athleteProfileDeleted = (
            <TransitionablePortal
              transition={{ animation, duration }}
              open={athleteDeleted}
              onClose={this.handleDeleteExit}
            >
              <Modal onClose={this.handleDeleteExit} open={true}>
                <Modal.Content>
                  <div className="AdminProfileUpdatedContainer">
                    <h3>Athlete Archived!</h3>
                    <Button
                      color="blue"
                      name="okButton"
                      content="OK"
                      onClick={this.handleDeleteExit}
                    />
                  </div>
                </Modal.Content>
              </Modal>
            </TransitionablePortal>
          );
        } else {
          athleteProfileDeleted = (
            <div className="SpinnerBackground">
              <div className="SpinnerContainer">
                <Loader size="large" active inline="centered" />
              </div>
            </div>
          );
        }
      }

      if (this.state.athleteTriedToUpdate && athleteUpdated) {
        athleteProfileUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={athleteUpdated}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>Profile Updated!</h3>
                  <Button
                    positive
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.athleteTriedToUpdate && athleteEventsUpdated) {
        eventsAthleteUpdated = (
          <TransitionablePortal
            transition={{ animation, duration }}
            open={athleteEventsUpdated}
            onClose={this.handleExit}
          >
            <Modal onClose={this.handleExit} open={true}>
              <Modal.Content>
                <div className="AdminProfileUpdatedContainer">
                  <h3>Events Updated!</h3>
                  <Button
                    positive
                    name="okButton"
                    content="OK"
                    onClick={this.handleExit}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
        );
      }

      if (this.state.editProfileOpen) {
        athleteDetails = (
          <div className="AdminFormContainer">
            <Form>
              <div className="AdminAthleteDetailsThumbnailContainer">
                <input
                  value={""}
                  style={{ display: "none" }}
                  id={"thumbnail"}
                  type="file"
                  onChange={this.fileSelectedHandler}
                />
                <Button
                  floated="right"
                  name="editThumbnailButton"
                  content="Edit"
                  labelPosition="right"
                  icon="image"
                  onClick={() => this.upload("thumbnail")}
                />
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newThumbnailImage && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorConfig}
                              src={this.state.newThumbnailImageUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1}
                              onProcess={({ dest }) => this.processImage(dest)}
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                {formThumbnail}
              </div>
              <div className="AdminAthleteActionImagesContainer">
                <div className="AdminAthleteActionImagesTitleButtonContainer">
                  <h3>Photos</h3>
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageOne"}
                    type="file"
                    onChange={this.fileSelectedImageOneHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageTwo"}
                    type="file"
                    onChange={this.fileSelectedImageTwoHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageThree"}
                    type="file"
                    onChange={this.fileSelectedImageThreeHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageFour"}
                    type="file"
                    onChange={this.fileSelectedImageFourHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageFive"}
                    type="file"
                    onChange={this.fileSelectedImageFiveHandler}
                  />
                  {addImageButton}
                </div>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageOneOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newImageOne && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageOneConfig}
                              src={this.state.newImageOneUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1.5}
                              onProcess={({ dest }) =>
                                this.processImageOne(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageTwoOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newImageTwo && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageTwoConfig}
                              src={this.state.newImageTwoUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1.5}
                              onProcess={({ dest }) =>
                                this.processImageTwo(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageThreeOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newImageThree && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageThreeConfig}
                              src={this.state.newImageThreeUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1.5}
                              onProcess={({ dest }) =>
                                this.processImageThree(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageFourOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newImageFour && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageFourConfig}
                              src={this.state.newImageFourUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1.5}
                              onProcess={({ dest }) =>
                                this.processImageFour(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageFiveOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newImageFive && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageFiveConfig}
                              src={this.state.newImageFiveUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              imageCropAspectRatio={1.5}
                              onProcess={({ dest }) =>
                                this.processImageFive(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <div className="AdminAthleteActionImages">
                  {formImageOne}
                  {formImageTwo}
                  {formImageThree}
                  {formImageFour}
                  {formImageFive}
                </div>
              </div>
              <div className="AdminAthleteActionImagesContainer">
                <div className="AdminAthleteActionImagesTitleButtonContainer">
                  <h3>Video</h3>
                  {addVideoButton}
                </div>
                <div className="AdminAthleteVideosGroupContainer">
                  <TransitionablePortal
                    transition={{ animation, duration }}
                    open={this.state.cropImageVideoNewOpen}
                    onClose={() => this.handleEditVideoClose()}
                  >
                    <Modal
                      onClose={() => this.handleEditVideoClose()}
                      open={true}
                    >
                      <Modal.Content>
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditVideoClose()}
                            />
                            {formDropzoneApplyVideoNewButton}
                          </div>
                        </div>
                        <h3>Add Video File</h3>
                        {formDropzoneVideo}
                        {formDropzoneNew}
                        <div className="AdminDropzoneLinkContainer">
                          {formDropzoneVideoLinkLabel}
                          {formDropzoneVideoNewLink}
                        </div>
                      </Modal.Content>
                    </Modal>
                  </TransitionablePortal>
                  <TransitionablePortal
                    transition={{ animation, duration }}
                    open={this.state.cropImageVideoOneOpen}
                    onClose={() => this.handleEditVideoClose()}
                  >
                    <Modal
                      onClose={() => this.handleEditVideoClose()}
                      open={true}
                    >
                      <Modal.Content>
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditVideoClose()}
                            />
                            {formDropzoneApplyVideoOneButton}
                          </div>
                        </div>
                        <h3>Add Video File</h3>
                        {formDropzoneVideo}
                        {formDropzoneOne}
                        <div className="AdminDropzoneLinkContainer">
                          {formDropzoneVideoLinkLabel}
                          {formDropzoneVideoOneLink}
                        </div>
                      </Modal.Content>
                    </Modal>
                  </TransitionablePortal>
                  <TransitionablePortal
                    transition={{ animation, duration }}
                    open={this.state.cropImageVideoTwoOpen}
                    onClose={() => this.handleEditVideoClose()}
                  >
                    <Modal
                      onClose={() => this.handleEditVideoClose()}
                      open={true}
                    >
                      <Modal.Content>
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditVideoClose()}
                            />
                            {formDropzoneApplyVideoTwoButton}
                          </div>
                        </div>
                        <h3>Add Video File</h3>
                        {formDropzoneVideo}
                        {formDropzoneTwo}
                        <div className="AdminDropzoneLinkContainer">
                          {formDropzoneVideoLinkLabel}
                          {formDropzoneVideoTwoLink}
                        </div>
                      </Modal.Content>
                    </Modal>
                  </TransitionablePortal>
                  <TransitionablePortal
                    transition={{ animation, duration }}
                    open={this.state.cropImageVideoThreeOpen}
                    onClose={() => this.handleEditVideoClose()}
                  >
                    <Modal
                      onClose={() => this.handleEditVideoClose()}
                      open={true}
                    >
                      <Modal.Content>
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditVideoClose()}
                            />
                            {formDropzoneApplyVideoThreeButton}
                          </div>
                        </div>
                        <h3>Add Video File</h3>
                        {formDropzoneVideo}
                        {formDropzoneThree}
                        <div className="AdminDropzoneLinkContainer">
                          {formDropzoneVideoLinkLabel}
                          {formDropzoneVideoThreeLink}
                        </div>
                      </Modal.Content>
                    </Modal>
                  </TransitionablePortal>
                  <TransitionablePortal
                    transition={{ animation, duration }}
                    open={this.state.cropImageVideoFourOpen}
                    onClose={() => this.handleEditVideoClose()}
                  >
                    <Modal
                      onClose={() => this.handleEditVideoClose()}
                      open={true}
                    >
                      <Modal.Content>
                        <div className="AdminTopButtonsDropzoneContainer">
                          <div className="AdminTopButtonsContainer">
                            <Button
                              floated="left"
                              circular
                              icon="close"
                              onClick={() => this.handleEditVideoClose()}
                            />
                            {formDropzoneApplyVideoFourButton}
                          </div>
                        </div>
                        <h3>Add Video File</h3>
                        {formDropzoneVideo}
                        {formDropzoneFour}
                        <div className="AdminDropzoneLinkContainer">
                          {formDropzoneVideoLinkLabel}
                          {formDropzoneVideoFourLink}
                        </div>
                      </Modal.Content>
                    </Modal>
                  </TransitionablePortal>
                  {formVideoOne}
                  {formVideoTwo}
                  {formVideoThree}
                  {formVideoFour}
                </div>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Personal Information</h3>
                <Form.Field>
                  <label>First Name</label>
                  {formFirstName}
                </Form.Field>
                <Form.Field>
                  <label>Last Name</label>
                  {formLastName}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Hometown
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="i.e. Keller, TX"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formHometown}
                </Form.Field>
                <Form.Field>
                  <label>Grad Year</label>
                  {formClass}
                </Form.Field>
                <Form.Field>
                  <label>Status</label>
                  {formCommitted}
                </Form.Field>
                {formCommittedSchool}
                <Form.Field>
                  <label>Parent One - First Name</label>
                  {formParentOneFirst}
                </Form.Field>
                <Form.Field>
                  <label>Parent One - Last Name</label>
                  {formParentOneLast}
                </Form.Field>
                <Form.Field>
                  <label>Parent Two - First Name</label>
                  {formParentTwoFirst}
                </Form.Field>
                <Form.Field>
                  <label>Parent Two - Last Name</label>
                  {formParentTwoLast}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Athletic Information</h3>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Sport
                      {/* This Handles to show and hide the Add new Sport Modal */}
                      <AddNewSportIcon
                        onClick={this.handleShowNewSportFieldOpen} // it is on line number 1988
                      />
                    </div>
                  </label>
                  {formSport}
                </Form.Field>

                {this.state.showNewSportField && (
                  <AddNewSport onClose={this.handleShowNewSportFieldOpen} />
                )}

                <Form.Field>
                  {primaryPositionLabel}
                  {formPrimaryPosition}
                </Form.Field>
                {this.state.showNewPositionField && (
                  <AddNewPosition
                    onClose={this.handleShowNewPositionFieldOpen}
                  />
                )}
                <Form.Field>
                  {secondaryPositionLabel}
                  {formSecondaryPosition}
                </Form.Field>
                {(this.state.sport === "Softball" ||
                  this.state.sport === "Baseball") && (
                  <>
                    <Form.Field>
                      {batsLabel}
                      {formBats}
                    </Form.Field>
                    <Form.Field>
                      {throwsLabel}
                      {formThrows}
                    </Form.Field>
                  </>
                )}
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Specialty Metrics
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="i.e. 20 yard dash - 2.8 seconds"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formSpecialtyMetrics}
                </Form.Field>
                <Form.Field>
                  <label>Club Name</label>
                  {formClubName}
                </Form.Field>
                <Form.Field>
                  <label>Club Team Name</label>
                  {formClubTeamName}
                </Form.Field>
                <Form.Field>
                  <label>Club Team Jersey#</label>
                  {formJersey}
                </Form.Field>
                <Form.Field>
                  <label>Height</label>
                  {formHeight}
                </Form.Field>
                <Form.Field>
                  <label>Weight</label>
                  {formWeight}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      NCAA / NAIA#
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Visit the NCAA Eligibility Center at ncaa.org/ Once you register, you will receive a long number, input it here"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formNcaaId}
                </Form.Field>
              </div>
              {/* Contact Info */}
              <ContactInfo athId={this.props.id} data={this.props.contacts} />
              {/* HighSchool Schedule input */}
              <div className="AdminAthleteActionImagesContainer">
                <div className="AdminAthleteActionImagesTitleButtonContainer">
                  <h3>School Schedule</h3>
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageHighSchoolOne"}
                    type="file"
                    onChange={this.fileSelectedImageHighSchoolOneHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageHighSchoolTwo"}
                    type="file"
                    onChange={this.fileSelectedImageHighSchoolTwoHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageHighSchoolThree"}
                    type="file"
                    onChange={this.fileSelectedImageHighSchoolThreeHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageHighSchoolFour"}
                    type="file"
                    onChange={this.fileSelectedImageHighSchoolFourHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageHighSchoolFive"}
                    type="file"
                    onChange={this.fileSelectedImageHighSchoolFiveHandler}
                  />
                  {addImageHighSchoolButton}
                </div>
                <div className="AdminAthleteActionImages">
                  {formImageHighSchoolOne}
                  {formImageHighSchoolTwo}
                  {formImageHighSchoolThree}
                  {formImageHighSchoolFour}
                  {formImageHighSchoolFive}
                </div>
              </div>
              <StatsPhotos id={this.props.match.params.id} />

              <TransitionablePortal
                transition={{ animation, duration }}
                open={this.state.showHighSchoolScheduleOne}
                onClose={() => this.handleShowHighSchoolScheduleOneClose()}
              >
                {this.state.imageHighSchoolOne && (
                  <ImgsViewer
                    imgs={[
                      {
                        src: this.state.imageHighSchoolOne,
                        caption: "School Schedule One",
                      },
                    ]}
                    currImg={this.state.currImg}
                    isOpen={this.state.showHighSchoolScheduleOne}
                    onClickPrev={this.gotoPrevious}
                    onClickNext={this.gotoNext}
                    onClose={this.handleShowHighSchoolScheduleOneClose}
                    backdropCloseable={true}
                    enableKeyboardInput={true}
                  />
                )}
              </TransitionablePortal>
              <TransitionablePortal
                transition={{ animation, duration }}
                open={this.state.showHighSchoolScheduleTwo}
                onClose={() => this.handleShowHighSchoolScheduleTwoClose()}
              >
                <ImgsViewer
                  imgs={[
                    {
                      src: this.state.imageHighSchoolTwo,
                      caption: "School Schedule Two",
                    },
                  ]}
                  currImg={this.state.currImg}
                  isOpen={this.state.showHighSchoolScheduleTwo}
                  onClickPrev={this.gotoPrevious}
                  onClickNext={this.gotoNext}
                  onClose={this.handleShowHighSchoolScheduleTwoClose}
                  backdropCloseable={true}
                  enableKeyboardInput={true}
                />
              </TransitionablePortal>
              <TransitionablePortal
                transition={{ animation, duration }}
                open={this.state.showHighSchoolScheduleThree}
                onClose={() => this.handleShowHighSchoolScheduleThreeClose()}
              >
                <ImgsViewer
                  imgs={[
                    {
                      src: this.state.imageHighSchoolThree,
                      caption: "School Schedule Three",
                    },
                  ]}
                  currImg={this.state.currImg}
                  isOpen={this.state.showHighSchoolScheduleThree}
                  onClickPrev={this.gotoPrevious}
                  onClickNext={this.gotoNext}
                  onClose={this.handleShowHighSchoolScheduleThreeClose}
                  backdropCloseable={true}
                  enableKeyboardInput={true}
                />
              </TransitionablePortal>
              <TransitionablePortal
                transition={{ animation, duration }}
                open={this.state.showHighSchoolScheduleFour}
                onClose={() => this.handleShowHighSchoolScheduleFourClose()}
              >
                <ImgsViewer
                  imgs={[
                    {
                      src: this.state.imageHighSchoolFour,
                      caption: "School Schedule Four",
                    },
                  ]}
                  currImg={this.state.currImg}
                  isOpen={this.state.showHighSchoolScheduleFour}
                  onClickPrev={this.gotoPrevious}
                  onClickNext={this.gotoNext}
                  onClose={this.handleShowHighSchoolScheduleFourClose}
                  backdropCloseable={true}
                  enableKeyboardInput={true}
                />
              </TransitionablePortal>
              <TransitionablePortal
                transition={{ animation, duration }}
                open={this.state.showHighSchoolScheduleFive}
                onClose={() => this.handleShowHighSchoolScheduleFiveClose()}
              >
                <ImgsViewer
                  imgs={[
                    {
                      src: this.state.imageHighSchoolFive,
                      caption: "School Schedule Five",
                    },
                  ]}
                  currImg={this.state.currImg}
                  isOpen={this.state.showHighSchoolScheduleFive}
                  onClickPrev={this.gotoPrevious}
                  onClickNext={this.gotoNext}
                  onClose={this.handleShowHighSchoolScheduleFiveClose}
                  backdropCloseable={true}
                  enableKeyboardInput={true}
                />
              </TransitionablePortal>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Academic Information</h3>
                <Form.Field>
                  <label>GPA</label>
                  {formGpa}
                </Form.Field>
                <Form.Field>
                  <label>ACT</label>
                  {formAct}
                </Form.Field>
                <Form.Field>
                  <label>SAT</label>
                  {formSat}
                </Form.Field>
                <Form.Field>
                  <label>Class Rank</label>
                  {formClassRank}
                </Form.Field>
                <Form.Field>
                  <label>High School Name</label>
                  {formHighSchoolName}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      High School (City, State)
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="i.e. Keller, TX"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formHighSchoolCityState}
                </Form.Field>
                <Form.Field>
                  <label>Intended Major</label>
                  {formIntendedMajor}
                </Form.Field>
              </div>
              <div className="AdminAthleteVerificationImagesContainer">
                <div className="AdminAthleteVerificationImagesTitleButtonContainer">
                  <h3>Academic Verification</h3>
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id="imageTranscript"
                    type="file"
                    accept="image/* , .pdf"
                    onChange={this.fileSelectedImageTranscriptHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id="imageSat"
                    type="file"
                    accept="image/* , .pdf"
                    onChange={this.fileSelectedImageSatHandler}
                  />
                  <input
                    value={""}
                    style={{ display: "none" }}
                    id={"imageAct"}
                    type="file"
                    accept="image/* , .pdf"
                    onChange={this.fileSelectedImageActHandler}
                  />
                  <div className="AdminAthleteVerificationImagesButtonContainer">
                    {addTranscriptImageButton}
                    {addSatImageButton}
                    {addActImageButton}
                  </div>
                </div>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageTranscriptOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newTranscriptImage && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageTranscriptConfig}
                              src={this.state.newTranscriptImageUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              onProcess={({ dest }) =>
                                this.processImageTranscript(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageSatOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newSatScoreImage && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageSatConfig}
                              src={this.state.newSatScoreImageUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              onProcess={({ dest }) =>
                                this.processImageSat(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <TransitionablePortal
                  transition={{ animation, duration }}
                  open={this.state.cropImageActOpen}
                  onClose={() => this.handleEditImageClose()}
                >
                  <Modal
                    onClose={() => this.handleEditImageClose()}
                    open={true}
                  >
                    <div className="AdminEditImageContainer">
                      <Modal.Content>
                        {this.state.newActScoreImage && (
                          <div className="AdminImageEditorContainer">
                            <DokaImageEditor
                              {...editorImageActConfig}
                              src={this.state.newActScoreImageUrl}
                              enableButtonClose={true}
                              handleEvent={(type) =>
                                this.handleImageEvent(type)
                              }
                              onProcess={({ dest }) =>
                                this.processImageAct(dest)
                              }
                            />
                          </div>
                        )}
                      </Modal.Content>
                    </div>
                  </Modal>
                </TransitionablePortal>
                <div className="AdminAthleteVerificationImages">
                  {/* Transcript */}
                  {this.state.croppedImageTranscriptBlobUrl &&
                  this.state.transcriptImage &&
                  this.state.transcriptImage?.type === "application/pdf" &&
                  !isFileImage(this.state.transcriptImage) ? (
                    <div className="AdminFormImageContainer">
                      <div
                        className="AdminFormVerificationImageContainerImage box"
                        style={{ background: `url(${Dummy})` }}
                      />
                      <div className="AdminFormImageContainerButton">
                        <Popup
                          content={
                            "Transcript : " + this.state.transcriptImage?.name
                          }
                          trigger={
                            <Button
                              floated="right"
                              size="tiny"
                              circular
                              icon="eye"
                              onClick={() =>
                                openURL(
                                  this.state.croppedImageTranscriptBlobUrl
                                )
                              }
                            />
                          }
                        />

                        <Button
                          floated="right"
                          size="tiny"
                          circular
                          icon="pencil"
                          onClick={() => this.upload("imageTranscript")}
                        />
                      </div>
                    </div>
                  ) : (
                    formImageTranscript
                  )}
                  {/* SAT */}
                  {this.state.croppedImageSatBlobUrl &&
                  this.state.satScoreImage &&
                  this.state.satScoreImage?.type === "application/pdf" &&
                  !isFileImage(this.state.satScoreImage) ? (
                    <div className="AdminFormImageContainer">
                      <div
                        className="AdminFormVerificationImageContainerImage box"
                        style={{ background: `url(${Dummy})` }}
                      />
                      <div className="AdminFormImageContainerButton">
                        <Popup
                          content={"SAT : " + this.state.satScoreImage?.name}
                          trigger={
                            <Button
                              floated="right"
                              size="tiny"
                              circular
                              icon="eye"
                              onClick={() =>
                                openURL(this.state.croppedImageSatBlobUrl)
                              }
                            />
                          }
                        />

                        <Button
                          floated="right"
                          size="tiny"
                          circular
                          icon="pencil"
                          onClick={() => this.upload("imageSat")}
                        />
                      </div>
                    </div>
                  ) : (
                    formImageSat
                  )}
                  {/* ACT */}
                  {this.state.croppedImageActBlobUrl &&
                  this.state.actScoreImage &&
                  this.state.actScoreImage?.type === "application/pdf" &&
                  !isFileImage(this.state.actScoreImage) ? (
                    <div className="AdminFormImageContainer">
                      <div
                        className="AdminFormVerificationImageContainerImage box"
                        style={{ background: `url(${Dummy})` }}
                      />
                      <div className="AdminFormImageContainerButton">
                        <Popup
                          content={"ACT : " + this.state.actScoreImage?.name}
                          trigger={
                            <Button
                              floated="right"
                              size="tiny"
                              circular
                              icon="eye"
                              onClick={() =>
                                openURL(this.state.croppedImageActBlobUrl)
                              }
                            />
                          }
                        />

                        <Button
                          floated="right"
                          size="tiny"
                          circular
                          icon="pencil"
                          onClick={() => this.upload("imageAct")}
                        />
                      </div>
                    </div>
                  ) : (
                    formImageAct
                  )}
                </div>
              </div>
              <div className="AdminFormCalendarInfoContainer">
                <h3>Google Calendar Integration</h3>
                <div className="AdminFormCalendarGroupContainer">
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Gmail Address
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Calendar must be set to PUBLIC"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formAthleteCalendar}
                  </Form.Field>
                </div>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Coaching Information</h3>
                <div className="AdminFormCoachGroupContainer">
                  <Form.Field>
                    <label>Club Coach Name</label>
                    {formClubCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Club Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formClubCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>Club Coach Email</label>
                    {formClubCoachEmail}
                  </Form.Field>
                </div>
                <div className="AdminFormCoachGroupContainer">
                  <Form.Field>
                    <label>High School Coach Name</label>
                    {formHighSchoolCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        High School Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formHighSchoolCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>High School Coach Email</label>
                    {formHighSchoolCoachEmail}
                  </Form.Field>
                </div>
                <div className="AdminFormCoachGroupContainer">
                  <Form.Field>
                    <label>Hitting Coach Name</label>
                    {formHittingCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Hitting Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formHittingCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>Hitting Coach Email</label>
                    {formHittingCoachEmail}
                  </Form.Field>
                </div>
                <div className="AdminFormCoachGroupContainer">
                  <Form.Field>
                    <label>Pitching Coach Name</label>
                    {formPitchingCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Pitching Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formPitchingCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>Pitching Coach Email</label>
                    {formPitchingCoachEmail}
                  </Form.Field>
                </div>
                <div className="AdminFormCoachGroupContainer">
                  <Form.Field>
                    <label>Catching Coach Name</label>
                    {formCatchingCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Catching Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formCatchingCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>Catching Coach Email</label>
                    {formCatchingCoachEmail}
                  </Form.Field>
                </div>
                <div className="AdminFormCoachGroupLastContainer">
                  <Form.Field>
                    <label>Specialty Coach Name</label>
                    {formSpecialtyCoachName}
                  </Form.Field>
                  <Form.Field>
                    <label>Specialty Coach Focus</label>
                    {formSpecialtyCoachFocus}
                  </Form.Field>
                  <Form.Field>
                    <label>
                      <div className="AdminNcaaIdContainer">
                        Specialty Coach Phone
                        <div className="AdminQuestionIconContainer">
                          <Popup
                            content="Numbers only i.e. 9496339944"
                            trigger={<Icon name="question circle" />}
                          />
                        </div>
                      </div>
                    </label>
                    {formSpecialtyCoachPhone}
                  </Form.Field>
                  <Form.Field>
                    <label>Specialty Coach Email</label>
                    {formSpecialtyCoachEmail}
                  </Form.Field>
                </div>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Social Media</h3>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Twitter
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste full link i.e. https://twitter.com/CSA_Athletes"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formTwitter}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Instagram
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste full link i.e. https://www.instagram.com/collegiate_sports_advocate"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formInstagram}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Facebook
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste full link i.e. https://www.facebook.com/collegiatesportsadvocate/"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formFacebook}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      You Tube
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste full link i.e. https://www.youtube.com"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formYouTube}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Athlete's Go Live
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste AGL code i.e. AGL001234"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formAgl}
                </Form.Field>
                <Form.Field>
                  <label>
                    <div className="AdminNcaaIdContainer">
                      Hudl
                      <div className="AdminQuestionIconContainer">
                        <Popup
                          content="Paste full link i.e. https://www.hudl.com/"
                          trigger={<Icon name="question circle" />}
                        />
                      </div>
                    </div>
                  </label>
                  {formHudl}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Academic Honors</h3>
                <Form.Field>
                  <label>Academic Honor One</label>
                  {formAcademicHonorOne}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Two</label>
                  {formAcademicHonorTwo}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Three</label>
                  {formAcademicHonorThree}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Four</label>
                  {formAcademicHonorFour}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Five</label>
                  {formAcademicHonorFive}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Six</label>
                  {formAcademicHonorSix}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Seven</label>
                  {formAcademicHonorSeven}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Eight</label>
                  {formAcademicHonorEight}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Nine</label>
                  {formAcademicHonorNine}
                </Form.Field>
                <Form.Field>
                  <label>Academic Honor Ten</label>
                  {formAcademicHonorTen}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Athletic Awards</h3>
                <Form.Field>
                  <label>Athletic Award One</label>
                  {formAthleticAwardOne}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Two</label>
                  {formAthleticAwardTwo}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Three</label>
                  {formAthleticAwardThree}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Four</label>
                  {formAthleticAwardFour}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Five</label>
                  {formAthleticAwardFive}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Six</label>
                  {formAthleticAwardSix}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Seven</label>
                  {formAthleticAwardSeven}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Eight</label>
                  {formAthleticAwardEight}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Nine</label>
                  {formAthleticAwardNine}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Award Ten</label>
                  {formAthleticAwardTen}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Athletic Strengths</h3>
                <Form.Field>
                  <label>Athletic Strength One</label>
                  {formAthleticStrengthOne}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Strength Two</label>
                  {formAthleticStrengthTwo}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Strength Three</label>
                  {formAthleticStrengthThree}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Strength Four</label>
                  {formAthleticStrengthFour}
                </Form.Field>
                <Form.Field>
                  <label>Athletic Strength Five</label>
                  {formAthleticStrengthFive}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Extracurricular</h3>
                <Form.Field>
                  <label>Extracurricular One</label>
                  {formAthleticExtraOne}
                </Form.Field>
                <Form.Field>
                  <label>Extracurricular Two</label>
                  {formAthleticExtraTwo}
                </Form.Field>
                <Form.Field>
                  <label>Extracurricular Three</label>
                  {formAthleticExtraThree}
                </Form.Field>
                <Form.Field>
                  <label>Extracurricular Four</label>
                  {formAthleticExtraFour}
                </Form.Field>
                <Form.Field>
                  <label>Extracurricular Five</label>
                  {formAthleticExtraFive}
                </Form.Field>
              </div>
              <div className="AdminFormPersonalInfoContainer">
                <h3>Hobbies</h3>
                <Form.Field>
                  <label>Hobby One</label>
                  {formAthleticHobbyOne}
                </Form.Field>
                <Form.Field>
                  <label>Hobby Two</label>
                  {formAthleticHobbyTwo}
                </Form.Field>
                <Form.Field>
                  <label>Hobby Three</label>
                  {formAthleticHobbyThree}
                </Form.Field>
                <Form.Field>
                  <label>Hobby Four</label>
                  {formAthleticHobbyFour}
                </Form.Field>
                <Form.Field>
                  <label>Hobby Five</label>
                  {formAthleticHobbyFive}
                </Form.Field>
              </div>
              {athleteProfileUpdated}
            </Form>
          </div>
        );
      } else {
        athleteDetails = <AthleteDetails adminId={auth.uid} />;
      }

      if (this.state.manageEvents) {
        manageEvents = (
          <div className="AdminFormContainer">
            <Form>
              <div className="AdminFormEventContainer">
                <h3>Events</h3>
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventOneName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventOneUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventOneDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateOneChange}
                  />
                </Form.Field>
              </div>
              <div className="AdminFormEventContainer">
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventTwoName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventTwoUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventTwoDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateTwoChange}
                  />
                </Form.Field>
              </div>
              <div className="AdminFormEventContainer">
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventThreeName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventThreeUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventThreeDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateThreeChange}
                  />
                </Form.Field>
              </div>
              <div className="AdminFormEventContainer">
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventFourName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventFourUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventFourDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateFourChange}
                  />
                </Form.Field>
              </div>
              <div className="AdminFormEventContainer">
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventFiveName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventFiveUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventFiveDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateFiveChange}
                  />
                </Form.Field>
              </div>
              <div className="AdminFormEventContainer">
                <Form.Field required>
                  <label>Event Name</label>
                  {formEventSixName}
                </Form.Field>
                <Form.Field>
                  <label>Event URL</label>
                  {formEventSixUrl}
                </Form.Field>
                <Form.Field required>
                  <label>Event Date</label>
                  <DatePicker
                    selected={this.state.eventSixDate}
                    placeholderText="Select Date"
                    showPopperArrow={false}
                    onChange={this.onDateSixChange}
                  />
                </Form.Field>
              </div>
              {eventsAthleteUpdated}
            </Form>
          </div>
        );
      }

      return (
        <>
          <div className="AdminAthleteDetailsBackground">
            <div className="AdminAthleteDetailsBannerBar"></div>
            <div className="AdminEditProfileButtonContainer">
              {/* {seoButton} */}
              {deleteAthleteButton}
              {reminders}
              {/* Pankaj Bhai Here .*/}
              {this.state.remindersModal && (
                <PublicModal
                  id={this.props.match.params.id}
                  open={this.state.remindersModal}
                  close={() => this.setState({ remindersModal: false })}
                />
              )}
              {eventsPage}
              {wikiPage}
              {/* <Link to={`/admin/${this.props.auth.uid}/events`}>
              <Button icon labelPosition="left" color="blue">
                <Icon name="list" />
                Events
              </Button>
            </Link> */}
              {/* <Button
              icon
              labelPosition="left"
              positive
              name="eventButton"
              onClick={this.handleClick}
            >
              <Icon name="calendar" />
              Edit Events
            </Button> */}
              <Button
                icon
                labelPosition="left"
                color="blue"
                name="profileButton"
                onClick={this.handleClick}
              >
                <Icon name="user" />
                Edit Profile
              </Button>
            </div>
            <Confirm
              open={this.state.confirmDelete}
              content={
                "Are you sure you want to ARCHIVE " +
                this.props.athlete.firstName +
                " " +
                this.props.athlete.lastName +
                "?"
              }
              confirmButton="ARCHIVE"
              onCancel={this.confirmDeleteCancel}
              onConfirm={this.confirmDelete}
            />
            {athleteProfileDeleted}

            <Modal
              onClose={() => this.handleClose()}
              open={this.state.editProfileOpen}
            >
              <Modal.Content
                scrolling
                className={
                  this.state.showNewSportField ||
                  this.state.showNewPositionField
                    ? "active"
                    : ""
                }
              >
                <div className="AdminTopButtonsProgressContainer">
                  <div className="AdminTopButtonsContainer">
                    <Button
                      floated="left"
                      circular
                      icon="close"
                      onClick={() => this.handleClose()}
                    />
                    {saveButton}
                  </div>
                  <div className="AdminProgressContainer">{progressLabel}</div>
                </div>
                {athleteDetails}
                <div className="AdminSaveButtonContainer">
                  <div className="AdminProgressContainer">{progressLabel}</div>
                  {saveButton}
                </div>
                <Confirm
                  open={this.state.confirmOpen}
                  content="You have unsaved changes.  Are you sure you want to exit?"
                  onCancel={this.confirmCloseCancel}
                  onConfirm={this.confirmClose}
                />
              </Modal.Content>
            </Modal>

            {/* {seoPopup} */}
            <TransitionablePortal
              transition={{ animation, duration }}
              open={this.state.manageEvents}
              onClose={() => this.handleEventsClose()}
            >
              <Modal onClose={() => this.handleEventsClose()} open={true}>
                <Modal.Content scrolling>
                  <div className="AdminTopButtonsProgressContainer">
                    <div className="AdminTopButtonsContainer">
                      <Button
                        floated="left"
                        circular
                        icon="close"
                        onClick={() => this.handleEventsClose()}
                      />
                      {eventsSaveButton}
                    </div>
                    <div className="AdminProgressContainer">
                      {progressLabel}
                    </div>
                  </div>
                  {manageEvents}
                  <div className="AdminSaveButtonContainer">
                    <div className="AdminProgressContainer">
                      {progressLabel}
                    </div>
                    {eventsSaveButton}
                  </div>
                  <Confirm
                    open={this.state.confirmOpen}
                    content="You have unsaved changes.  Are you sure you want to exit?"
                    onCancel={this.confirmCloseCancel}
                    onConfirm={this.confirmClose}
                  />
                </Modal.Content>
              </Modal>
            </TransitionablePortal>
            <div className="AdminAthleteDetailsGroupContainer">
              <AthleteDetails adminId={this.props.athlete.customUrl} />
            </div>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  let uid;
  let role;
  let advocateKey = null;
  let newUserKey = null;
  var id = null;
  var athlete = null;
  id = ownProps.match.params.id;
  const athletes = state.firestore.data.adminAthletes;
  const idArray = athletes
    ? Object.keys(state.firestore.data.adminAthletes)
    : null;
  const customUrlArray = idArray
    ? idArray.map((id) => {
        return athletes[id].customUrl;
      })
    : null;
  athlete = athletes ? athletes[id] : null;

  if (
    state.firebase.auth &&
    state.firestore.data.userRole &&
    state.firestore.data.advocates
  ) {
    uid = state.firebase.auth.uid;
    const keys = Object.keys(state.firestore.data.userRole);
    keys.forEach((key) => {
      if (state.firestore.data.userRole[key]?.userUID === uid) {
        role = state.firestore.data.userRole[key].role;
        if (role === "newUser") {
          newUserKey = uid;
        } else if (role === "advocate") {
          advocateKey = state.firestore.data.advocates[key].id;
        }
      }
    });
  }

  let contacts = {};
  const contactsData = state.firestore.data.athleteContacts;
  if (contactsData && Object.keys(contactsData).length > 0) {
    if (contactsData[id]) {
      contacts = contactsData[id];
    }
  }

  return {
    contacts,
    auth: state.firebase.auth,
    id,
    role,
    advocateKey,
    newUserKey,
    athlete: athlete,
    adminCoachList: state.firestore.data.adminCoachList,
    adminSocialList: state.firestore.data.adminSocialList,
    adminAwardsList: state.firestore.data.adminAwardsList,
    adminExtrasList: state.firestore.data.adminExtrasList,
    adminImagesList: state.firestore.data.adminImagesList,
    adminVideoList: state.firestore.data.adminVideoList,
    adminSportsList: state.firestore.data.adminSportsList,
    updateAthleteError: state.athlete.updateAthleteError,
    athleteUpdated: state.athlete.athleteUpdated,
    athleteUpdateProgress: state.athlete.athleteUpdateProgress,
    athleteUpdateProgressType: state.athlete.athleteUpdateProgressType,
    athleteUpdating: state.athlete.athleteUpdating,

    superAdmin: state.auth.superAdmin,
    athleteDeleted: state.athlete.athleteDeleted,
    athleteDeletedError: state.athlete.deleteAthleteError,

    adminEventsList: state.firestore.data.adminEventsList,
    updateAthleteEventsError: state.athlete.updateAthleteEventsError,
    athleteEventsUpdated: state.athlete.athleteEventsUpdated,

    adminSchoolsList: state.firestore.ordered.adminSchoolsList,
    adminSchoolsIdList: state.firestore.data.adminSchoolsIdList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateAthlete: (athleteInfo, athleteId) =>
      dispatch(updateAthlete(athleteInfo, athleteId)),
    deleteAthlete: (athleteId) => dispatch(deleteAthlete(athleteId)),
    resetAthlete: () => dispatch(resetAthlete()),
    clearData: () => dispatch({ type: actionTypes.CLEAR_DATA }),

    updateAthleteEvents: (athleteInfo, athleteId) =>
      dispatch(updateAthleteEvents(athleteInfo, athleteId)),
  };
};
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "adminAthletes",
    },
    {
      collection: "athleteContacts",
    },
    {
      collection: "userRole",
    },
    {
      collection: "advocates",
    },
    {
      collection: "testNewRequests",
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "coaches" }],
      storeAs: adminReduxCoachList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "socialMedia" }],
      storeAs: adminReduxSocialList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "awardsHonors" }],
      storeAs: adminReduxAwardsList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "extras" }],
      storeAs: adminReduxExtrasList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "images" }],
      storeAs: adminReduxImagesList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "video" }],
      storeAs: adminReduxVideoList,
    },
    {
      collection: "adminAthletes",
      doc: props.match.params.id,
      subcollections: [{ collection: "profile", doc: "events" }],
      storeAs: adminReduxEventsList,
    },
    {
      collection: "schools",
      orderBy: ["name", "asc"],
      storeAs: adminReduxSchoolsList,
    },
    {
      collection: "schools",
      orderBy: ["name", "asc"],
      storeAs: adminReduxSchoolsIdList,
    },
    {
      collection: "sports",
      storeAs: adminReduxSportsList,
    },
  ])
)(Admin);
